import geodesic from "./geodesic.js";
import Util from "./util";
import { RepositoryFactory } from "./../repository/RepositoryFactory";

/** Repository */
const TelemeterRepository = RepositoryFactory.get("telemeter");
const TelemeterJsonRepository = RepositoryFactory.get("telemeterJson");


/**
 * 共通(個別観測所)
 */
export default {
  convertSelectedObsRain,
  convertSelectedObsBsn,
  convertSelectedObsSnow,
  convertSelectedObsStage,
  convertSelectedObsWtrQual,
  convertSelectedObsRdBsn,
  convertSelectedObsDam,
  convertSelectedObsCoast,
  convertSelectedObsCctv,
  convertSelectedObsScam,
  convertObsRain,
  convertObsBsn,
  convertObsSnow,
  convertObsStage,
  convertObsWtrQual,
  convertObsDam,
  convertObsCoast,
  convertObsRdBsn,
  convertObsCctv,
  convertObsScam,
  getXsecArr,
  getXsecPresent,
  getXsecCross,
  getXsecSpecialCross,
  getSwXsecSpecialCross,
  getXsecRiverInfo,
  getSwXsecRiverInfo,
  hasLatestUrl,
  hasUsualUrl,
  hasCctvInfo,
  hasXsec,
  hasZeroHighFix,
  formatWndDir,
  checkCcd,
  getTargetPredStgData,
  getCrntPredTime,
  formatFloat,
  formatLatLon,
  formatDateNonNull,
  valueCeil,
  roundUpValue,
  getCopyHeader,
  convertRelatObsValue,
  convertRelatDataList,
  extractImageName,
  obsAppTimeArray,
  replaceJpgWithJson,
  updateLatestScamTime,
  roundTimeToInterval,
  getUrl,
  getDetailJson,
  convertTimestampToDateString,
  setArrayTimeData,
  getBaseTime
};

/** 雨量グラフ10分上限値 */
// const rainGraphMin10Max = 200;
/** 雨量グラフ10分間隔 */
// const rainGraphMin10MaxAdd = 10;
/** 雨量グラフ10分下限値 */
const rainGraphMin10Min = 0;
/** 雨量グラフ時間上限値 */
// const rainGraphHourMax = 400;
/** 雨量グラフ時間間隔 */
// const rainGraphHourMaxAdd = 10;
/** 雨量グラフ時間下限値 */
const rainGraphHourMin = 0;
/** 雨量グラフ累加 時間上限値 */
// const rainGraphTotalMax = 2000;
/** 雨量グラフ累加 時間間隔 */
// const rainGraphTotalMaxAdd = 20;
/** 雨量グラフ累加 時間下限値 */
const rainGraphTotalMin = 0;

/** レーダ流域平均グラフ10分上限値 */
const rdBsnGraphMin10Max = 200;
/** レーダ流域平均グラフ10分間隔 */
const rdBsnGraphMin10MaxAdd = 10;
/** レーダ流域平均グラフ10分下限値 */
const rdBsnGraphMin10Min = 0;
/** レーダ流域平均グラフ時間上限値 */
const rdBsnGraphHourMax = 400;
/** レーダ流域平均グラフ時間間隔 */
const rdBsnGraphHourMaxAdd = 10;
/** レーダ流域平均グラフ時間下限値 */
const rdBsnGraphHourMin = 0;
/** レーダ流域平均グラフ累加 時間上限値 */
const rdBsnGraphTotalMax = 2000;
/** レーダ流域平均グラフ累加 時間間隔 */
const rdBsnGraphTotalMaxAdd = 20;
/** レーダ流域平均グラフ累加 時間下限値 */
const rdBsnGraphTotalMin = 0;

/** 流域平均グラフ10分上限値 */
// const bsnGraphMin10Max = 200;
/** 流域平均グラフ10分間隔 */
// const bsnGraphMin10MaxAdd = 10;
/** 流域平均グラフ10分下限値 */
const bsnGraphMin10Min = 0;
/** 流域平均グラフ時間上限値 */
// const bsnGraphHourMax = 400;
/** 流域平均グラフ時間間隔 */
// const bsnGraphHourMaxAdd = 10;
/** 流域平均グラフ時間下限値 */
const bsnGraphHourMin = 0;
/** 流域平均グラフ累加 時間上限値 */
// const bsnGraphTotalMax = 2000;
/** 流域平均グラフ累加 時間間隔 */
// const bsnGraphTotalMaxAdd = 20;
/** 流域平均グラフ累加 時間下限値 */
const bsnGraphTotalMin = 0;

/** ダムグラフ貯水位10分間隔 */
// const damStorGraphMin10MaxAdd = 1;
/** ダムグラフ貯水位10分間隔 */
// const damStorGraphMin10MinAdd = 1;
/** ダムグラフ貯水位時間間隔 */
// const damStorGraphHourMaxAdd = 1;
/** ダムグラフ貯水位時間間隔 */
// const damStorGraphHourMinAdd = 1;
/** ダムグラフ全流入量・全放流量10分間隔 */
// const damAllGraphMin10MaxAdd = 10;
/** ダムグラフ全流入量・全放流量10分間隔 */
// const damAllGraphMin10MinAdd = 10;
/** ダムグラフ全流入量・全放流量時間間隔 */
// const damAllGraphHourMaxAdd = 10;
/** ダムグラフ全流入量・全放流量時間間隔 */
// const damAllGraphHourMinAdd = 10;

/** ダムグラフ雨量10分上限値 */
// const damRainGraphMin10Max = 200;
/** ダムグラフ雨量10分間隔 */
// const damRainGraphMin10MaxAdd = 10;
/** ダムグラフ雨量10分下限値 */
const damRainGraphMin10Min = 0;
/** ダムグラフ雨量時間上限値 */
// const damRainGraphHourMax = 400;
/** ダムグラフ雨量時間間隔 */
// const damRainGraphHourMaxAdd = 10;
/** ダムグラフ雨量時間下限値 */
const damRainGraphHourMin = 0;
/** ダムグラフ雨量累加 時間上限値 */
// const damRainGraphTotalMax = 2000;
/** ダムグラフ雨量累加 時間間隔 */
// const damRainGraphTotalMaxAdd = 20;
/** ダムグラフ雨量累加 時間下限値 */
const damRainGraphTotalMin = 0;

/** 積雪深グラフ[積雪深]上限値 */
// const snowGraphMax = 2000;
/** 積雪深グラフ[積雪深]間隔 */
// const snowGraphAdd = 20;
/** 積雪深グラフ[積雪深]上限値(閉局、または欠測、またはデータなしの場合) */
// const snowGraphClosingMax = 10;
/** 積雪深グラフ[積雪深]下限値 */
const snowGraphMin = 0;
/** 積雪深グラフ[気温]上限値 */
// const snowGraphTmpMax = 60;
/** 積雪深グラフ[気温]間隔 */
// const snowGraphTmpAdd = 5;
/** 積雪深グラフ[気温]上限値(閉局、または欠測、またはデータなしの場合) */
// const snowGraphTmpClosingMax = 5.0;
/** 積雪深グラフ[気温]下限値 */
// const snowGraphTmpMin = -50;
/** 積雪深グラフ[気温]下限値(閉局、または欠測、またはデータなしの場合) */
// const snowGraphTmpClosingMin = 0.0;
/** 積雪深グラフ[気温]上限値～下限値の最小 */
// const snowGraphTmpSpanMax = 40.0;
/** 積雪深グラフ[気温]上限値～下限値の最小 */
// const snowGraphTmpInt = 20.0;

/** 水位グラフ10分上限値 */
// const stageGraphMin10Max = 200;
/** 水位グラフ10分間隔 */
// const stageGraphMin10MaxAdd = 10;
/** 水位グラフ10分下限値 */
const stageGraphMin10Min = 0;
/** 水位グラフ時間上限値 */
// const stageGraphHourMax = 400;
/** 水位グラフ時間間隔 */
// const stageGraphHourMaxAdd = 10;
/** 水位グラフ時間下限値 */
const stageGraphHourMin = 0;
/** 水位グラフ累加 時間上限値 */
// const stageGraphTotalMax = 2000;
/** 水位グラフ累加 時間間隔 */
// const stageGraphTotalMaxAdd = 20;
/** 水位グラフ累加 時間下限値 */
const stageGraphTotalMin = 0;

/** 海岸グラフ風速 上限値 */
// const coastGraphWndspdMax = 200;
/** 海岸グラフ風速 間隔 */
// const coastGraphWndspdMaxAdd = 10;
/** 海岸グラフ風速 下限値 */
const coastGraphWndspdMin = 0;
/** 海岸グラフ潮位・波高 上限値 */
// const coastGraphTideMax = 500;
/** 海岸グラフ潮位・波高 間隔 */
// const coastGraphTideMaxAdd = 5;
/** 海岸グラフ潮位・波高 下限値 */
// const coastGraphTideMin = -2;
/** 海岸グラフ潮位・波高 下限減算値 */
// const coastGraphTideMinAdd = 1;
/** 海岸グラフ潮位・波高 下限間隔 */
// const coastGraphTideMinInterval = 5;
/** 海岸グラフ波高 下限値 */
// const coastGraphWaveMin = 0;
/** 海岸グラフ周期 上限値 */
// const coastGraphCycleMax = 90;
/** 海岸グラフ周期 間隔 */
// const coastGraphCycleMaxAdd = 1;
/** 海岸グラフ周期 下限値 */
// const coastGraphCycleMin = 0;
/** 海岸グラフ周期 下限間隔 */
// const coastGraphCycleMinAdd = 1;

/** 水質グラフ水温 上限値・下限値設定 */
// const wtrQualGraphConf = {
//   wtrtmp: {
//     max: 100,
//     maxAdd: 5,
//     min: -10,
//     minAdd: 5,
//     ceil: 1,
//   },
//   ph: {
//     max: 14.0,
//     maxAdd: 0.5,
//     min: 0.0,
//     minAdd: 0.5,
//     ceil: 0.01,
//   },
//   dox: {
//     max: 150.0,
//     maxAdd: 5.0,
//     min: 0.0,
//     minAdd: 5.0,
//     ceil: 0.01,
//   },
//   conduct: {
//     max: 50000,
//     maxAdd: 50,
//     min: 0,
//     minAdd: 50,
//     ceil: 1,
//   },
//   turbdty: {
//     max: 2000,
//     maxAdd: 20,
//     min: 0,
//     minAdd: 20,
//     ceil: 1,
//   },
//   amn: {
//     max: 100.0,
//     maxAdd: 2.0,
//     min: 0.0,
//     minAdd: 2.0,
//     ceil: 0.01,
//   },
//   slt: {
//     max: 100000,
//     maxAdd: 500,
//     min: 0,
//     minAdd: 500,
//     ceil: 1,
//   },
//   cod: {
//     max: 500,
//     maxAdd: 10,
//     min: 0,
//     minAdd: 10,
//     ceil: 1,
//   },
// };

// 内容コード : 閉局（休止中）
const CCD_CLOSING = 140;

// 内容コード : 欠測
const CCD_MISSING = 190;

// 内容コード無効時の表示文字列
const invalidStr = "-- ";

// 内容コード無効時の観測値
const invalidVal = null;

// 事務所コード表示用の共通タイトル
const codeParamHead = "  (事務所コード:";
const codeParamTail = ")";

// 関連観測所コード表示用の共通タイトル
const codeParamHeadLinkObs = "  (観測所コード：";
const codeParamTailLinkObs = ")";

// 未収集 : 内容コード
const NOT_COLLECTED = 160;

//------------------------------------------------------------
/**
 * [雨量観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo 雨量観測所情報
 * @param {*} tmData 最新雨量観測値情報
 * @param {*} min10DataList [グラフ用]10分単位の雨量観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の雨量観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsRain(
  obsInfo,
  tmData,
  min10DataList,
  hrDataList,
  appTime
) {
  let min10RnList = null;
  let hrRnList = null;

  // グラフデータ生成
  // 10分単位
  min10RnList = getMin10HrDataRain(min10DataList);

  // 時間単位
  hrRnList = getMin10HrDataRain(hrDataList);

  // 雨量観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmRainDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsKana: obsInfo.obsKana,
        obsNmS: obsInfo.obsNmS,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        alti: obsInfo.alti,
        rn10mCaut: obsInfo.rn10mCaut,
        rn10mWarn: obsInfo.rn10mWarn,
        rnHrCaut: obsInfo.rnHrCaut,
        rnHrWarn: obsInfo.rnHrWarn,
        rnIncCaut: obsInfo.rnIncCaut,
        rnIncWarn: obsInfo.rnIncWarn,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        rn10m: tmData != null ? tmData.rn10m : null,
        rn10mCcd: tmData != null ? tmData.rn10mCcd : NOT_COLLECTED,
        rn10mCautOvflg: tmData != null ? tmData.rn10mCautOvflg : null,
        rn10mWarnOvflg: tmData != null ? tmData.rn10mWarnOvflg : null,
        rnInc: tmData != null ? tmData.rnInc : null,
        rnIncCcd: tmData != null ? tmData.rnIncCcd : NOT_COLLECTED,
        rnIncCautOvflg: tmData != null ? tmData.rnIncCautOvflg : null,
        rnIncWarnOvflg: tmData != null ? tmData.rnIncWarnOvflg : null,
        rnHr10m: tmData != null ? tmData.rnHr10m : null,
        rnHr10mCcd: tmData != null ? tmData.rnHr10mCcd : NOT_COLLECTED,
        rnHr10mCautOvflg: tmData != null ? tmData.rnHr10mCautOvflg : null,
        rnHr10mWarnOvflg: tmData != null ? tmData.rnHr10mWarnOvflg : null,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmRainDetailObs: {
        rn10mList: min10RnList.rnList,
        rn10mIncList: min10RnList.rnIncList,
        rnHrList: hrRnList.rnList,
        rnHrIncList: hrRnList.rnIncList,
      },
    },
  };
  return tmObsResult;
}

/**
 * [流域平均観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo 流域平均観測所情報
 * @param {*} tmData 最新流域平均観測値情報
 * @param {*} min10DataList [グラフ用]10分単位の流域平均観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の流域平均観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsBsn(
  obsInfo,
  tmData,
  min10DataList,
  hrDataList,
  appTime
) {
  let min10BsnList = null;
  let hrBsnList = null;

  // グラフデータ生成
  // 10分単位
  min10BsnList = getMin10HrDataBsn(min10DataList);

  // 時間単位
  hrBsnList = getMin10HrDataBsn(hrDataList);

  // 流域平均観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmBsnDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsKana: obsInfo.obsKana,
        obsNmS: obsInfo.obsNmS,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        bsnArea: obsInfo.bsnArea,
        rn10mCaut: obsInfo.rn10mCaut,
        rn10mWarn: obsInfo.rn10mWarn,
        rnHrCaut: obsInfo.rnHrCaut,
        rnHrWarn: obsInfo.rnHrWarn,
        rnIncCaut: obsInfo.rnIncCaut,
        rnIncWarn: obsInfo.rnIncWarn,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        bsnrn10m: tmData != null ? tmData.bsnrn10m : null,
        bsnrn10mCcd: tmData != null ? tmData.bsnrn10mCcd : NOT_COLLECTED,
        bsnrn10mCautOvflg: tmData != null ? tmData.bsnrn10mCautOvflg : null,
        bsnrn10mWarnOvflg: tmData != null ? tmData.bsnrn10mWarnOvflg : null,
        bsnrnInc: tmData != null ? tmData.bsnrnInc : null,
        bsnrnIncCcd: tmData != null ? tmData.bsnrnIncCcd : NOT_COLLECTED,
        bsnrnIncCautOvflg: tmData != null ? tmData.bsnrnIncCautOvflg : null,
        bsnrnIncWarnOvflg: tmData != null ? tmData.bsnrnIncWarnOvflg : null,
        bsnrnHr10m: tmData != null ? tmData.bsnrnHr10m : null,
        bsnrnHr10mCcd: tmData != null ? tmData.bsnrnHr10mCcd : NOT_COLLECTED,
        bsnrnHr10mCautOvflg: tmData != null ? tmData.bsnrnHr10mCautOvflg : null,
        bsnrnHr10mWarnOvflg: tmData != null ? tmData.bsnrnHr10mWarnOvflg : null,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmBsnDetailObs: {
        bsnrn10mList: min10BsnList.bsnList,
        bsnrn10mIncList: min10BsnList.bsnIncList,
        bsnrnHrList: hrBsnList.bsnList,
        bsnrnHrIncList: hrBsnList.bsnIncList,
      },
    },
  };
  return tmObsResult;
}

/**
 * [積雪観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo 積雪観測所情報
 * @param {*} tmData 最新積雪観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の積雪観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsSnow(obsInfo, tmData, hrDataList, appTime) {
  // 積雪観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmSnwDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsNmS: obsInfo.obsNmS,
        obsKana: obsInfo.obsKana,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        alti: obsInfo.alti,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        snwdp: tmData != null ? tmData.snwdp : null,
        snwdpCcd: tmData != null ? tmData.snwdpCcd : NOT_COLLECTED,
        tmp: tmData != null ? tmData.tmp : null,
        tmpCcd: tmData != null ? tmData.tmpCcd : NOT_COLLECTED,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmSnwDetailObs: {
        snwList: hrDataList != null ? hrDataList : [],
      },
    },
  };
  return tmObsResult;
}

/**
 * [水位観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsData 水位観測所情報(観測所情報・横断情報・横断断面情報)
 * @param {*} tmData 最新水位観測値情報
 * @param {*} upStgObsInfo 上流水位観測所情報
 * @param {*} upStgTmData 最新上流水位観測値情報
 * @param {*} dwStgObsInfo 下流水位観測所情報
 * @param {*} dwStgTmData 最新下流水位観測値情報
 * @param {*} reprnObsInfo 関連雨量観測所情報
 * @param {*} reprnTmData 最新関連雨量観測値情報
 * @param {*} min10DataList [グラフ用]10分単位の水位観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の水位観測値情報
 * @param {*} predStgList [グラフ用]予測水位リスト
 * @param {*} reprnMin10DataList [グラフ用]10分単位の水位観測値情報
 * @param {*} reprnHrDataList [グラフ用]時間単位の水位観測値情報
 * @param {*} trPredStgList [横断用]予測水位リスト
 * @param {*} latestObsTime [横断用]最新観測時刻
 * @param {string} argObsTime 観測日時
 * @param {string} appTime 画面表示時刻
 * @param {strng} crntPredTime 予測水位の現況の時刻
 */
function convertSelectedObsStage(
  obsData,
  tmData,
  upStgObsInfo,
  upStgTmData,
  dwStgObsInfo,
  dwStgTmData,
  reprnObsInfo,
  reprnTmData,
  min10DataList,
  hrDataList,
  predStgList,
  reprnMin10DataList,
  reprnHrDataList,
  trPredStgList,
  latestObsTime,
  argObsTime,
  appTime,
  crntPredTime
) {
  let min10StgList = null;
  let hrStgList = null;
  let min10CrossList = null;
  let hrCrossList = null;
  let crsSctList = [];
  // 時間を取得
  let argObsTimeHr = argObsTime.substring(0, argObsTime.length - 2) + "00";

  // グラフデータ生成
  // 10分単位
  min10StgList = getMin10HrDataStg(min10DataList, reprnMin10DataList);
  // 時間単位
  hrStgList = getMin10HrDataStg(hrDataList, reprnHrDataList);

  // 横断図グラフデータ生成
  if (latestObsTime != null) {
    // 最新観測値の時刻が取得出来た場合
    let latestObsTimeHr =
      latestObsTime.substring(0, latestObsTime.length - 2) + "00";
    // 10分単位
    min10CrossList = getMin10HrDataCross(min10DataList, latestObsTime, 10);
    // 時間単位
    hrCrossList = getMin10HrDataCross(hrDataList, latestObsTimeHr, 60);
  } else {
    // 最新観測値の時刻が取得出来ない場合、画面の時刻で生成する
    // 10分単位
    min10CrossList = getMin10HrDataCross(min10DataList, argObsTime, 10);
    // 時間単位
    hrCrossList = getMin10HrDataCross(hrDataList, argObsTimeHr, 60);
  }

  // 横断断面情報の生成
  if (Object.keys(obsData.crssct).length > 0) {
    for (var crsSct of obsData.crssct) {
      var crsSctValue = {
        drawPointNo: crsSct.drawPointNo,
        drawHeight: crsSct.drawHigh,
        drawLength: crsSct.drawLength,
      };
      crsSctList.push(crsSctValue);
    }
  }

  // 水位観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmStgDetailInfo: {
        ofcCd: obsData.obsInfo.ofcCd,
        ofcNm: obsData.obsInfo.ofcNm,
        itmkndCd: obsData.obsInfo.itmkndCd,
        camKind: obsData.obsInfo.camKind,
        sysId: obsData.obsInfo.sysId,
        obsCd: obsData.obsInfo.obsCd,
        obsNm: obsData.obsInfo.obsNm,
        obsKana: obsData.obsInfo.obsKana,
        obsNmS: obsData.obsInfo.obsNmS,
        obsSkana: obsData.obsInfo.obsSkana,
        prefCd: obsData.obsInfo.prefCd,
        twnCd: obsData.obsInfo.twnCd,
        rvrCd: obsData.obsInfo.rvrCd,
        rvrNm: obsData.obsInfo.rvrNm,
        rvrKana: obsData.obsInfo.rvrKana,
        rsysCd: obsData.obsInfo.rsysCd,
        rsysNm: obsData.obsInfo.rsysNm,
        rsysKana: obsData.obsInfo.rsysKana,
        jrsCd: obsData.obsInfo.jrsCd,
        jrsNm: obsData.obsInfo.jrsNm,
        jrsNmKana: obsData.obsInfo.jrsNmKana,
        obsAdr: obsData.obsInfo.obsAdr,
        obsAdrKana: obsData.obsInfo.obsAdrKana,
        obsSadr: obsData.obsInfo.obsSadr,
        obsSct: obsData.obsInfo.obsSct,
        bnkSct: obsData.obsInfo.bnkSct,
        rvrMouthDst: obsData.obsInfo.rvrMouthDst,
        lat: obsData.obsInfo.lat,
        lon: obsData.obsInfo.lon,
        reprnObsNm: obsData.obsInfo.reprnObsNm,
        reprnOfcCd: reprnObsInfo != null ? reprnObsInfo.ofcCd : null,
        reprnItmkndCd: obsData.obsInfo.reprnItmkndCd,
        reprnObsCd: reprnObsInfo != null ? reprnObsInfo.obsCd : null,
        reprn10mCaut: reprnObsInfo != null ? reprnObsInfo.rn10mCaut : null,
        reprn10mWarn: reprnObsInfo != null ? reprnObsInfo.rn10mWarn : null,
        reprnHrCaut: reprnObsInfo != null ? reprnObsInfo.rnHrCaut : null,
        reprnHrWarn: reprnObsInfo != null ? reprnObsInfo.rnHrWarn : null,
        reprnIncCaut: reprnObsInfo != null ? reprnObsInfo.rnIncCaut : null,
        reprnIncWarn: reprnObsInfo != null ? reprnObsInfo.rnIncWarn : null,
        reprnRnHr10m: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rnHr10m"
        ),
        reprnRnHr10mCcd: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rnHr10mCcd"
        ),
        reprnRn10m: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rn10m"
        ),
        reprnRn10mCcd: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rn10mCcd"
        ),
        reprnRnInc: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rnInc"
        ),
        reprnRnIncCcd: checkReprnObs(
          reprnTmData,
          obsData.obsInfo.reprnItmkndCd,
          "rnIncCcd"
        ),
        altiStdCd: obsData.obsInfo.altiStdCd,
        zeroHigh: obsData.obsInfo.zeroHigh,
        zeroHighFix: obsData.obsInfo.zeroHighFix,
        // 堤防天端からの高さ
        stgDiffTopendHght: tmData != null ? tmData.stgHght : null,
        stgTopendHght: obsData.obsInfo.topendHght,
        rsrvStg: obsData.obsInfo.rsrvStg,
        warnStg: obsData.obsInfo.warnStg,
        dsgnMoblzdStg: obsData.obsInfo.dsgnMoblzdStg,
        spclWarnStg: obsData.obsInfo.spclWarnStg,
        dngStg: obsData.obsInfo.dngStg,
        dsgnHighStg: obsData.obsInfo.dsgnHighStg,
        fldStg: obsData.obsInfo.fldStg,
        rsrvStgDiffTopendHght: obsData.obsInfo.rsrvStgHght,
        warnStgDiffTopendHght: obsData.obsInfo.warnStgHght,
        dsgnMoblzdStgDiffTopendHght: obsData.obsInfo.dsgnMoblzdStgHght,
        spclWarnStgDiffTopendHght: obsData.obsInfo.spclWarnStgHght,
        dngStgDiffTopendHght: obsData.obsInfo.dngStgHght,
        dsgnHighStgDiffTopendHght: obsData.obsInfo.dsgnHighStgHght,
        fldStgDiffTopendHght: obsData.obsInfo.fldStgHght,
        fldctlFlg: obsData.obsInfo.fldctlFlg,
        fldfrFlg: obsData.obsInfo.fldfrFlg,
        evstgFlg: obsData.obsInfo.evstgFlg,
        reprnObsFcd: obsData.obsInfo.reprnObsFcd,
        drawType: obsData.obsInfo.drawType,
        upgate1: obsData.obsInfo.upgate1,
        upgate2: obsData.obsInfo.upgate2,
        topendHght: obsData.obsInfo.topendHght,
        leftBnkHghtLat: obsData.crs.leftBnkHghtLat,
        leftBnkHghtLon: obsData.crs.leftBnkHghtLon,
        rightBnkHghtLat: obsData.crs.rightBnkHghtLat,
        rightBnkHghtLon: obsData.crs.rightBnkHghtLon,
        embDrawDist: obsData.crs.embDrawDist,
        drawPosMax: obsData.crs.drawPosMax,
        drawPosMin: obsData.crs.drawPosMin,
        currProvUrl: obsData.obsInfo.currProvUrl,
        normProvUrl: obsData.obsInfo.normProvUrl,
        currentUrl: obsData.obsInfo.currentUrl,
        normallyUrl: obsData.obsInfo.normallyUrl,
        liveUrl: obsData.obsInfo.liveUrl,
        upStgOfcCd: upStgObsInfo != null ? upStgObsInfo.ofcCd : null,
        upStgItmkndCd: upStgObsInfo != null ? upStgObsInfo.itmkndCd : null,
        upStgObsCd: upStgObsInfo != null ? upStgObsInfo.obsCd : null,
        // 零点高からの高さ
        upStg: upStgTmData != null ? upStgTmData.stg : null,
        // 堤防天端からの高さ
        upStgDiffTopendHght: upStgTmData != null ? upStgTmData.stgHght : null,
        // 未収集、もしくは堤防天端からの高さのデータが取得出来ない場合内容コードに未収集値を入れる
        upStgCcd:
          upStgTmData != null && upStgTmData.stgHght != null
            ? upStgTmData.stgCcd
            : NOT_COLLECTED,
        upStgOvlvl: upStgTmData != null ? upStgTmData.stgOvlvl : null,
        upStgLtstChg: upStgTmData != null ? upStgTmData.stgLtstChg : null,
        upStgLtstChgCcd:
          upStgTmData != null ? upStgTmData.stgLtstChgCcd : NOT_COLLECTED,
        upStg10mChg: upStgTmData != null ? upStgTmData.stg10mChg : null,
        upStg10mChgCcd:
          upStgTmData != null ? upStgTmData.stg10mChgCcd : NOT_COLLECTED,
        upStgQmflg: upStgTmData != null ? upStgTmData.stgQmflg : null,
        upRsrvStg: upStgObsInfo != null ? upStgObsInfo.rsrvStg : null,
        upWarnStg: upStgObsInfo != null ? upStgObsInfo.warnStg : null,
        upSpclWarnStg: upStgObsInfo != null ? upStgObsInfo.spclWarnStg : null,
        upDngStg: upStgObsInfo != null ? upStgObsInfo.dngStg : null,
        upFldStg: upStgObsInfo != null ? upStgObsInfo.fldStg : null,
        upDspFlg: upStgObsInfo != null ? upStgObsInfo.dspFlg : null,
        dwStgOfcCd: dwStgObsInfo != null ? dwStgObsInfo.ofcCd : null,
        dwStgItmkndCd: dwStgObsInfo != null ? dwStgObsInfo.itmkndCd : null,
        dwStgObsCd: dwStgObsInfo != null ? dwStgObsInfo.obsCd : null,
        // 零点高からの高さ
        dwStg: dwStgTmData != null ? dwStgTmData.stg : null,
        // 堤防天端からの高さ
        dwStgDiffTopendHght: dwStgTmData != null ? dwStgTmData.stgHght : null,
        // 未収集、もしくは堤防天端からの高さのデータが取得出来ない場合内容コードに未収集値を入れる
        dwStgCcd:
          dwStgTmData != null && dwStgTmData.stgHght != null
            ? dwStgTmData.stgCcd
            : NOT_COLLECTED,
        dwStgOvlvl: dwStgTmData != null ? dwStgTmData.stgOvlvl : null,
        dwStgLtstChg: dwStgTmData != null ? dwStgTmData.stgLtstChg : null,
        dwStgLtstChgCcd:
          dwStgTmData != null ? dwStgTmData.stgLtstChgCcd : NOT_COLLECTED,
        dwStg10mChg: dwStgTmData != null ? dwStgTmData.stg10mChg : null,
        dwStg10mChgCcd:
          dwStgTmData != null ? dwStgTmData.stg10mChgCcd : NOT_COLLECTED,
        dwStgQmflg: dwStgTmData != null ? dwStgTmData.stgQmflg : null,
        dwRsrvStg: dwStgObsInfo != null ? dwStgObsInfo.rsrvStg : null,
        dwWarnStg: dwStgObsInfo != null ? dwStgObsInfo.warnStg : null,
        dwSpclWarnStg: dwStgObsInfo != null ? dwStgObsInfo.spclWarnStg : null,
        dwDngStg: dwStgObsInfo != null ? dwStgObsInfo.dngStg : null,
        dwFldStg: dwStgObsInfo != null ? dwStgObsInfo.fldStg : null,
        dwDspFlg: dwStgObsInfo != null ? dwStgObsInfo.dspFlg : null,
        damRlsCnt: obsData.obsInfo.damRlsCnt,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        // 零点高からの高さ
        stg: tmData != null ? tmData.stg : null,
        // 未収集の場合内容コードに未収集値を入れる
        stgCcd: tmData != null ? tmData.stgCcd : NOT_COLLECTED,
        stgOvlvl: tmData != null ? tmData.stgOvlvl : null,
        stgOvdeg: tmData != null ? tmData.stgOvdeg : null,
        stgQmflg: tmData != null ? tmData.stgQmflg : null,
        stgLtstChg: tmData != null ? tmData.stgLtstChg : null,
        stgLtstChgCcd: tmData != null ? tmData.stgLtstChgCcd : NOT_COLLECTED,
        stg10mChg: tmData != null ? tmData.stg10mChg : null,
        stg10mChgCcd: tmData != null ? tmData.stg10mChgCcd : null,
        qwtrObsCd: obsData.obsInfo.qwtrObsCd,
        dbLink: obsData.obsInfo.dbLink,
        dspFlg: obsData.obsInfo.dspFlg,
      },
      tmStgDetailObs: {
        stg10mList: min10StgList != null ? min10StgList : [],
        stgHrList: hrStgList != null ? hrStgList : [],
        predStgList:
          predStgList != null && Object.keys(predStgList).length > 0
            ? predStgList
            : [],
        // 予測水位「現況」の時刻
        crntPredTime,
      },
      crossDataObs: {
        crs: {
          zeroHigh: obsData.crs.zeroHigh,
          sfLeftLimit: obsData.crs.sfLeftLimit,
          sfRightLimit: obsData.crs.sfRightLimit,
          riverBaseHght: obsData.crs.rvrBaseHigh,
          riverBed: obsData.crs.riverBed,
        },
        crssct: crsSctList,
        trStg10m: min10CrossList,
        trStg1h: hrCrossList,
        trPredStg:
          trPredStgList != null && Object.keys(trPredStgList).length > 0
            ? trPredStgList
            : [],
      },
    },
  };
  return tmObsResult;
}

/**
 * [水質観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo 水質観測所情報
 * @param {*} tmData 最新水質観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の水質観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsWtrQual(obsInfo, tmData, hrDataList, appTime) {
  // 水質観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmQwtrDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsNmS: obsInfo.obsNmS,
        obsKana: obsInfo.obsKana,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        tyclsCd: obsInfo.tyclsCd,
        tysct1Cd: obsInfo.tysct1Cd,
        phLolmt: obsInfo.phLolmt,
        phUplmt: obsInfo.phUplmt,
        doxLolmt: obsInfo.doxLolmt,
        codUplmt: obsInfo.codUplmt,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        wtrtmp: tmData != null ? tmData.wtrtmp : null,
        wtrtmpCcd: tmData != null ? tmData.wtrtmpCcd : NOT_COLLECTED,
        wtrtmpOvcd: tmData != null ? tmData.wtrtmpOvcd : null,
        conduct: tmData != null ? tmData.conduct : null,
        conductCcd: tmData != null ? tmData.conductCcd : NOT_COLLECTED,
        conductOvcd: tmData != null ? tmData.conductOvcd : null,
        dox: tmData != null ? tmData.dox : null,
        doxCcd: tmData != null ? tmData.doxCcd : NOT_COLLECTED,
        doxOvcd: tmData != null ? tmData.doxOvcd : null,
        ph: tmData != null ? tmData.ph : null,
        phCcd: tmData != null ? tmData.phCcd : NOT_COLLECTED,
        phOvcd: tmData != null ? tmData.phOvcd : null,
        turbdty: tmData != null ? tmData.turbdty : null,
        turbdtyCcd: tmData != null ? tmData.turbdtyCcd : NOT_COLLECTED,
        turbdtyOvcd: tmData != null ? tmData.turbdtyOvcd : null,
        cod: tmData != null ? tmData.cod : null,
        codCcd: tmData != null ? tmData.codCcd : NOT_COLLECTED,
        codOvcd: tmData != null ? tmData.codOvcd : null,
        amn: tmData != null ? tmData.amn : null,
        amnCcd: tmData != null ? tmData.amnCcd : NOT_COLLECTED,
        amnOvcd: tmData != null ? tmData.amnOvcd : null,
        slt: tmData != null ? tmData.slt : null,
        sltCcd: tmData != null ? tmData.sltCcd : NOT_COLLECTED,
        sltOvcd: tmData != null ? tmData.sltOvcd : null,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmQwtrDetailObs: {
        qwtrList: hrDataList != null ? hrDataList : [],
      },
    },
  };
  return tmObsResult;
}

/**
 * [ダム観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo ダム観測所情報
 * @param {*} tmData 最新ダム観測値情報
 * @param {*} dwStgObsInfo 下流水位観測所情報
 * @param {*} dwStgTmData 最新下流水位観測値情報
 * @param {*} relatTmObsInfo 流域平均雨量観測所情報
 * @param {*} relatTmTmData 最新流域平均雨量観測値情報
 * @param {*} relatRdObsInfo レーダ流域平均雨量観測所情報
 * @param {*} relatRdTmData レーダ流域平均雨量観測値情報
 * @param {*} min10DataList [グラフ用]10分単位のダム観測値情報
 * @param {*} hrDataList [グラフ用]時間単位のダム観測値情報
 * @param {*} relatTmMin10DataList [グラフ用]10分単位の流域平均雨量観測値情報
 * @param {*} relatTmHrDataList [グラフ用]時間単位の流域平均雨量観測値情報
 * @param {*} relatRdMin10DataList [グラフ用]10分単位のレーダ流域平均雨量観測値情報
 * @param {*} relatRdHrDataList [グラフ用]時間単位のレーダ流域平均雨量観測値情報
 * @param {*} relatDwStgHrDataList [模式図用]時間単位の下流水位観測値情報
 * @param {string} argObsTime 観測日時
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsDam(
  obsInfo,
  tmData,
  dwStgObsInfo,
  dwStgTmData,
  relatTmObsInfo,
  relatTmTmData,
  relatRdObsInfo,
  relatRdTmData,
  min10DataList,
  hrDataList,
  relatTmMin10DataList,
  relatTmHrDataList,
  relatRdMin10DataList,
  relatRdHrDataList,
  relatDwStgHrDataList,
  argObsTime,
  appTime
) {
  // 制限水位情報の取得
  let limitStageInfo = getStageInfo(
    Util.formatDate(argObsTime),
    "MM/DD",
    obsInfo.lmtStg1,
    obsInfo.lmtStg2,
    obsInfo.lmtStg3,
    obsInfo.lmtStg4,
    obsInfo.lmtStgStrt1,
    obsInfo.lmtStgStrt2,
    obsInfo.lmtStgStrt3,
    obsInfo.lmtStgStrt4,
    obsInfo.lmtStgEnd1,
    obsInfo.lmtStgEnd2,
    obsInfo.lmtStgEnd3,
    obsInfo.lmtStgEnd4
  );

  // 予備放流水位情報の取得
  var spareStageInfo = getStageInfo(
    Util.formatDate(argObsTime),
    "MM/DD",
    obsInfo.sprStg1,
    obsInfo.sprStg2,
    obsInfo.sprStg3,
    obsInfo.sprStg4,
    obsInfo.sprStgStrt1,
    obsInfo.sprStgStrt2,
    obsInfo.sprStgStrt3,
    obsInfo.sprStgStrt4,
    obsInfo.sprStgEnd1,
    obsInfo.sprStgEnd2,
    obsInfo.sprStgEnd3,
    obsInfo.sprStgEnd4
  );

  let min10DamList = null;
  let hrDamList = null;

  // 流域平均雨量を優先する
  if (
    obsInfo.relatTmObsFcd !== null &&
    obsInfo.relatTmObsFcd !== "0000000000000"
  ) {
    min10DamList = getMin10HrDataDam(
      // 10分単位のダム観測値情報
      min10DataList,
      // 10分単位の流域平均雨量観測値情報
      relatTmMin10DataList
    );
    hrDamList = getMin10HrDataDam(
      // 時間単位のダム観測値情報
      hrDataList,
      // 時間単位の流域平均雨量観測値情報
      relatTmHrDataList
    );
  } else if (
    obsInfo.relatRdObsFcd !== null &&
    obsInfo.relatRdObsFcd !== "0000000000000"
  ) {
    min10DamList = getMin10HrDataDam(
      // 10分単位のダム観測値情報
      min10DataList,
      // 10分単位のレーダ流域平均雨量観測値情報
      relatRdMin10DataList
    );
    hrDamList = getMin10HrDataDam(
      // 時間単位のダム観測値情報
      hrDataList,
      // 時間単位のレーダ流域平均雨量観測値情報
      relatRdHrDataList
    );
  } else {
    min10DamList = getMin10HrDataDam(
      // 10分単位のダム観測値情報
      min10DataList,
      // 関連雨量観測所無し
      null
    );
    hrDamList = getMin10HrDataDam(
      // 時間単位のダム観測値情報
      hrDataList,
      // 関連雨量観測所無し
      null
    );
  }

  // ダム模式図情報取得
  let diagInfo = setDiagData(
    obsInfo,
    tmData,
    dwStgObsInfo,
    dwStgTmData,
    relatTmObsInfo,
    relatTmTmData,
    relatRdObsInfo,
    relatRdTmData,
    min10DataList,
    hrDataList,
    relatDwStgHrDataList,
    limitStageInfo,
    spareStageInfo,
    argObsTime
  );

  // ダム観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmDamDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsNmS: obsInfo.obsNmS,
        obsKana: obsInfo.obsKana,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        bsnArea: obsInfo.bsnArea,
        fldctlStrtFlw: obsInfo.fldctlStrtFlw,
        prvsStg: obsInfo.prvsStg,
        storCapBs: obsInfo.storCapBs,
        storPcntBs: obsInfo.storPcntBs,
        allDischBs: obsInfo.allDischBs,
        storPcntEffBs: obsInfo.storPcntEffBs,
        dsgnHighFlow: obsInfo.dsgnHighFlow,
        nrmlHighStg: obsInfo.nrmlHighStg,
        srchgStg: obsInfo.srchgStg,
        minStg: obsInfo.minStg,
        lnkNm: obsInfo.lnkNm,
        lnkUrl: obsInfo.lnkUrl,
        wtrUseFlg: obsInfo.wtrUseFlg,
        // 算出した制限水位情報
        lmtStg: limitStageInfo.stg,
        lmtStgStrt: limitStageInfo.stgStrt,
        lmtStgEnd: limitStageInfo.stgEnd,
        // 算出した予備放流水位情報
        sprStg: spareStageInfo.stg,
        sprStgStrt: spareStageInfo.stgStrt,
        sprStgEnd: spareStageInfo.stgEnd,
        relatTmObsFcd: obsInfo.relatTmObsFcd,
        relatTmObsNm: obsInfo.relatTmObsNm,
        relatTmOfcCd: relatTmObsInfo != null ? relatTmObsInfo.ofcCd : null,
        relatTmItmkndCd:
          relatTmObsInfo != null ? relatTmObsInfo.itmkndCd : null,
        relatTmObsCd: relatTmObsInfo != null ? relatTmObsInfo.obsCd : null,
        tmRn10mCaut: relatTmObsInfo != null ? relatTmObsInfo.rn10mCaut : null,
        tmRn10mWarn: relatTmObsInfo != null ? relatTmObsInfo.rn10mWarn : null,
        tmRnHrCaut: relatTmObsInfo != null ? relatTmObsInfo.rnHrCaut : null,
        tmRnHrWarn: relatTmObsInfo != null ? relatTmObsInfo.rnHrWarn : null,
        tmRnIncCaut: relatTmObsInfo != null ? relatTmObsInfo.rnIncCaut : null,
        tmRnIncWarn: relatTmObsInfo != null ? relatTmObsInfo.rnIncWarn : null,
        relatRdObsFcd: obsInfo.relatRdObsFcd,
        relatRdObsNm: obsInfo.relatRdObsNm,
        relatRdOfcCd: relatRdObsInfo != null ? relatRdObsInfo.ofcCd : null,
        relatRdItmkndCd:
          relatRdObsInfo != null ? relatRdObsInfo.itmkndCd : null,
        relatRdObsCd: relatRdObsInfo != null ? relatRdObsInfo.obsCd : null,
        rdRn10mCaut: relatRdObsInfo != null ? relatRdObsInfo.rn10mCaut : null,
        rdRn10mWarn: relatRdObsInfo != null ? relatRdObsInfo.rn10mWarn : null,
        rdRnHrCaut: relatRdObsInfo != null ? relatRdObsInfo.rnHrCaut : null,
        rdRnHrWarn: relatRdObsInfo != null ? relatRdObsInfo.rnHrWarn : null,
        rdRnIncCaut: relatRdObsInfo != null ? relatRdObsInfo.rnIncCaut : null,
        rdRnIncWarn: relatRdObsInfo != null ? relatRdObsInfo.rnIncWarn : null,
        dwStgObsFcd: obsInfo.dwStgObsFcd,
        dwStgObsNm: obsInfo.dwStgObsNm,
        dwStgOfcCd: dwStgObsInfo != null ? dwStgObsInfo.ofcCd : null,
        dwStgItmkndCd: dwStgObsInfo != null ? dwStgObsInfo.itmkndCd : null,
        dwStgObsCd: dwStgObsInfo != null ? dwStgObsInfo.obsCd : null,
        dwRsrvStg: dwStgObsInfo != null ? dwStgObsInfo.rsrvStg : null,
        dwWarnStg: dwStgObsInfo != null ? dwStgObsInfo.warnStg : null,
        dwSpclWarnStg: dwStgObsInfo != null ? dwStgObsInfo.spclWarnStg : null,
        dwDngStg: dwStgObsInfo != null ? dwStgObsInfo.dngStg : null,
        dwDspFlg: dwStgObsInfo != null ? dwStgObsInfo.dspFlg : null,
        dwStgTopendHght: dwStgObsInfo != null ? dwStgObsInfo.topendHght : null,
        // 零点高からの高さ
        dwStg: dwStgTmData != null ? dwStgTmData.stg : null,
        // 堤防天端からの高さ
        dwStgTopendHghtDiff: dwStgTmData != null ? dwStgTmData.stgHght : null,
        // 未収集、もしくは堤防天端からの高さのデータが取得出来ない場合内容コードに未収集値を入れる
        dwStgCcd:
          dwStgTmData != null && dwStgTmData.stgHght != null
            ? dwStgTmData.stgCcd
            : NOT_COLLECTED,
        dwStgOvlvl: dwStgTmData != null ? dwStgTmData.stgOvlvl : null,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        storLvl: tmData != null ? tmData.storLvl : null,
        storLvlCcd: tmData != null ? tmData.storLvlCcd : NOT_COLLECTED,
        storLvlOvflg: tmData != null ? tmData.storLvlOvflg : null,
        storCap: tmData != null ? tmData.storCap : null,
        storCapCcd: tmData != null ? tmData.storCapCcd : NOT_COLLECTED,
        storCapOvflg: tmData != null ? tmData.storCapOvflg : null,
        storFcntIrr: tmData != null ? tmData.storFcntIrr : null,
        storFcntIrrCcd: tmData != null ? tmData.storFcntIrrCcd : NOT_COLLECTED,
        storFcntIrrOvflg: tmData != null ? tmData.storFcntIrrOvflg : null,
        storPcntIrr: tmData != null ? tmData.storPcntIrr : null,
        storPcntIrrCcd: tmData != null ? tmData.storPcntIrrCcd : NOT_COLLECTED,
        storPcntIrrOvflg: tmData != null ? tmData.storPcntIrrOvflg : null,
        storPcntEff: tmData != null ? tmData.storPcntEff : null,
        storPcntEffCcd: tmData != null ? tmData.storPcntEffCcd : NOT_COLLECTED,
        storPcntEffOvflg: tmData != null ? tmData.storPcntEffOvflg : null,
        allSink: tmData != null ? tmData.allSink : null,
        allSinkCcd: tmData != null ? tmData.allSinkCcd : NOT_COLLECTED,
        allSinkOvflg: tmData != null ? tmData.allSinkOvflg : null,
        allDisch: tmData != null ? tmData.allDisch : null,
        allDischCcd: tmData != null ? tmData.allDischCcd : NOT_COLLECTED,
        allDischOvflg: tmData != null ? tmData.allDischOvflg : null,
        bsnrn10m: relatTmTmData != null ? relatTmTmData.bsnrn10m : null,
        bsnrn10mCcd:
          relatTmTmData != null ? relatTmTmData.bsnrn10mCcd : NOT_COLLECTED,
        bsnrn10mCautOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrn10mCautOvflg : null,
        bsnrn10mWarnOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrn10mWarnOvflg : null,
        bsnrnInc: relatTmTmData != null ? relatTmTmData.bsnrnInc : null,
        bsnrnIncCcd:
          relatTmTmData != null ? relatTmTmData.bsnrnIncCcd : NOT_COLLECTED,
        bsnrnIncCautOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrnIncCautOvflg : null,
        bsnrnIncWarnOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrnIncWarnOvflg : null,
        bsnrnHr10m: relatTmTmData != null ? relatTmTmData.bsnrnHr10m : null,
        bsnrnHr10mCcd:
          relatTmTmData != null ? relatTmTmData.bsnrnHr10mCcd : NOT_COLLECTED,
        bsnrnHr10mCautOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrnHr10mCautOvflg : null,
        bsnrnHr10mWarnOvflg:
          relatTmTmData != null ? relatTmTmData.bsnrnHr10mWarnOvflg : null,
        rdbsnrn10m: relatRdTmData != null ? relatRdTmData.rdbsnrn10m : null,
        rdbsnrn10mCcd:
          relatRdTmData != null ? relatRdTmData.rdbsnrn10mCcd : NOT_COLLECTED,
        rdbsnrn10mCautOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrn10mCautOvflg : null,
        rdbsnrn10mWarnOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrn10mWarnOvflg : null,
        rdbsnrnInc: relatRdTmData != null ? relatRdTmData.rdbsnrnInc : null,
        rdbsnrnIncCcd:
          relatRdTmData != null ? relatRdTmData.rdbsnrnIncCcd : NOT_COLLECTED,
        rdbsnrnIncCautOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrnIncCautOvflg : null,
        rdbsnrnIncWarnOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrnIncWarnOvflg : null,
        rdbsnrnHr10m: relatRdTmData != null ? relatRdTmData.rdbsnrnHr10m : null,
        rdbsnrnHr10mCcd:
          relatRdTmData != null ? relatRdTmData.rdbsnrnHr10mCcd : NOT_COLLECTED,
        rdbsnrnHr10mCautOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrnHr10mCautOvflg : null,
        rdbsnrnHr10mWarnOvflg:
          relatRdTmData != null ? relatRdTmData.rdbsnrnHr10mWarnOvflg : null,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmDamDetailObs: {
        dam10mList: min10DamList,
        damHrList: hrDamList,
      },
      diag: {
        dam: diagInfo,
      },
    },
  };
  return tmObsResult;
}

/**
 * [海岸観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo 海岸観測所情報
 * @param {*} tmData 最新海岸観測値情報
 * @param {*} min10DataList [グラフ用]10分単位の海岸観測値情報
 * @param {*} hrDataList [グラフ用]時間単位の海岸観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsCoast(
  obsInfo,
  tmData,
  min10DataList,
  hrDataList,
  appTime
) {
  // 海岸観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmCoastDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsNmS: obsInfo.obsNmS,
        obsKana: obsInfo.obsKana,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        wvHghtCaut: obsInfo.wvHghtCaut,
        wvHghtWarn: obsInfo.wvHghtWarn,
        tidlvlCaut: obsInfo.tidlvlCaut,
        tidlvlWarn: obsInfo.tidlvlWarn,
        wndSpdCaut: obsInfo.wndSpdCaut,
        wndSpdWarn: obsInfo.wndSpdWarn,
        dsgnWvHght: obsInfo.dsgnWvHght,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        maxwvHght: tmData != null ? tmData.maxwvHght : null,
        maxwvHghtCcd: tmData != null ? tmData.maxwvHghtCcd : NOT_COLLECTED,
        maxwvCycl: tmData != null ? tmData.maxwvCycl : null,
        maxwvCyclCcd: tmData != null ? tmData.maxwvCyclCcd : NOT_COLLECTED,
        onthwvHght: tmData != null ? tmData.onthwvHght : null,
        onthwvHghtCcd: tmData != null ? tmData.onthwvHghtCcd : NOT_COLLECTED,
        onthwvHghtCautOvflg: tmData != null ? tmData.onthwvHghtCautOvflg : null,
        onthwvHghtWarnOvflg: tmData != null ? tmData.onthwvHghtWarnOvflg : null,
        onthwvCycl: tmData != null ? tmData.onthwvCycl : null,
        onthwvCyclCcd: tmData != null ? tmData.onthwvCyclCcd : NOT_COLLECTED,
        tidlvl: tmData != null ? tmData.tidlvl : null,
        tidlvlCcd: tmData != null ? tmData.tidlvlCcd : NOT_COLLECTED,
        tidlvlCautOvflg: tmData != null ? tmData.tidlvlCautOvflg : null,
        tidlvlWarnOvflg: tmData != null ? tmData.tidlvlWarnOvflg : null,
        avewndSpd: tmData != null ? tmData.avewndSpd : null,
        avewndSpdCcd: tmData != null ? tmData.avewndSpdCcd : NOT_COLLECTED,
        avewndSpdCautOvflg: tmData != null ? tmData.avewndSpdCautOvflg : null,
        avewndSpdWarnOvflg: tmData != null ? tmData.avewndSpdWarnOvflg : null,
        avewndDir: tmData != null ? tmData.avewndDir : null,
        avewndDirCcd: tmData != null ? tmData.avewndDirCcd : NOT_COLLECTED,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmCoastDetailObs: {
        coast10mList: min10DataList != null ? min10DataList : [],
        coastHrList: hrDataList != null ? hrDataList : [],
      },
    },
  };
  return tmObsResult;
}

/**
 * [レーダ流域平均観測所情報]高アクセス対応 フォーマット変換
 * @param {*} obsInfo レーダ流域平均観測所情報
 * @param {*} tmData 最新レーダ流域平均観測値情報
 * @param {*} min10DataList [グラフ用]10分単位のレーダ流域平均観測値情報
 * @param {*} hrDataList [グラフ用]時間単位のレーダ流域平均観測値情報
 * @param {string} appTime 画面表示時刻
 */
function convertSelectedObsRdBsn(
  obsInfo,
  tmData,
  min10DataList,
  hrDataList,
  appTime
) {
  let min10RdbsnList = null;
  let hrRdbsnList = null;
  // グラフデータ生成
  // 10分単位
  min10RdbsnList = getMin10HrDataRdBsn(min10DataList);

  // 時間単位
  hrRdbsnList = getMin10HrDataRdBsn(hrDataList);

  // レーダ流域平均観測所情報
  let tmObsResult = {
    tmObsResult: {
      tmRdBsnDetailInfo: {
        ofcCd: obsInfo.ofcCd,
        ofcNm: obsInfo.ofcNm,
        itmkndCd: obsInfo.itmkndCd,
        obsCd: obsInfo.obsCd,
        obsNm: obsInfo.obsNm,
        obsKana: obsInfo.obsKana,
        obsNmS: obsInfo.obsNmS,
        obsSkana: obsInfo.obsSkana,
        prefCd: obsInfo.prefCd,
        twnCd: obsInfo.twnCd,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        jrsCd: obsInfo.jrsCd,
        jrsNm: obsInfo.jrsNm,
        jrsNmKana: obsInfo.jrsNmKana,
        obsAdr: obsInfo.obsAdr,
        obsAdrKana: obsInfo.obsAdrKana,
        obsSadr: obsInfo.obsSadr,
        obsSct: obsInfo.obsSct,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        bsnArea: obsInfo.bsnArea,
        rn10mCaut: obsInfo.rn10mCaut,
        rn10mWarn: obsInfo.rn10mWarn,
        rnHrCaut: obsInfo.rnHrCaut,
        rnHrWarn: obsInfo.rnHrWarn,
        rnIncCaut: obsInfo.rnIncCaut,
        rnIncWarn: obsInfo.rnIncWarn,
        // 最新値が存在しない場合は表示時刻を入れる
        obsTime: tmData != null ? tmData.obsTime : appTime,
        rdbsnrn10m: tmData != null ? tmData.rdbsnrn10m : null,
        rdbsnrn10mCcd: tmData != null ? tmData.rdbsnrn10mCcd : NOT_COLLECTED,
        rdbsnrn10mCautOvflg: tmData != null ? tmData.rdbsnrn10mCautOvflg : null,
        rdbsnrn10mWarnOvflg: tmData != null ? tmData.rdbsnrn10mWarnOvflg : null,
        rdbsnrnInc: tmData != null ? tmData.rdbsnrnInc : null,
        rdbsnrnIncCcd: tmData != null ? tmData.rdbsnrnIncCcd : NOT_COLLECTED,
        rdbsnrnIncCautOvflg: tmData != null ? tmData.rdbsnrnIncCautOvflg : null,
        rdbsnrnIncWarnOvflg: tmData != null ? tmData.rdbsnrnIncWarnOvflg : null,
        rdbsnrnHr10m: tmData != null ? tmData.rdbsnrnHr10m : null,
        rdbsnrnHr10mCcd:
          tmData != null ? tmData.rdbsnrnHr10mCcd : NOT_COLLECTED,
        rdbsnrnHr10mCautOvflg:
          tmData != null ? tmData.rdbsnrnHr10mCautOvflg : null,
        rdbsnrnHr10mWarnOvflg:
          tmData != null ? tmData.rdbsnrnHr10mWarnOvflg : null,
        qwtrObsCd: obsInfo.qwtrObsCd,
        dbLink: obsInfo.dbLink,
      },
      tmRdBsnDetailObs: {
        rdbsnrn10mList: min10RdbsnList.rdbsnList,
        rdbsnrn10mIncList: min10RdbsnList.rdbsnIncList,
        rdbsnrnHrList: hrRdbsnList.rdbsnList,
        rdbsnrnHrIncList: hrRdbsnList.rdbsnIncList,
      },
    },
  };
  return tmObsResult;
}

/**
 * [河川カメラ]高アクセス対応 フォーマット変換
 * @param {string} cctvCd 河川カメラID
 * @param {*} obsInfo 河川カメラ
 * @param {*} relatStgObsData 関連水位観測所情報
 */
function convertSelectedObsCctv(
  cctvCd,
  obsInfo,
  relatStgObsData,
  relatSwStgObsData
) {
  // 河川カメラ観測所情報
  let tmObsResult = {
    tmObsResult: {
      cctvDetailInfo: {
        // 河川カメラ情報
        cctvNm: obsInfo.name,
        cctvNmKana: obsInfo.nameKana,
        cctvCd: cctvCd,
        ownCd: obsInfo.ownCd,
        ownName: obsInfo.ownName,
        ownKana: obsInfo.ownKana,
        ofcCd: obsInfo.ofcCd,
        sysId: obsInfo.sysId,
        sysCamId: obsInfo.sysCamId,
        rsysNm: obsInfo.rsysNm,
        rsysCd: obsInfo.rsysCd,
        rsysKana: obsInfo.rsysKana,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        mngSect: obsInfo.mngSect,
        twnCd: obsInfo.twnCd,
        addr: obsInfo.addr,
        addrKana: obsInfo.addrKana,
        pause: obsInfo.pause,
        dateType: obsInfo.dateType,
        camKind: obsInfo.camKind,
        currProvUrl: obsInfo.currProvUrl,
        normProvUrl: obsInfo.normProvUrl,
        currentUrl: obsInfo.currentUrl,
        normallyUrl: obsInfo.normallyUrl,
        liveUrl: obsInfo.liveUrl,

        // 関連水位観測所情報
        obsFcd: obsInfo.obsFcd,
        obsNm: obsInfo.obsNm,
        obsOfcCd: relatStgObsData != null ? relatStgObsData.ofcCd : null,
        ofcNm: relatStgObsData != null ? relatStgObsData.ofcNm : null,
        itmkndCd: relatStgObsData != null ? relatStgObsData.itmkndCd : null,
        obsCd: relatStgObsData != null ? relatStgObsData.obsCd : null,
        obsKana: relatStgObsData != null ? relatStgObsData.obsKana : null,
        obsNmS: relatStgObsData != null ? relatStgObsData.obsNmS : null,
        obsSkana: relatStgObsData != null ? relatStgObsData.obsSkana : null,
        prefCd: relatStgObsData != null ? relatStgObsData.prefCd : null,
        obsTwnCd: relatStgObsData != null ? relatStgObsData.twnCd : null,
        obsAdr: relatStgObsData != null ? relatStgObsData.obsAdr : null,
        obsSadr: relatStgObsData != null ? relatStgObsData.obsSadr : null,
        obsSct: relatStgObsData != null ? relatStgObsData.obsSct : null,
        bnkSct: relatStgObsData != null ? relatStgObsData.bnkSct : null,
        rvrMouthDst:
          relatStgObsData != null ? relatStgObsData.rvrMouthDst : null,

        // 関連危機管理水位観測所情報
        swobsCd: obsInfo.swobsCd,
        swobsNm: obsInfo.swobsNm,
        swofcCd: relatSwStgObsData != null ? relatSwStgObsData.swofcCd : null,
      },
    },
  };
  return tmObsResult;
}

/**
 * [簡易カメラ]高アクセス対応 フォーマット変換
 * @param {string} scamId 簡易カメラID
 * @param {*} obsInfo 簡易カメラ
 */
function convertSelectedObsScam(
  scamId,
  obsInfo,
  relatStgObsData,
  relatSwStgObsData,
  scamNowDetailInfo
) {
  // 簡易カメラ観測所情報
  let tmObsResult = {
    tmObsResult: {
      scamDetailInfo: {
        // 簡易カメラ情報
        scamNm: obsInfo.name,
        scamNmKana: obsInfo.nameKana,
        scamId: scamId,
        ownCd: obsInfo.ownCd,
        ownName: obsInfo.ownName,
        ownKana: obsInfo.ownKana,
        ofcCd: obsInfo.ofcCd,
        sysId: obsInfo.sysId,
        sysCamId: obsInfo.sysCamId,
        lat: obsInfo.lat,
        lon: obsInfo.lon,
        rsysCd: obsInfo.rsysCd,
        rsysNm: obsInfo.rsysNm,
        rsysKana: obsInfo.rsysKana,
        rvrCd: obsInfo.rvrCd,
        rvrNm: obsInfo.rvrNm,
        rvrKana: obsInfo.rvrKana,
        twnCd: obsInfo.twnCd,
        addr: obsInfo.addr,
        addrKana: obsInfo.addrKana,
        pause: obsInfo.pause,
        dateType: obsInfo.dateType,
        camKind: obsInfo.camKind,
        mngSect: obsInfo.mngSect,
        currProvUrl: obsInfo.currProvUrl,
        normProvUrl: obsInfo.normProvUrl,
        currentUrl: obsInfo.currentUrl,
        normallyUrl: obsInfo.normallyUrl,
        liveUrl: obsInfo.liveUrl,

        // 簡易カメラ最新情報
        dateTypeNow:
          scamNowDetailInfo != null ? scamNowDetailInfo.date_type : null,
        createTime:
          scamNowDetailInfo != null
            ? formatDateNonNull(scamNowDetailInfo.create_time)
            : null,
        getTime:
          scamNowDetailInfo != null
            ? formatDateNonNull(scamNowDetailInfo.get_time)
            : null,

        // 関連水位観測所情報
        obsFcd: obsInfo.obsFcd,
        obsNm: obsInfo.obsNm,
        obsOfcCd: relatStgObsData != null ? relatStgObsData.ofcCd : null,
        ofcNm: relatStgObsData != null ? relatStgObsData.ofcNm : null,
        itmkndCd: relatStgObsData != null ? relatStgObsData.itmkndCd : null,
        obsCd: relatStgObsData != null ? relatStgObsData.obsCd : null,
        obsKana: relatStgObsData != null ? relatStgObsData.obsKana : null,
        obsNmS: relatStgObsData != null ? relatStgObsData.obsNmS : null,
        obsSkana: relatStgObsData != null ? relatStgObsData.obsSkana : null,
        prefCd: relatStgObsData != null ? relatStgObsData.prefCd : null,
        obsTwnCd: relatStgObsData != null ? relatStgObsData.twnCd : null,
        obsAdr: relatStgObsData != null ? relatStgObsData.obsAdr : null,
        obsSadr: relatStgObsData != null ? relatStgObsData.obsSadr : null,
        obsSct: relatStgObsData != null ? relatStgObsData.obsSct : null,
        bnkSct: relatStgObsData != null ? relatStgObsData.bnkSct : null,
        rvrMouthDst:
          relatStgObsData != null ? relatStgObsData.rvrMouthDst : null,

        // 関連危機管理水位観測所情報
        swobsCd: obsInfo.swobsCd,
        swobsNm: obsInfo.swobsNm,
        swofcCd: relatSwStgObsData != null ? relatSwStgObsData.swofcCd : null,
      },
    },
  };
  return tmObsResult;
}

/**
 * [雨量観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsRain(obsData) {
  return {
    tmRainDetailInfo: obsData.tmRainDetailInfo,
    obsInfo: createDataRainObsInfo(obsData),
    standardValue: createDataRainStandardValue(obsData),
    curt: createDataRainCurt(obsData),
    graph: createDataRainGraph(obsData),
    obsValues: createDataRainValues(obsData),
    codeInfo: createDataRainCodeInfo(obsData),
  };
}

/**
 * [雨量観測所情報]観測所情報
 * @param {*} obsData 観測所情報
 */
function createDataRainObsInfo(obsData) {
  const info = obsData.tmRainDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
    {
      title: "標高",
      value: formatFloat(info.alti),
      unit: "m",
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      rankValue: "雨量ランキング",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [雨量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRainStandardValue(obsData) {
  const info = obsData.tmRainDetailInfo;
  return [
    {
      title: "時間雨量",
      value: formatCautWarn(info.rnHrCaut, info.rnHrWarn, "mm", 1),
    },
    {
      title: "10分雨量",
      value: formatCautWarn(info.rn10mCaut, info.rn10mWarn, "mm", 1),
    },
    {
      title: "降り始めからの雨量",
      value: formatCautWarn(info.rnIncCaut, info.rnIncWarn, "mm", 1),
    },
  ];
}

/**
 * [雨量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRainCurt(obsData) {
  const info = obsData.tmRainDetailInfo;
  return {
    category: [
      {
        title: "時間雨量",
        value: checkCcd(info.rnHr10m, info.rnHr10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.rnHr10mCcd),
        ovflg: isBkColoringCutWrn(info.rnHr10mCautOvflg, info.rnHr10mWarnOvflg),
        bgColor: checkRainBgColor(info.rnHr10mCcd),
      },
      {
        title: "10分雨量",
        value: checkCcd(info.rn10m, info.rn10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.rn10mCcd),
        ovflg: isBkColoringCutWrn(info.rn10mCautOvflg, info.rn10mWarnOvflg),
        bgColor: checkRainBgColor(info.rn10mCcd),
      },
      {
        title: "降り始めからの雨量",
        value: checkCcd(info.rnInc, info.rnIncCcd, 1),
        unit: checkCcdOfUnit("mm", info.rnIncCcd),
        ovflg: isBkColoringCutWrn(info.rnIncCautOvflg, info.rnIncWarnOvflg),
        bgColor: checkRainBgColor(info.rnIncCcd),
      },
    ],
    obsTime: !checkNotCollected(1, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [雨量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRainGraph(obsData) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmRainDetailInfo.rnHrWarn,
          caution: obsData.tmRainDetailInfo.rnHrCaut,
          min: rainGraphMin10Min,
          title: "時間雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmRainDetailInfo.rnIncWarn,
          caution: obsData.tmRainDetailInfo.rnIncCaut,
          min: rainGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
    min10: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmRainDetailInfo.rn10mWarn,
          caution: obsData.tmRainDetailInfo.rn10mCaut,
          min: rainGraphHourMin,
          title: "10分雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmRainDetailInfo.rnIncWarn,
          caution: obsData.tmRainDetailInfo.rnIncCaut,
          min: rainGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
  };

  // 10分グラフデータ
  for (var i = 0; i < obsData.tmRainDetailObs.rn10mList.length; i++) {
    // 最大値/最小値格納
    graphData.min10.spec.rain.max = mathMax(
      graphData.min10.spec.rain.max,
      checkCcdForGraph(
        obsData.tmRainDetailObs.rn10mList[i].rn10m,
        obsData.tmRainDetailObs.rn10mList[i].rn10mCcd
      )
    );
    graphData.min10.spec.total.max = mathMax(
      graphData.min10.spec.total.max,
      checkCcdForGraph(
        obsData.tmRainDetailObs.rn10mIncList[i].rnInc,
        obsData.tmRainDetailObs.rn10mIncList[i].rnIncCcd
      )
    );

    graphData.min10.value.push({
      date: Util.formatDate24(
        obsData.tmRainDetailObs.rn10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmRainDetailObs.rn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmRainDetailObs.rn10mList[i].rn10m,
        obsData.tmRainDetailObs.rn10mList[i].rn10mCcd
      ),
      total: checkCcdForGraph(
        obsData.tmRainDetailObs.rn10mIncList[i].rnInc,
        obsData.tmRainDetailObs.rn10mIncList[i].rnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    obsData.tmRainDetailInfo.rn10mCaut,
    obsData.tmRainDetailInfo.rn10mWarn
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    obsData.tmRainDetailInfo.rnIncCaut,
    obsData.tmRainDetailInfo.rnIncWarn
  );

  // 時間グラフデータ
  for (var j = 0; j < obsData.tmRainDetailObs.rnHrList.length; j++) {
    graphData.hour.spec.rain.max = mathMax(
      graphData.hour.spec.rain.max,
      obsData.tmRainDetailObs.rnHrList[j].rnHr
    );
    graphData.hour.spec.total.max = mathMax(
      graphData.hour.spec.total.max,
      obsData.tmRainDetailObs.rnHrIncList[j].rnInc
    );

    graphData.hour.value.push({
      date: Util.formatDate24(
        obsData.tmRainDetailObs.rnHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmRainDetailObs.rnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmRainDetailObs.rnHrList[j].rnHr,
        obsData.tmRainDetailObs.rnHrList[j].rnHrCcd
      ),
      total: checkCcdForGraph(
        obsData.tmRainDetailObs.rnHrIncList[j].rnInc,
        obsData.tmRainDetailObs.rnHrIncList[j].rnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.hour.spec.rain.max = mathMax(
    graphData.hour.spec.rain.max,
    obsData.tmRainDetailInfo.rnHrCaut,
    obsData.tmRainDetailInfo.rnHrWarn
  );

  graphData.hour.spec.total.max = mathMax(
    graphData.hour.spec.total.max,
    obsData.tmRainDetailInfo.rnIncCaut,
    obsData.tmRainDetailInfo.rnIncWarn
  );

  // 10分と時間で、上限を合わせる
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    graphData.hour.spec.rain.max
  );
  // 最上位の値の小数点第一位を切り上げ
  graphData.min10.spec.rain.max = Math.ceil(graphData.min10.spec.rain.max);
  // 10分と時間で、上限を合わせる
  graphData.hour.spec.rain.max = graphData.min10.spec.rain.max;

  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    graphData.hour.spec.total.max
  );
  // 最上位の値の小数点第一位を切り上げ
  graphData.min10.spec.total.max = Math.ceil(graphData.min10.spec.total.max);
  // 10分と時間で、上限を合わせる
  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  let difMin10Rain =
    graphData.min10.spec.rain.max - graphData.min10.spec.rain.min;
  let quarterMin10Rain = difMin10Rain / 4;

  if (quarterMin10Rain <= 10) {
    // <=10は10
    quarterMin10Rain = 10;
  } else if (quarterMin10Rain > 10 && quarterMin10Rain <= 20) {
    // 10<かつ<=20は20
    quarterMin10Rain = 20;
  } else if (quarterMin10Rain > 20 && quarterMin10Rain <= 30) {
    // 20<かつ<=30は30
    quarterMin10Rain = 30;
  } else if (quarterMin10Rain > 30 && quarterMin10Rain <= 40) {
    // 30<かつ<=40は40
    quarterMin10Rain = 40;
  } else {
    // 40<かつ<=50は50
    quarterMin10Rain = 50;
  }

  graphData.min10.spec.rain.max =
    graphData.min10.spec.rain.min + quarterMin10Rain * 4;

  let difHourRain = graphData.hour.spec.rain.max - graphData.hour.spec.rain.min;
  let quarterHourRain = difHourRain / 4;

  if (quarterHourRain <= 20) {
    // <=20は20
    quarterHourRain = 20;
  } else if (quarterHourRain > 20 && quarterHourRain <= 30) {
    // 20<かつ<=30は30
    quarterHourRain = 30;
  } else if (quarterHourRain > 30 && quarterHourRain <= 40) {
    // 30<かつ<=40は40
    quarterHourRain = 40;
  } else {
    // 40<かつ<=50は50
    quarterHourRain = 50;
  }

  graphData.hour.spec.rain.max =
    graphData.hour.spec.rain.min + quarterHourRain * 4;

  if (graphData.min10.spec.rain.max < graphData.hour.spec.rain.max) {
    graphData.min10.spec.rain.max = graphData.hour.spec.rain.max;
  }

  let difMin10Total =
    graphData.min10.spec.total.max - graphData.min10.spec.total.min;
  let quarterMin10Total = difMin10Total / 4;

  if (quarterMin10Total <= 50) {
    // <=50は50
    quarterMin10Total = 50;
  } else if (quarterMin10Total > 50 && quarterMin10Total <= 100) {
    // <=100は100
    quarterMin10Total = 100;
  } else if (quarterMin10Total > 100 && quarterMin10Total <= 200) {
    // 100<かつ<=200は200
    quarterMin10Total = 200;
  } else if (quarterMin10Total > 200 && quarterMin10Total <= 500) {
    // 200<かつ<=500は500
    quarterMin10Total = 500;
  } else {
    // 500<は750
    quarterMin10Total = 750;
  }

  graphData.min10.spec.total.max =
    graphData.min10.spec.total.min + quarterMin10Total * 4;

  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  return graphData;
}

/**
 * [雨量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRainValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < obsData.tmRainDetailObs.rn10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmRainDetailObs.rn10mList[i].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmRainDetailObs.rn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmRainDetailObs.rn10mList[i].rn10m,
        obsData.tmRainDetailObs.rn10mList[i].rn10mCcd,
        1
      ),
      total: checkCcd(
        obsData.tmRainDetailObs.rn10mIncList[i].rnInc,
        obsData.tmRainDetailObs.rn10mIncList[i].rnIncCcd,
        1
      ),
    });

    // コピー用データ
    let copyMin10Value =
      Util.formatDate24(obsData.tmRainDetailObs.rn10mList[i].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmRainDetailObs.rn10mList[i].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmRainDetailObs.rn10mList[i].rn10m,
        obsData.tmRainDetailObs.rn10mList[i].rn10mCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmRainDetailObs.rn10mIncList[i].rnInc,
        obsData.tmRainDetailObs.rn10mIncList[i].rnIncCcd,
        1
      );
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(
      obsData.tmRainDetailObs.rn10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  // 時間観測値一覧データ
  obsTimeBefore = null;
  for (var j = 0; j < obsData.tmRainDetailObs.rnHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmRainDetailObs.rnHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmRainDetailObs.rnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmRainDetailObs.rnHrList[j].rnHr,
        obsData.tmRainDetailObs.rnHrList[j].rnHrCcd,
        1
      ),
      total: checkCcd(
        obsData.tmRainDetailObs.rnHrIncList[j].rnInc,
        obsData.tmRainDetailObs.rnHrIncList[j].rnIncCcd,
        1
      ),
    });

    // コピー用データ
    let copyHrValue =
      Util.formatDate24(
        obsData.tmRainDetailObs.rnHrIncList[j].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmRainDetailObs.rnHrIncList[j].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmRainDetailObs.rnHrList[j].rnHr,
        obsData.tmRainDetailObs.rnHrList[j].rnHrCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmRainDetailObs.rnHrIncList[j].rnInc,
        obsData.tmRainDetailObs.rnHrIncList[j].rnIncCcd,
        1
      );
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmRainDetailObs.rnHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

/**
 * [雨量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRainCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmRainDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [流域平均観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsBsn(obsData) {
  return {
    tmBsnDetailInfo: obsData.tmBsnDetailInfo,
    obsInfo: createDataBsnObsInfo(obsData),
    standardValue: createDataBsnStandardValue(obsData),
    curt: createDataBsnCurt(obsData),
    graph: createDataBsnGraph(obsData),
    obsValues: createDataBsnValues(obsData),
  };
}

/**
 * [流域平均観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataBsnObsInfo(obsData) {
  const info = obsData.tmBsnDetailInfo;
  return [
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "流域面積",
      value: formatFloat(info.bsnArea),
      unit: "km&sup2;",
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [流域平均観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataBsnStandardValue(obsData) {
  const info = obsData.tmBsnDetailInfo;
  return [
    {
      title: "時間雨量",
      value: formatCautWarn(info.rnHrCaut, info.rnHrWarn, "mm", 1),
    },
    {
      title: "10分雨量",
      value: formatCautWarn(info.rn10mCaut, info.rn10mWarn, "mm", 1),
    },
    {
      title: "降り始めからの雨量",
      value: formatCautWarn(info.rnIncCaut, info.rnIncWarn, "mm", 1),
    },
  ];
}

/**
 * [流域平均観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataBsnCurt(obsData) {
  const info = obsData.tmBsnDetailInfo;
  return {
    category: [
      {
        title: "時間雨量",
        value: checkCcd(info.bsnrnHr10m, info.bsnrnHr10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.bsnrnHr10mCcd),
        ovflg: isBkColoringCutWrn(
          info.bsnrnHr10mCautOvflg,
          info.bsnrnHr10mWarnOvflg
        ),
        bgColor: checkRainBgColor(info.bsnrnHr10mCcd),
      },
      {
        title: "10分雨量",
        value: checkCcd(info.bsnrn10m, info.bsnrn10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.bsnrn10mCcd),
        ovflg: isBkColoringCutWrn(
          info.bsnrn10mCautOvflg,
          info.bsnrn10mWarnOvflg
        ),
        bgColor: checkRainBgColor(info.bsnrn10mCcd),
      },
      {
        title: "降り始めからの雨量",
        value: checkCcd(info.bsnrnInc, info.bsnrnIncCcd, 1),
        unit: checkCcdOfUnit("mm", info.bsnrnIncCcd),
        ovflg: isBkColoringCutWrn(
          info.bsnrnIncCautOvflg,
          info.bsnrnIncWarnOvflg
        ),
        bgColor: checkRainBgColor(info.bsnrnIncCcd),
      },
    ],
    obsTime: !checkNotCollected(2, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [流域平均観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataBsnGraph(obsData) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmBsnDetailInfo.rnHrWarn,
          caution: obsData.tmBsnDetailInfo.rnHrCaut,
          min: bsnGraphMin10Min,
          title: "時間雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmBsnDetailInfo.rnIncWarn,
          caution: obsData.tmBsnDetailInfo.rnIncCaut,
          min: bsnGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
    min10: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmBsnDetailInfo.rn10mWarn,
          caution: obsData.tmBsnDetailInfo.rn10mCaut,
          min: bsnGraphHourMin,
          title: "10分雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmBsnDetailInfo.rnIncWarn,
          caution: obsData.tmBsnDetailInfo.rnIncCaut,
          min: bsnGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
  };

  // 10分グラフデータ
  for (var i = 0; i < obsData.tmBsnDetailObs.bsnrn10mList.length; i++) {
    // 最大値/最小値格納
    graphData.min10.spec.rain.max = mathMax(
      graphData.min10.spec.rain.max,
      checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10m,
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10mCcd
      )
    );
    graphData.min10.spec.total.max = mathMax(
      graphData.min10.spec.total.max,
      checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnIncCcd
      )
    );

    graphData.min10.value.push({
      date: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10m,
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10mCcd
      ),
      total: checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    obsData.tmBsnDetailInfo.rn10mCaut,
    obsData.tmBsnDetailInfo.rn10mWarn
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    obsData.tmBsnDetailInfo.rnIncCaut,
    obsData.tmBsnDetailInfo.rnIncWarn
  );

  // 1の位を切り捨て
  // graphData.min10.spec.rain.max = valueCeil(graphData.min10.spec.rain.max, 10);
  // graphData.min10.spec.total.max = valueCeil(
  //   graphData.min10.spec.total.max,
  //   10
  // );

  // 最大値セット
  // graphData.min10.spec.rain.max = graphMaxAdd(
  //   graphData.min10.spec.rain.max,
  //   bsnGraphMin10MaxAdd,
  //   bsnGraphMin10Max
  // );
  // graphData.min10.spec.total.max = graphMaxAdd(
  //   graphData.min10.spec.total.max,
  //   bsnGraphTotalMaxAdd,
  //   bsnGraphTotalMax
  // );

  // 上限値・下限値の値調整
  // graphData.min10.spec.rain.max = roundMax(
  //   graphData.min10.spec.rain.max,
  //   bsnGraphMin10MaxAdd,
  //   bsnGraphMin10Max,
  //   10
  // );
  // graphData.min10.spec.total.max = roundMax(
  //   graphData.min10.spec.total.max,
  //   bsnGraphTotalMaxAdd,
  //   bsnGraphTotalMax,
  //   10
  // );

  // 時間グラフデータ
  for (var j = 0; j < obsData.tmBsnDetailObs.bsnrnHrList.length; j++) {
    graphData.hour.spec.rain.max = mathMax(
      graphData.hour.spec.rain.max,
      checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHr,
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHrCcd
      )
    );
    graphData.hour.spec.total.max = mathMax(
      graphData.hour.spec.total.max,
      checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnIncCcd
      )
    );

    graphData.hour.value.push({
      date: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHr,
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHrCcd
      ),
      total: checkCcdForGraph(
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.hour.spec.rain.max = mathMax(
    graphData.hour.spec.rain.max,
    obsData.tmBsnDetailInfo.rnHrCaut,
    obsData.tmBsnDetailInfo.rnHrWarn
  );
  graphData.hour.spec.total.max = mathMax(
    graphData.hour.spec.total.max,
    obsData.tmBsnDetailInfo.rnIncCaut,
    obsData.tmBsnDetailInfo.rnIncWarn
  );

  // 1の位を切り捨て
  // graphData.hour.spec.rain.max = valueCeil(graphData.hour.spec.rain.max, 10);
  // graphData.hour.spec.total.max = valueCeil(graphData.hour.spec.total.max, 10);

  // // 最大値セット
  // graphData.hour.spec.rain.max = graphMaxAdd(
  //   graphData.hour.spec.rain.max,
  //   bsnGraphHourMaxAdd,
  //   bsnGraphHourMax
  // );
  // graphData.hour.spec.total.max = graphMaxAdd(
  //   graphData.hour.spec.total.max,
  //   bsnGraphTotalMaxAdd,
  //   bsnGraphTotalMax
  // );

  // // 上限値・下限値の値調整
  // graphData.hour.spec.rain.max = roundMax(
  //   graphData.hour.spec.rain.max,
  //   bsnGraphHourMaxAdd,
  //   bsnGraphHourMax,
  //   10
  // );
  // graphData.hour.spec.total.max = roundMax(
  //   graphData.hour.spec.total.max,
  //   bsnGraphTotalMaxAdd,
  //   bsnGraphTotalMax,
  //   10
  // );

  // 10分と時間で、上限を合わせる
  graphData.hour.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    graphData.hour.spec.rain.max
  );

  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    graphData.hour.spec.total.max
  );

  let difMin10Rain =
    graphData.min10.spec.rain.max - graphData.min10.spec.rain.min;
  let quarterMin10Rain = difMin10Rain / 4;

  if (quarterMin10Rain <= 10) {
    // <=10は10
    quarterMin10Rain = 10;
  } else if (quarterMin10Rain > 10 && quarterMin10Rain <= 20) {
    // 10<かつ<=20は20
    quarterMin10Rain = 20;
  } else if (quarterMin10Rain > 20 && quarterMin10Rain <= 30) {
    // 20<かつ<=30は30
    quarterMin10Rain = 30;
  } else if (quarterMin10Rain > 30 && quarterMin10Rain <= 40) {
    // 30<かつ<=40は40
    quarterMin10Rain = 40;
  } else {
    // 40<かつ<=50は50
    quarterMin10Rain = 50;
  }

  graphData.min10.spec.rain.max =
    graphData.min10.spec.rain.min + quarterMin10Rain * 4;

  let difHourRain = graphData.hour.spec.rain.max - graphData.hour.spec.rain.min;
  let quarterHourRain = difHourRain / 4;

  if (quarterHourRain <= 20) {
    // <=20は20
    quarterHourRain = 20;
  } else if (quarterHourRain > 20 && quarterHourRain <= 30) {
    // 20<かつ<=30は30
    quarterHourRain = 30;
  } else if (quarterHourRain > 30 && quarterHourRain <= 40) {
    // 30<かつ<=40は40
    quarterHourRain = 40;
  } else {
    // 40<かつ<=50は50
    quarterHourRain = 50;
  }

  graphData.hour.spec.rain.max =
    graphData.hour.spec.rain.min + quarterHourRain * 4;

  if (graphData.min10.spec.rain.max < graphData.hour.spec.rain.max) {
    graphData.min10.spec.rain.max = graphData.hour.spec.rain.max;
  }

  let difMin10Total =
    graphData.min10.spec.total.max - graphData.min10.spec.total.min;
  let quarterMin10Total = difMin10Total / 4;

  if (quarterMin10Total <= 50) {
    // <=50は50
    quarterMin10Total = 50;
  } else if (quarterMin10Total > 50 && quarterMin10Total <= 100) {
    // <=100は100
    quarterMin10Total = 100;
  } else if (quarterMin10Total > 100 && quarterMin10Total <= 200) {
    // 100<かつ<=200は200
    quarterMin10Total = 200;
  } else if (quarterMin10Total > 200 && quarterMin10Total <= 500) {
    // 200<かつ<=500は500
    quarterMin10Total = 500;
  } else {
    // 500<は750
    quarterMin10Total = 750;
  }

  graphData.min10.spec.total.max =
    graphData.min10.spec.total.min + quarterMin10Total * 4;

  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  return graphData;
}

/**
 * [流域平均観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataBsnValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < obsData.tmBsnDetailObs.bsnrn10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10m,
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10mCcd,
        1
      ),
      total: checkCcd(
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnIncCcd,
        1
      ),
    });

    let copyMin10Value =
      Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10m,
        obsData.tmBsnDetailObs.bsnrn10mList[i].bsnrn10mCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrn10mIncList[i].bsnrnIncCcd,
        1
      );
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(
      obsData.tmBsnDetailObs.bsnrn10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  // 時間観測値一覧データ
  obsTimeBefore = null;
  for (var j = 0; j < obsData.tmBsnDetailObs.bsnrnHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHr,
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHrCcd,
        1
      ),
      total: checkCcd(
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnIncCcd,
        1
      ),
    });

    let copyHrValue =
      Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHr,
        obsData.tmBsnDetailObs.bsnrnHrList[j].bsnrnHrCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnInc,
        obsData.tmBsnDetailObs.bsnrnHrIncList[j].bsnrnIncCcd,
        1
      );
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmBsnDetailObs.bsnrnHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

//------------------------------------------------------------
/**
 * [積雪観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 * @param {*} graphConfig グラフ設定
 */
function convertObsSnow(obsData, graphConfig) {
  return {
    tmSnwDetailInfo: obsData.tmSnwDetailInfo,
    obsInfo: createDataSnowObsInfo(obsData),
    curt: createDataSnowCurt(obsData),
    graph: createDataSnowGraph(obsData, graphConfig),
    obsValues: createDataSnowValues(obsData),
    codeInfo: createDataSnowCodeInfo(obsData),
  };
}

/**
 * [積雪観測所情報]観測所情報
 * @param {*} obsData 観測所情報
 */
function createDataSnowObsInfo(obsData) {
  const info = obsData.tmSnwDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
    {
      title: "標高",
      value: formatFloat(info.alti),
      unit: "m",
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [積雪観測所情報]観測所情報
 * @param {*} obsData 観測所情報
 */
function createDataSnowCurt(obsData) {
  const info = obsData.tmSnwDetailInfo;
  return {
    category: [
      {
        title: "積雪深",
        value: checkCcd(info.snwdp, info.snwdpCcd),
        unit: checkCcdOfUnit("cm", info.snwdpCcd),
      },
      {
        title: "気温",
        value: checkCcd(info.tmp, info.tmpCcd, 1),
        unit: checkCcdOfUnit("℃", info.tmpCcd),
      },
    ],
    obs: [
      {
        title: "気温",
        value: checkCcd(info.tmp, info.tmpCcd, 1),
        unit: checkCcdOfUnit("℃", info.tmpCcd),
      },
      {
        title: "積雪深",
        value: checkCcd(info.snwdp, info.snwdpCcd),
        unit: checkCcdOfUnit("cm", info.snwdpCcd),
      },
    ],
    obsTime: !checkNotCollected(3, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [積雪観測所情報]観測所情報
 * @param {*} obsData 観測所情報
 * @param {*} graphConfig グラフ設定
 */
function createDataSnowGraph(obsData, graphConfig) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        snow: {
          max: null,
          lvl6: graphConfig.snow.snowGraphLvl6,
          lvl5: graphConfig.snow.snowGraphLvl5,
          lvl4: graphConfig.snow.snowGraphLvl4,
          lvl3: graphConfig.snow.snowGraphLvl3,
          lvl2: graphConfig.snow.snowGraphLvl2,
          lvl1: graphConfig.snow.snowGraphLvl1,
          min: snowGraphMin,
          title: "積雪深",
          unit: "cm",
        },
        tmp: {
          max: null,
          min: null,
          title: "気温",
          unit: "℃",
        },
      },
      value: [],
    },
  };

  // let tmpMissingFlg = true; // 気温「閉局」「欠測」フラグ
  // let snwMissingFlg = true; // 積雪深「閉局」「欠測」フラグ

  // 観測値の合計値
  // let snwPointSum = 0.0;

  // 有効な観測所データデータカウント数
  // let snwValifPontCount = 0;

  const snwList = obsData.tmSnwDetailObs.snwList;

  // グラフデータ
  for (let i = 0; i < snwList.length; i++) {
    // 積雪深
    graphData.hour.spec.snow.max = mathMax(
      graphData.hour.spec.snow.max,
      checkCcdForGraph(snwList[i].snwdp, snwList[i].snwdpCcd)
    );

    // 積雪深内容コードが「閉局」「欠測」以外のフラグを変更
    if (!isInvalid(snwList[i].snwdpCcd)) {
      // 有効な内容コードあり
      // snwMissingFlg = false;
    }

    // 気温
    // 気温の上限値は観測値の平均値のため、合計値を算出
    // snwPointSum += checkCcdForGraph(snwList[i].tmp, snwList[i].tmpCcd);

    // 気温の最小値
    graphData.hour.spec.tmp.min = mathMin(
      graphData.hour.spec.tmp.min,
      checkCcdForGraph(snwList[i].tmp, snwList[i].tmpCcd)
    );
    // 気温の最大値
    graphData.hour.spec.tmp.max = mathMax(
      graphData.hour.spec.tmp.max,
      checkCcdForGraph(snwList[i].tmp, snwList[i].tmpCcd)
    );

    // 気温内容コードが「閉局」「欠測」以外のフラグを変更
    // if (!isInvalid(snwList[i].tmpCcd)) {
    //   // 有効な内容コードあり
    //   tmpMissingFlg = false;
    //   snwValifPontCount++;
    // }

    graphData.hour.value.push({
      date: Util.formatDate24(snwList[i].obsTime, "YYYY/MM/DD"),
      time: Util.formatDate24(snwList[i].obsTime, "HH:mm"),
      snwdp: checkCcdForGraph(snwList[i].snwdp, snwList[i].snwdpCcd),
      tmp: checkCcdForGraph(snwList[i].tmp, snwList[i].tmpCcd),
    });
  }

  // 気温の上限値に観測値の平均値をセット
  // graphData.hour.spec.tmp.max = valueCeil(
  //   snwPointSum / snwValifPontCount,
  //   0.001
  // );

  // 積雪深全データ「閉局」「欠測」の場合max変更
  // if (snwMissingFlg) {
  //   // 有効な内容コードなし
  //   graphData.hour.spec.snow.max = snowGraphClosingMax;
  // }
  // else {
  //   // 有効な内容コードあり
  //   graphData.hour.spec.snow.max = graphMaxAdd(
  //     graphData.hour.spec.snow.max,
  //     snowGraphAdd,
  //     snowGraphMax
  //   );

  //   // 小数点第1位以下を切り捨て
  //   graphData.hour.spec.snow.max = valueCeil(graphData.hour.spec.snow.max, 1);

  //   // 上限値の値調整
  //   graphData.hour.spec.snow.max = roundMax(
  //     graphData.hour.spec.snow.max,
  //     snowGraphAdd,
  //     snowGraphMax,
  //     1
  //   );
  // }

  // 気温全データ「閉局」「欠測」の場合max min変更
  // if (tmpMissingFlg) {
  //   // 有効な内容コードなし
  //   graphData.hour.spec.tmp.max = snowGraphTmpClosingMax;
  //   graphData.hour.spec.tmp.min = snowGraphTmpClosingMin;
  // }

  // else {
  //   // 有効な内容コードあり
  //   graphData.hour.spec.tmp.max = graphMaxAdd(
  //     graphData.hour.spec.tmp.max,
  //     snowGraphTmpInt,
  //     snowGraphTmpMax
  //   );
  //   graphData.hour.spec.tmp.min = graphMinAdd(
  //     graphData.hour.spec.tmp.min,
  //     snowGraphTmpInt,
  //     snowGraphTmpMin
  //   );

  //   // 小数点第2位以下を切り捨て
  //   graphData.hour.spec.tmp.max = valueCeil(graphData.hour.spec.tmp.max, 0.1);
  //   graphData.hour.spec.tmp.min = valueCeil(graphData.hour.spec.tmp.min, 0.1);

  //   // 上限値・下限値の値調整
  //   graphData.hour.spec.tmp.max = roundMax(
  //     graphData.hour.spec.tmp.max,
  //     snowGraphTmpAdd,
  //     snowGraphTmpMax,
  //     0.1
  //   );
  //   graphData.hour.spec.tmp.min = roundMin(
  //     graphData.hour.spec.tmp.min,
  //     snowGraphTmpAdd,
  //     snowGraphTmpMin,
  //     0.1
  //   );
  // }

  // [気温]グラフの上限値～下限値の最小は40.0℃幅となるようにする。
  // if (
  //   graphData.hour.spec.tmp.max - graphData.hour.spec.tmp.min >
  //   snowGraphTmpSpanMax
  // ) {
  //   graphData.hour.spec.tmp.max =
  //     graphData.hour.spec.tmp.min + snowGraphTmpSpanMax;
  // }

  // 積雪深

  // 上端：最大値の小数点第一位を切り上げる
  // 下端：常に０
  graphData.hour.spec.snow.max = Math.ceil(graphData.hour.spec.snow.max);

  let difHourSnow = graphData.hour.spec.snow.max - graphData.hour.spec.snow.min;
  let quarterHourSnow = difHourSnow / 4;

  if (quarterHourSnow <= 20) {
    // <=20は20
    quarterHourSnow = 20;
  } else if (quarterHourSnow <= 50) {
    // 20<かつ<=50は50
    quarterHourSnow = 50;
  } else if (quarterHourSnow <= 100) {
    // 50<かつ<=100は100
    quarterHourSnow = 100;
  } else if (quarterHourSnow <= 200) {
    // 100<かつ<=200は200
    quarterHourSnow = 200;
  } else {
    // 200<かつ<=400は400
    quarterHourSnow = 400;
  }

  graphData.hour.spec.snow.max =
    graphData.hour.spec.snow.min + quarterHourSnow * 4;

  // 気温

  // 上端：最大値の小数点第一位を切り上げる
  // 下端：最小値の小数点第一位を切り下げる
  graphData.hour.spec.tmp.max = Math.ceil(graphData.hour.spec.tmp.max);
  graphData.hour.spec.tmp.min = Math.floor(graphData.hour.spec.tmp.min);

  let difHourTmp = graphData.hour.spec.tmp.max - graphData.hour.spec.tmp.min;
  let quarterHourTmp = difHourTmp / 4;

  if (quarterHourTmp <= 2) {
    // <=2は2
    quarterHourTmp = 2;
  } else if (quarterHourTmp <= 10) {
    // 2<かつ<=10は、小数点第一位を切り上げ
    quarterHourTmp = Math.ceil(quarterHourTmp);
  } else {
    // １０<以上は、一の位を切り上げ5の倍数
    quarterHourTmp = Math.ceil(quarterHourTmp / 5) * 5;
  }

  graphData.hour.spec.tmp.max =
    graphData.hour.spec.tmp.min + quarterHourTmp * 4;

  return graphData;
}

/**
 * [積雪観測所情報]観測所情報
 * @param {*} obsData 観測所情報
 */
function createDataSnowValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "積雪深[cm]",
          align: "center",
          value: "snwdp",
          width: "25%",
        },
        {
          text: "気温[℃]",
          align: "center",
          value: "tmp",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };
  // コピー用データのヘッダー追加
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 時間観測値一覧データ
  for (var j = 0; j < obsData.tmSnwDetailObs.snwList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmSnwDetailObs.snwList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmSnwDetailObs.snwList[j].obsTime,
        "HH:mm"
      ),
      snwdp: checkCcd(
        obsData.tmSnwDetailObs.snwList[j].snwdp,
        obsData.tmSnwDetailObs.snwList[j].snwdpCcd
      ),
      tmp: checkCcd(
        obsData.tmSnwDetailObs.snwList[j].tmp,
        obsData.tmSnwDetailObs.snwList[j].tmpCcd,
        1
      ),
    });

    let copyHrValue =
      Util.formatDate24(obsData.tmSnwDetailObs.snwList[j].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmSnwDetailObs.snwList[j].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmSnwDetailObs.snwList[j].snwdp,
        obsData.tmSnwDetailObs.snwList[j].snwdpCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmSnwDetailObs.snwList[j].tmp,
        obsData.tmSnwDetailObs.snwList[j].tmpCcd,
        1
      );
    checkCcd(
      obsData.tmSnwDetailObs.snwList[j].tmp,
      obsData.tmSnwDetailObs.snwList[j].tmpCcd,
      1
    );
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmSnwDetailObs.snwList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

/**
 * [積雪観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataSnowCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmSnwDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [水位観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function convertObsStage(obsData, stgMsg) {
  // 「上流の観測所での基準値超過または、ダムの放流があります。」の 表示／非表示 設定
  // 下記2つのいずれか(OR条件)
  let warningFlg = false;
  // 1. 自身の観測所より上流観測所の水位テーブル[tr_stg].基準水位超過[stg_ovlvl]と比較し、『上流観測所』がランクが上である場合
  // ランク: 0:超過無し、1:水防団待機水位超過、2:氾濫注意水位超過、3:出動水位超過、4:避難判断水位超過、5:氾濫危険水位超過、6:計画高水位超過、7:氾濫開始水位超過
  //    (個別観測所の最新観測値に表示されている上流観測所が対象になるので、さらに上流まで遡る必要はない。)
  if (obsData.tmStgDetailInfo.upStgOvlvl !== null) {
    if (obsData.tmStgDetailInfo.stgOvlvl === null) {
      if (0 < obsData.tmStgDetailInfo.upStgOvlvl) {
        warningFlg = true;
      }
    } else {
      if (
        obsData.tmStgDetailInfo.stgOvlvl < obsData.tmStgDetailInfo.upStgOvlvl
      ) {
        warningFlg = true;
      }
    }
  }
  // 2. ダム放流通知を発令中のダム観測所があり、その下流水位観測所が自身の観測所だった場合
  //    ⇒下流水位観測所･･･ダム諸量観測所マスタ[mt_damobs]の下流水位観測所伝送記号[dw_stg_obs_fcd]
  if (obsData.tmStgDetailInfo.damRlsCnt !== null) {
    if (obsData.tmStgDetailInfo.damRlsCnt > 0) {
      warningFlg = true;
    }
  }

  return {
    tmStgDetailInfo: obsData.tmStgDetailInfo,
    tmStgAdditionalInfo: obsData.tmStgAdditionalInfo,
    warningFlg: warningFlg,
    obsInfo: createDataStageObsInfo(obsData),
    standardValue: createDataStageStandardValue(obsData),
    cctvInfo: createDataStageCctvInfo(obsData),
    curt: createDataStageCurt(obsData, stgMsg),
    graph: createDataStageGraph(obsData, stgMsg),
    obsValues: createDataStageValues(obsData, stgMsg),
    xsec: createDataStageXsec(obsData),
    codeInfo: createDataStageCodeInfo(obsData),
  };
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataStageObsInfo(obsData) {
  const info = obsData.tmStgDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  let codeParamLinkObs = "";
  if (info.reprnObsCd !== null && global.KWB_MODE === "admin") {
    codeParamLinkObs =
      codeParamHeadLinkObs + info.reprnObsCd + codeParamTailLinkObs;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
      unit: "",
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "水位標のゼロ点高(T.P.)",
      value: formatFloatRound(info.zeroHighFix, 2),
      unit: "m",
    },
    {
      title: "左右岸",
      value: formatFloat(info.bnkSct),
    },
    {
      title: "関連雨量観測所",
      value:
        info.reprnItmkndCd == 2 ||
        info.reprnItmkndCd == 20 ||
        info.reprnItmkndCd == 21
          ? "--"
          : formatFloat(info.reprnObsNm),
      ofcCd: formatFloat(info.reprnOfcCd),
      itmkndCd: info.reprnItmkndCd,
      obsCd: formatFloat(info.reprnObsCd),
      code: codeParamLinkObs,
    },
    {
      title: "河口または合流点からの距離",
      value: formatFloat(info.rvrMouthDst),
      unit: "m",
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      rankValue: "水位ランキング",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataStageStandardValue(obsData) {
  const info = obsData.tmStgDetailInfo;
  return [
    {
      title: "氾濫開始水位",
      value: [formatFloat(info.fldStg, 2), 0],
      unit: "m",
    },
    {
      title: "氾濫危険水位",
      value: [
        formatFloat(info.dngStg, 2),
        formatFloat(info.dngStgDiffTopendHght, 2),
      ],
      unit: "m",
    },
    {
      title: "避難判断水位",
      value: [
        formatFloat(info.spclWarnStg, 2),
        formatFloat(info.spclWarnStgDiffTopendHght, 2),
      ],
      unit: "m",
    },
    {
      title: "氾濫注意水位",
      value: [
        formatFloat(info.warnStg, 2),
        formatFloat(info.warnStgDiffTopendHght, 2),
      ],
      unit: "m",
    },
    {
      title: "水防団待機水位",
      value: [
        formatFloat(info.rsrvStg, 2),
        formatFloat(info.rsrvStgDiffTopendHght, 2),
      ],
      unit: "m",
    },
  ];
}

/**
 * [水位観測所情報]河川カメラ情報
 * @param {*} obsData 観測所情報
 */
function createDataStageCctvInfo(obsData) {
  let result = {
    latestUrl: obsData.tmStgDetailInfo.currProvUrl,
    usualUrl: obsData.tmStgDetailInfo.normProvUrl,
    subLatestUrl: obsData.tmStgDetailInfo.currentUrl,
    subUsualUrl: obsData.tmStgDetailInfo.normallyUrl,
    liveUrl: obsData.tmStgDetailInfo.liveUrl,
    sysId: obsData.tmStgDetailInfo.sysId,
  };
  return result;
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function createDataStageCurt(obsData, stgMsg) {
  const info = obsData.tmStgDetailInfo;
  return {
    category: {
      stg: {
        title: stgMsg.normalStgHght,
        mobile_title: stgMsg.normalStg,
        currentObsValue: checkCcd(info.stg, info.stgCcd, 2),
        currentObsValueValid: checkCcdBoolean(info.stg, info.stgCcd),
      },
      stgHght: {
        title: stgMsg.topendStgHght,
        mobile_title: stgMsg.topendStg,
        currentObsValue: checkCcd(info.stgDiffTopendHght, info.stgCcd, 2),
        currentObsValueValid: checkCcdBoolean(
          info.stgDiffTopendHght,
          info.stgCcd
        ),
      },
      currentObsUnit: checkCcdOfUnit("m", info.stgCcd),
      stgLtstChg: checkCcd(info.stgLtstChg, info.stgLtstChgCcd),
      stg10mChg: checkCcd(info.stg10mChg, info.stg10mChgCcd),
      isAbnrml: info.stgQmflg !== null && info.stgQmflg !== 0,
      stgOvlvl: info.stgOvlvl,
      stgCcd: info.stgCcd,
      rsrvStg: info.rsrvStg,
      warnStg: info.warnStg,
      spclWarnStg: info.spclWarnStg,
      dngStg: info.dngStg,
      fldStg: info.fldStg,
      dspFlg: info.dspFlg,
      upObsTitle: "上流観測所",
      upStg: {
        upObsValue: checkCcd(info.upStg, info.upStgCcd, 2),
        upObsValueValid: checkCcdBoolean(info.upStg, info.upStgCcd),
      },
      upStgHght: {
        upObsValue: checkCcd(info.upStgDiffTopendHght, info.upStgCcd, 2),
        upObsValueValid: checkCcdBoolean(
          info.upStgDiffTopendHght,
          info.upStgCcd
        ),
      },
      upObsUnit: checkCcdOfUnit("m", info.upStgCcd),
      upStgLtstChg: checkCcd(info.upStgLtstChg, info.upStgLtstChgCcd),
      upStg10mChg: checkCcd(info.upStg10mChg, info.upStg10mChgCcd),
      isAbnrmlUp: info.upStgQmflg !== null && info.upStgQmflg !== 0,
      upStgParam: formatParam(
        info.upStgOfcCd,
        info.upStgItmkndCd,
        info.upStgObsCd
      ),
      upStgOvlvl: info.upStgOvlvl,
      upStgCcd: info.upStgCcd,
      upRsrvStg: info.upRsrvStg,
      upWarnStg: info.upWarnStg,
      upSpclWarnStg: info.upSpclWarnStg,
      upDngStg: info.upDngStg,
      upFldStg: info.upFldStg,
      upDspFlg: info.upDspFlg,
      downObsTitle: "下流観測所",
      dwStg: {
        downObsValue: checkCcd(info.dwStg, info.dwStgCcd, 2),
        downObsValueValid: checkCcdBoolean(info.dwStg, info.dwStgCcd),
      },
      dwStgHght: {
        downObsValue: checkCcd(info.dwStgDiffTopendHght, info.dwStgCcd, 2),
        downObsValueValid: checkCcdBoolean(
          info.dwStgDiffTopendHght,
          info.dwStgCcd
        ),
      },
      downObsUnit: checkCcdOfUnit("m", info.dwStgCcd),
      dwStgLtstChg: checkCcd(info.dwStgLtstChg, info.dwStgLtstChgCcd),
      dwStg10mChg: checkCcd(info.dwStg10mChg, info.dwStg10mChgCcd),
      isAbnrmlDw: info.dwStgQmflg !== null && info.dwStgQmflg !== 0,
      dwStgParam: formatParam(
        info.dwStgOfcCd,
        info.dwStgItmkndCd,
        info.dwStgObsCd
      ),
      dwStgOvlvl: info.dwStgOvlvl,
      dwStgCcd: info.dwStgCcd,
      dwRsrvStg: info.dwRsrvStg,
      dwWarnStg: info.dwWarnStg,
      dwSpclWarnStg: info.dwSpclWarnStg,
      dwDngStg: info.dwDngStg,
      dwFldStg: info.dwFldStg,
      dwDspFlg: info.dwDspFlg,
    },
    obs: [
      {
        title: [stgMsg.normalStgHght, stgMsg.topendStgHght],
        value: [
          checkCcd(info.stg, info.stgCcd, 2),
          checkCcd(info.stgDiffTopendHght, info.stgCcd, 2),
        ],
        valueValid: checkCcdBoolean(info.stg, info.stgCcd),
        valueStgHghtValid: checkCcdBoolean(info.stgDiffTopendHght, info.stgCcd),
        unit: checkCcdOfUnit("m", info.stgCcd),
      },
      {
        title: "時間雨量",
        value: checkCcd(info.reprnRnHr10m, info.reprnRnHr10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.reprnRnHr10mCcd),
      },
      {
        title: "10分雨量",
        value: checkCcd(info.reprnRn10m, info.reprnRn10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.reprnRn10mCcd),
      },
      {
        title: "降り始めからの雨量",
        value: checkCcd(info.reprnRnInc, info.reprnRnIncCcd, 1),
        unit: checkCcdOfUnit("mm", info.reprnRnIncCcd),
      },
    ],
    obsTime: !checkNotCollected(4, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function createDataStageGraph(obsData, stgMsg) {
  let stgHghtMin10Min = 0;
  let stgHghtHrMin = 0;

  // 観測値から最大値と最小値を取得する
  let tmMin = getStgListMinValue(
    obsData.tmStgDetailObs.stg10mList,
    obsData.tmStgDetailObs.stgHrList,
    obsData.tmStgDetailObs.predStgList
  );
  let tmMax = getStgListMaxValue(
    obsData.tmStgDetailObs.stg10mList,
    obsData.tmStgDetailObs.stgHrList,
    obsData.tmStgDetailObs.predStgList
  );

  // 下端：最下位の値の小数点第一位を切り捨て
  if (tmMin.min10StgHght != null) {
    stgHghtMin10Min = Math.floor(tmMin.min10StgHght);
  }
  if (tmMin.hrStgHght != null) {
    stgHghtHrMin = Math.floor(tmMin.hrStgHght);
  }
  if (tmMin.min10Stg != null) {
    tmMin.min10Stg = Math.floor(tmMin.min10Stg);
  }

  let stgHghtMin10Max = 1;
  let stgHghtHrMax = 1;
  // 堤防天端からの高さの上限値を取得する
  // 小数点切り上げ
  let ruStgHghtMin10Max = roundUpValue(tmMax.min10StgHght, 1);
  let ruStgHghtHrMax = roundUpValue(tmMax.hrStgHght, 1);

  if (1 < ruStgHghtMin10Max && ruStgHghtMin10Max < 5) {
    // 切り上げ値が1より大きく、5以下の場合は切り上げ値を上限値に設定する
    stgHghtMin10Max = ruStgHghtMin10Max;
  } else if (5 <= ruStgHghtMin10Max) {
    // 切り上げ値が5より大きい場合は5を上限値に設定する
    stgHghtMin10Max = 5;
  }
  if (1 < ruStgHghtHrMax && ruStgHghtHrMax < 5) {
    stgHghtHrMax = ruStgHghtHrMax;
  } else if (5 <= ruStgHghtHrMax) {
    stgHghtHrMax = 5;
  }

  // 河床からの下限値を取得する
  // 基準値の最小値と最大値を取得する
  let minStandardValue = getMinStandardVlue(
    obsData.tmStgDetailInfo.rsrvStg,
    obsData.tmStgDetailInfo.warnStg,
    obsData.tmStgDetailInfo.spclWarnStg,
    obsData.tmStgDetailInfo.dngStg,
    obsData.tmStgDetailInfo.fldStg
  );
  let maxStandardValue = getMaxStandardVlue(
    obsData.tmStgDetailInfo.fldStg,
    obsData.tmStgDetailInfo.dngStg,
    obsData.tmStgDetailInfo.spclWarnStg,
    obsData.tmStgDetailInfo.warnStg,
    obsData.tmStgDetailInfo.rsrvStg
  );

  let stgMin10Top = null;
  let stgHrTop = null;

  // 氾濫開始水位がある場合はtopに設定する
  if (obsData.tmStgDetailInfo.fldStg != null) {
    stgMin10Top = obsData.tmStgDetailInfo.fldStg;
    stgHrTop = obsData.tmStgDetailInfo.fldStg;
  }

  // グラフ下限値を取得する
  let stgmin10Min = mathMin(tmMin.min10Stg, minStandardValue);
  let stgHrMin = mathMin(tmMin.hrStg, minStandardValue);

  // グラフ上限の基準値を取得する（この値から上限値を算出する）
  let stgmin10Max = mathMax(tmMax.min10Stg, maxStandardValue);
  let stgHrMax = mathMax(tmMax.hrStg, maxStandardValue);

  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        rain: {
          max: 0,
          min: stageGraphMin10Min,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: stageGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        level: {
          max: stgHrMax,
          top: stgHrTop != null ? valueCeil(stgHrTop, 0.1) : null,
          danger:
            obsData.tmStgDetailInfo.dngStg != null
              ? obsData.tmStgDetailInfo.dngStg
              : null,
          refuge:
            obsData.tmStgDetailInfo.spclWarnStg != null
              ? obsData.tmStgDetailInfo.spclWarnStg
              : null,
          warning:
            obsData.tmStgDetailInfo.warnStg != null
              ? obsData.tmStgDetailInfo.warnStg
              : null,
          standby:
            obsData.tmStgDetailInfo.rsrvStg != null
              ? obsData.tmStgDetailInfo.rsrvStg
              : null,
          min: stgHrMin,
          title: stgMsg.normalStgHght,
          unit: "m",
          topText: stgMsg.normalTop,
        },
        prediction: 0,
      },
      value: [],
      stage: [],
    },
    hourStgHght: {
      spec: {
        rain: {
          max: 0,
          min: stageGraphMin10Min,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: stageGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        level: {
          max: stgHghtHrMax,
          top: 0.0,
          danger:
            obsData.tmStgDetailInfo.dngStg != null
              ? obsData.tmStgDetailInfo.dngStgDiffTopendHght
              : null,
          refuge:
            obsData.tmStgDetailInfo.spclWarnStg != null
              ? obsData.tmStgDetailInfo.spclWarnStgDiffTopendHght
              : null,
          warning:
            obsData.tmStgDetailInfo.warnStg != null
              ? obsData.tmStgDetailInfo.warnStgDiffTopendHght
              : null,
          standby:
            obsData.tmStgDetailInfo.rsrvStg != null
              ? obsData.tmStgDetailInfo.rsrvStgDiffTopendHght
              : null,
          min: valueCeil(stgHghtHrMin, 0.1),
          title: stgMsg.topendStgHght,
          unit: "m",
          topText: stgMsg.topendTop,
        },
        prediction: 0,
      },
      value: [],
      stage: [],
    },
    min10: {
      spec: {
        rain: {
          max: 0,
          min: stageGraphHourMin,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: stageGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        level: {
          max: stgmin10Max,
          top: stgMin10Top != null ? valueCeil(stgMin10Top, 0.1) : null,
          danger:
            obsData.tmStgDetailInfo.dngStg != null
              ? obsData.tmStgDetailInfo.dngStg
              : null,
          refuge:
            obsData.tmStgDetailInfo.spclWarnStg != null
              ? obsData.tmStgDetailInfo.spclWarnStg
              : null,
          warning:
            obsData.tmStgDetailInfo.warnStg != null
              ? obsData.tmStgDetailInfo.warnStg
              : null,
          standby:
            obsData.tmStgDetailInfo.rsrvStg != null
              ? obsData.tmStgDetailInfo.rsrvStg
              : null,
          min: stgmin10Min,
          title: stgMsg.normalStgHght,
          unit: "m",
          topText: stgMsg.normalTop,
        },
        prediction: 0,
      },
      value: [],
      stage: [],
    },
    min10StgHght: {
      spec: {
        rain: {
          max: 0,
          min: stageGraphHourMin,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: stageGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        level: {
          max: stgHghtMin10Max,
          top: 0.0,
          danger:
            obsData.tmStgDetailInfo.dngStg != null
              ? obsData.tmStgDetailInfo.dngStgDiffTopendHght
              : null,
          refuge:
            obsData.tmStgDetailInfo.spclWarnStg != null
              ? obsData.tmStgDetailInfo.spclWarnStgDiffTopendHght
              : null,
          warning:
            obsData.tmStgDetailInfo.warnStg != null
              ? obsData.tmStgDetailInfo.warnStgDiffTopendHght
              : null,
          standby:
            obsData.tmStgDetailInfo.rsrvStg != null
              ? obsData.tmStgDetailInfo.rsrvStgDiffTopendHght
              : null,
          min: valueCeil(stgHghtMin10Min, 0.1),
          title: stgMsg.topendStgHght,
          unit: "m",
          topText: stgMsg.topendTop,
        },
        prediction: 0,
      },
      value: [],
      stage: [],
    },
    // 予測水位「現況」の時刻
    crntPredTime: obsData.tmStgDetailObs.crntPredTime,
  };

  // 10分グラフデータ
  for (var i = obsData.tmStgDetailObs.stg10mList.length - 1; 0 <= i; i--) {
    // 最大値/最小値格納
    graphData.min10.spec.rain.max = mathMax(
      graphData.min10.spec.rain.max,
      checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rn10m,
        obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
      )
    );
    graphData.min10.spec.total.max = mathMax(
      graphData.min10.spec.total.max,
      checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rnInc,
        obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
      )
    );

    graphData.min10.value.unshift({
      date: Util.formatDate24(
        obsData.tmStgDetailObs.stg10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stg10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rn10m,
        obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
      ),
      total: checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rnInc,
        obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
      ),
      level: checkCcdForGraphNullable(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd
      ),
    });

    graphData.min10.stage.unshift({
      date: Util.formatDate24(
        obsData.tmStgDetailObs.stg10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stg10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rn10m,
        obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
      ),
      total: checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].rnInc,
        obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
      ),
      level: checkCcdForGraph(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd
      ),
    });

    // 堤防天端からは氾濫開始水位がある場合のみ
    if (obsData.tmStgDetailInfo.dspFlg === 1) {
      graphData.min10StgHght.spec.rain.max = mathMax(
        graphData.min10StgHght.spec.rain.max,
        checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rn10m,
          obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
        )
      );
      graphData.min10StgHght.spec.total.max = mathMax(
        graphData.min10StgHght.spec.total.max,
        checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rnInc,
          obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
        )
      );
      graphData.min10StgHght.value.unshift({
        date: Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "YYYY/MM/DD"
        ),
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "HH:mm"
        ),
        rain: checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rn10m,
          obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
        ),
        total: checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rnInc,
          obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
        ),
        level: checkCcdForGraphNullable(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd
        ),
      });

      graphData.min10StgHght.stage.unshift({
        date: Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "YYYY/MM/DD"
        ),
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "HH:mm"
        ),
        rain: checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rn10m,
          obsData.tmStgDetailObs.stg10mList[i].rn10mCcd
        ),
        total: checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].rnInc,
          obsData.tmStgDetailObs.stg10mList[i].rnIncCcd
        ),
        level: checkCcdForGraph(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd
        ),
      });
    }
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    obsData.tmStgDetailInfo.reprn10mCaut,
    obsData.tmStgDetailInfo.reprn10mWarn
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    obsData.tmStgDetailInfo.reprnIncCaut,
    obsData.tmStgDetailInfo.reprnIncWarn
  );

  // 堤防天端から
  if (obsData.tmStgDetailInfo.dspFlg === 1) {
    graphData.min10StgHght.spec.rain.max = mathMax(
      graphData.min10StgHght.spec.rain.max,
      obsData.tmStgDetailInfo.reprn10mCaut,
      obsData.tmStgDetailInfo.reprn10mWarn
    );
    graphData.min10StgHght.spec.total.max = mathMax(
      graphData.min10StgHght.spec.total.max,
      obsData.tmStgDetailInfo.reprnIncCaut,
      obsData.tmStgDetailInfo.reprnIncWarn
    );
  }

  // 時間グラフデータ
  for (var j = obsData.tmStgDetailObs.stgHrList.length - 1; 0 <= j; j--) {
    graphData.hour.spec.rain.max = mathMax(
      graphData.hour.spec.rain.max,
      checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnHr,
        obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
      )
    );
    graphData.hour.spec.total.max = mathMax(
      graphData.hour.spec.total.max,
      checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnInc,
        obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
      )
    );

    graphData.hour.value.unshift({
      date: Util.formatDate24(
        obsData.tmStgDetailObs.stgHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stgHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnHr,
        obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
      ),
      total: checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnInc,
        obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
      ),
      level: checkCcdForGraphNullable(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd
      ),
    });

    graphData.hour.stage.unshift({
      date: Util.formatDate24(
        obsData.tmStgDetailObs.stgHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stgHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnHr,
        obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
      ),
      total: checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].rnInc,
        obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
      ),
      level: checkCcdForGraph(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd
      ),
    });

    if (obsData.tmStgDetailInfo.dspFlg === 1) {
      graphData.hourStgHght.spec.rain.max = mathMax(
        graphData.hourStgHght.spec.rain.max,
        checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnHr,
          obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
        )
      );
      graphData.hourStgHght.spec.total.max = mathMax(
        graphData.hourStgHght.spec.total.max,
        checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnInc,
          obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
        )
      );

      graphData.hourStgHght.value.unshift({
        date: Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "YYYY/MM/DD"
        ),
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "HH:mm"
        ),
        rain: checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnHr,
          obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
        ),
        total: checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnInc,
          obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
        ),
        level: checkCcdForGraphNullable(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd
        ),
      });

      graphData.hourStgHght.stage.unshift({
        date: Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "YYYY/MM/DD"
        ),
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "HH:mm"
        ),
        rain: checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnHr,
          obsData.tmStgDetailObs.stgHrList[j].rnHrCcd
        ),
        total: checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].rnInc,
          obsData.tmStgDetailObs.stgHrList[j].rnIncCcd
        ),
        level: checkCcdForGraph(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd
        ),
      });
    }
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.hour.spec.rain.max = mathMax(
    graphData.hour.spec.rain.max,
    obsData.tmStgDetailInfo.reprnHrCaut,
    obsData.tmStgDetailInfo.reprnHrWarn
  );
  graphData.hour.spec.total.max = mathMax(
    graphData.hour.spec.total.max,
    obsData.tmStgDetailInfo.reprnIncCaut,
    obsData.tmStgDetailInfo.reprnIncWarn
  );
  if (obsData.tmStgDetailInfo.dspFlg === 1) {
    graphData.hourStgHght.spec.rain.max = mathMax(
      graphData.hourStgHght.spec.rain.max,
      obsData.tmStgDetailInfo.reprnHrCaut,
      obsData.tmStgDetailInfo.reprnHrWarn
    );
    graphData.hourStgHght.spec.total.max = mathMax(
      graphData.hourStgHght.spec.total.max,
      obsData.tmStgDetailInfo.reprnIncCaut,
      obsData.tmStgDetailInfo.reprnIncWarn
    );
  }

  // 予測水位データ
  // 10分グラフ も 時間グラフ も同じ予測水位データを設定する
  if (obsData.tmStgDetailObs.predStgList) {
    const predStgListLength = obsData.tmStgDetailObs.predStgList.length;

    graphData.min10.spec.prediction = predStgListLength;
    graphData.hour.spec.prediction = predStgListLength;
    if (obsData.tmStgDetailInfo.dspFlg === 1) {
      graphData.min10StgHght.spec.prediction = predStgListLength;
      graphData.hourStgHght.spec.prediction = predStgListLength;
    }
    for (let k = predStgListLength - 1; 0 <= k; k--) {
      const predDate = Util.formatDate24(
        obsData.tmStgDetailObs.predStgList[k].obsTime,
        "YYYY/MM/DD"
      );
      const predTime = Util.formatDate24(
        obsData.tmStgDetailObs.predStgList[k].obsTime,
        "HH:mm"
      );
      const predLevel = obsData.tmStgDetailObs.predStgList[k].stg;

      // 零点高から
      const pred = {
        date: predDate,
        time: predTime,
        rain: null,
        total: null,
        level: predLevel,
      };
      // 10分グラフデータ
      graphData.min10.value.unshift(pred);
      graphData.min10.stage.unshift(pred);
      // 時間グラフデータ
      graphData.hour.value.unshift(pred);
      graphData.hour.stage.unshift(pred);

      if (obsData.tmStgDetailInfo.dspFlg === 1) {
        const predLevelHght =
          obsData.tmStgDetailObs.predStgList[k].stgDiffTopendHght;
        // 堤防天端から
        const predHght = {
          date: predDate,
          time: predTime,
          rain: null,
          total: null,
          level: predLevelHght,
        };

        graphData.min10StgHght.value.unshift(predHght);
        graphData.min10StgHght.stage.unshift(predHght);
        graphData.hourStgHght.value.unshift(predHght);
        graphData.hourStgHght.stage.unshift(predHght);
      }
    }
  }

  // 10分と時間で、上下限を合わせる
  // 水位表示
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    graphData.hour.spec.rain.max
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    graphData.hour.spec.total.max
  );

  let difMin10Rain =
    graphData.min10.spec.rain.max - graphData.min10.spec.rain.min;
  let quarterMin10Rain = difMin10Rain / 4;

  if (quarterMin10Rain <= 10) {
    // <=10は10
    quarterMin10Rain = 10;
  } else if (quarterMin10Rain > 10 && quarterMin10Rain <= 20) {
    // 10<かつ<=20は20
    quarterMin10Rain = 20;
  } else if (quarterMin10Rain > 20 && quarterMin10Rain <= 30) {
    // 20<かつ<=30は30
    quarterMin10Rain = 30;
  } else if (quarterMin10Rain > 30 && quarterMin10Rain <= 40) {
    // 30<かつ<=40は40
    quarterMin10Rain = 40;
  } else {
    // 40<かつ<=50は50
    quarterMin10Rain = 50;
  }

  graphData.min10.spec.rain.max =
    graphData.min10.spec.rain.min + quarterMin10Rain * 4;

  let difHourRain = graphData.hour.spec.rain.max - graphData.hour.spec.rain.min;
  let quarterHourRain = difHourRain / 4;

  if (quarterHourRain <= 20) {
    // <=20は20
    quarterHourRain = 20;
  } else if (quarterHourRain > 20 && quarterHourRain <= 30) {
    // 20<かつ<=30は30
    quarterHourRain = 30;
  } else if (quarterHourRain > 30 && quarterHourRain <= 40) {
    // 30<かつ<=40は40
    quarterHourRain = 40;
  } else {
    // 40<かつ<=50は50
    quarterHourRain = 50;
  }

  graphData.hour.spec.rain.max =
    graphData.hour.spec.rain.min + quarterHourRain * 4;

  if (graphData.min10.spec.rain.max < graphData.hour.spec.rain.max) {
    graphData.min10.spec.rain.max = graphData.hour.spec.rain.max;
  }

  let difMin10Total =
    graphData.min10.spec.total.max - graphData.min10.spec.total.min;
  let quarterMin10Total = difMin10Total / 4;

  if (quarterMin10Total <= 50) {
    // <=50は50
    quarterMin10Total = 50;
  } else if (quarterMin10Total > 50 && quarterMin10Total <= 100) {
    // <=100は100
    quarterMin10Total = 100;
  } else if (quarterMin10Total > 100 && quarterMin10Total <= 200) {
    // 100<かつ<=200は200
    quarterMin10Total = 200;
  } else if (quarterMin10Total > 200 && quarterMin10Total <= 500) {
    // 200<かつ<=500は500
    quarterMin10Total = 500;
  } else {
    // 500<は750
    quarterMin10Total = 750;
  }

  graphData.min10.spec.total.max =
    graphData.min10.spec.total.min + quarterMin10Total * 4;

  // graphData.hour.spec.rain.max = graphData.min10.spec.rain.max;
  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  // 水位は上限-下限が2の倍数となるように上限を調整する
  let levelMin = mathMin(
    graphData.min10.spec.level.min,
    graphData.hour.spec.level.min
  );

  let levelMax = mathMax(
    graphData.min10.spec.level.max,
    graphData.hour.spec.level.max
  );

  // 基準値を含めて最大値を設定
  levelMax = mathMax(
    levelMax,
    obsData.tmStgDetailInfo.rsrvStg,
    obsData.tmStgDetailInfo.warnStg,
    obsData.tmStgDetailInfo.spclWarnStg,
    obsData.tmStgDetailInfo.dngStg,
    obsData.tmStgDetailInfo.fldStg
  );

  // 基準値を含めて最小値を設定
  levelMin = mathMin(
    levelMin,
    obsData.tmStgDetailInfo.rsrvStg,
    obsData.tmStgDetailInfo.warnStg,
    obsData.tmStgDetailInfo.spclWarnStg,
    obsData.tmStgDetailInfo.dngStg,
    obsData.tmStgDetailInfo.fldStg
  );

  // 上限：最上位の値の小数点第一位を切り上げ
  levelMax = Math.ceil(levelMax);
  // 下限：最下位の値の小数点第一位を切り捨て
  levelMin = Math.floor(levelMin);

  let minDiff = levelMax - levelMin;

  // 上下端差÷4
  // <=0.5の場合は0.5
  // 0.5<の場合は（上下端差÷4の切り上げ整数)
  let quarter = minDiff / 4;
  if (quarter <= 0.5) {
    quarter = 0.5;
  } else {
    quarter = Math.ceil(quarter);
  }

  // if (obsData.tmStgDetailInfo.fldStg != null) {
  //   // 氾濫開始水位がある場合は最大値を軸にして最小値を算出
  //   levelMin = stgMin10Top - quarter * 4;
  // } else {
  // それ以外の場合は、最大値を算出
  levelMax = levelMin + quarter * 4;
  // }

  graphData.min10.spec.level.min = levelMin;
  graphData.hour.spec.level.min = levelMin;
  graphData.min10.spec.level.max = levelMax;
  graphData.hour.spec.level.max = levelMax;

  // 堤防天端からの高さ表示
  // 堤防天端の高さ[10分]に10分雨量と累加雨量を格納
  graphData.min10StgHght.spec.rain.max = graphData.min10.spec.rain.max;
  graphData.min10StgHght.spec.total.max = graphData.min10.spec.total.max;
  // 堤防天端の高さ[時間]に時間雨量と累加雨量を格納
  graphData.hourStgHght.spec.rain.max = graphData.hour.spec.rain.max;
  graphData.hourStgHght.spec.total.max = graphData.hour.spec.total.max;

  // 観測データの最小値を設定
  let levelMinSH = mathMin(
    graphData.min10StgHght.spec.level.min,
    graphData.hourStgHght.spec.level.min
  );
  // 観測データの最大値を設定
  let levelMaxSH = mathMax(
    graphData.min10StgHght.spec.level.max,
    graphData.hourStgHght.spec.level.max
  );

  // 基準値を含めて最大値を設定
  levelMaxSH = mathMax(
    levelMaxSH,
    graphData.min10StgHght.spec.level.top,
    graphData.min10StgHght.spec.level.danger,
    graphData.min10StgHght.spec.level.refuge,
    graphData.min10StgHght.spec.level.standby,
    graphData.min10StgHght.spec.level.warning
  );

  // 基準値を含めて最小値を設定
  levelMinSH = mathMin(
    levelMinSH,
    graphData.min10StgHght.spec.level.top,
    graphData.min10StgHght.spec.level.danger,
    graphData.min10StgHght.spec.level.refuge,
    graphData.min10StgHght.spec.level.standby,
    graphData.min10StgHght.spec.level.warning
  );

  // 上限：最上位の値の小数点第一位を切り上げ
  levelMaxSH = Math.ceil(levelMaxSH);
  // 下限：最下位の値の小数点第一位を切り捨て
  levelMinSH = Math.floor(levelMinSH);

  let minDiffSH = levelMaxSH - levelMinSH;

  // 上下端差÷4
  // <=0.5の場合は0.5
  // 0.5<の場合は（上下端差÷4の切り上げ整数)
  let quarterSH = minDiffSH / 4;
  if (quarterSH <= 0.5) {
    quarterSH = 0.5;
  } else {
    quarterSH = Math.ceil(quarterSH);
  }

  levelMaxSH = levelMinSH + quarterSH * 4;

  graphData.min10StgHght.spec.level.min = levelMinSH;
  graphData.hourStgHght.spec.level.min = levelMinSH;
  graphData.min10StgHght.spec.level.max = levelMaxSH;
  graphData.hourStgHght.spec.level.max = levelMaxSH;

  return graphData;
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function createDataStageValues(obsData, stgMsg) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: stgMsg.normalStgHght + "[m]",
          align: "center",
          value: "level",
          width: "20%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "20%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "20%",
        },
      ],
      values: [],
      copyValues: [],
    },
    hourStgHght: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: stgMsg.topendStgHght + "[m]",
          align: "center",
          value: "level",
          width: "20%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "20%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "20%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: stgMsg.normalStgHght + "[m]",
          align: "center",
          value: "level",
          width: "20%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "20%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "20%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10StgHght: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: stgMsg.topendStgHght + "[m]",
          align: "center",
          value: "level",
          width: "20%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "20%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "20%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10StgHght.copyValues.push(
    getCopyHeader(valuesData.min10StgHght.headers)
  );
  valuesData.hourStgHght.copyValues.push(
    getCopyHeader(valuesData.hourStgHght.headers)
  );
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < obsData.tmStgDetailObs.stg10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmStgDetailObs.stg10mList[i].obsTime,
      "MM/DD"
    );

    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stg10mList[i].obsTime,
        "HH:mm"
      ),
      stgLevel: checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd,
        2
      ),
      stgLevelValid: checkCcdBoolean(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd
      ),
      stgChg: checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].stg10mChg,
        obsData.tmStgDetailObs.stg10mList[i].stg10mChgCcd
      ),
      stgOvlvl: obsData.tmStgDetailObs.stg10mList[i].stgOvlvl,
      stgOvlvlValid: checkCcdBoolean(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd
      ),
      rain: checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].rn10m,
        obsData.tmStgDetailObs.stg10mList[i].rn10mCcd,
        1
      ),
      total: checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].rnInc,
        obsData.tmStgDetailObs.stg10mList[i].rnIncCcd,
        1
      ),
      isAbnrml:
        obsData.tmStgDetailObs.stg10mList[i].stgQmflg !== null &&
        obsData.tmStgDetailObs.stg10mList[i].stgQmflg !== 0,
    });

    let copyMin10StgValue =
      Util.formatDate24(obsData.tmStgDetailObs.stg10mList[i].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmStgDetailObs.stg10mList[i].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].stg,
        obsData.tmStgDetailObs.stg10mList[i].stgCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].rn10m,
        obsData.tmStgDetailObs.stg10mList[i].rn10mCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stg10mList[i].rnInc,
        obsData.tmStgDetailObs.stg10mList[i].rnIncCcd,
        1
      );

    valuesData.min10.copyValues.push(copyMin10StgValue);

    // 堤防天端からは氾濫開始水位がある場合のみ
    if (obsData.tmStgDetailInfo.dspFlg === 1) {
      valuesData.min10StgHght.values.push({
        cd: i,
        date: obsTime,
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "HH:mm"
        ),
        stgLevel: checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd,
          2
        ),
        stgLevelValid: checkCcdBoolean(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd
        ),
        stgChg: checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].stg10mChg,
          obsData.tmStgDetailObs.stg10mList[i].stg10mChgCcd
        ),
        stgOvlvl: obsData.tmStgDetailObs.stg10mList[i].stgOvlvl,
        stgOvlvlValid: checkCcdBoolean(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd
        ),
        rain: checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].rn10m,
          obsData.tmStgDetailObs.stg10mList[i].rn10mCcd,
          1
        ),
        total: checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].rnInc,
          obsData.tmStgDetailObs.stg10mList[i].rnIncCcd,
          1
        ),
        isAbnrml:
          obsData.tmStgDetailObs.stg10mList[i].stgQmflg !== null &&
          obsData.tmStgDetailObs.stg10mList[i].stgQmflg !== 0,
      });

      // コピー用データ
      let copyMin10StgHghtValue =
        Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "MM/DD"
        ) +
        "\t" +
        Util.formatDate24(
          obsData.tmStgDetailObs.stg10mList[i].obsTime,
          "HH:mm"
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].diffTopendHght,
          obsData.tmStgDetailObs.stg10mList[i].stgCcd,
          2
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].rn10m,
          obsData.tmStgDetailObs.stg10mList[i].rn10mCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stg10mList[i].rnInc,
          obsData.tmStgDetailObs.stg10mList[i].rnIncCcd,
          1
        );

      valuesData.min10StgHght.copyValues.push(copyMin10StgHghtValue);
    }

    obsTimeBefore = Util.formatDate24(
      obsData.tmStgDetailObs.stg10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  obsTimeBefore = "";
  // 時間観測値一覧データ
  for (var j = 0; j < obsData.tmStgDetailObs.stgHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmStgDetailObs.stgHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmStgDetailObs.stgHrList[j].obsTime,
        "HH:mm"
      ),
      stgLevel: checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd,
        2
      ),
      stgLevelValid: checkCcdBoolean(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd
      ),
      stgChg: checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].stgHrChg,
        obsData.tmStgDetailObs.stgHrList[j].stgHrChgCcd
      ),
      stgOvlvl: obsData.tmStgDetailObs.stgHrList[j].stgOvlvl,
      stgOvlvlValid: checkCcdBoolean(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd
      ),
      rain: checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].rnHr,
        obsData.tmStgDetailObs.stgHrList[j].rnHrCcd,
        1
      ),
      total: checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].rnInc,
        obsData.tmStgDetailObs.stgHrList[j].rnIncCcd,
        1
      ),
      isAbnrml:
        obsData.tmStgDetailObs.stgHrList[j].stgQmflg !== null &&
        obsData.tmStgDetailObs.stgHrList[j].stgQmflg !== 0,
    });

    let copyHourStgValue =
      Util.formatDate24(obsData.tmStgDetailObs.stgHrList[j].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmStgDetailObs.stgHrList[j].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].stg,
        obsData.tmStgDetailObs.stgHrList[j].stgCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].rnHr,
        obsData.tmStgDetailObs.stgHrList[j].rnHrCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmStgDetailObs.stgHrList[j].rnInc,
        obsData.tmStgDetailObs.stgHrList[j].rnIncCcd,
        1
      );
    valuesData.hour.copyValues.push(copyHourStgValue);

    if (obsData.tmStgDetailInfo.dspFlg === 1) {
      valuesData.hourStgHght.values.push({
        cd: j,
        date: obsTime,
        time: Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "HH:mm"
        ),
        stgLevel: checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd,
          2
        ),
        stgLevelValid: checkCcdBoolean(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd
        ),
        stgChg: checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].stgHrChg,
          obsData.tmStgDetailObs.stgHrList[j].stgHrChgCcd
        ),
        stgOvlvl: obsData.tmStgDetailObs.stgHrList[j].stgOvlvl,
        stgOvlvlValid: checkCcdBoolean(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd
        ),
        rain: checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].rnHr,
          obsData.tmStgDetailObs.stgHrList[j].rnHrCcd,
          1
        ),
        total: checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].rnInc,
          obsData.tmStgDetailObs.stgHrList[j].rnIncCcd,
          1
        ),
        isAbnrml:
          obsData.tmStgDetailObs.stgHrList[j].stgQmflg !== null &&
          obsData.tmStgDetailObs.stgHrList[j].stgQmflg !== 0,
      });

      let copyHourStgHghtValue =
        Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "MM/DD"
        ) +
        "\t" +
        Util.formatDate24(
          obsData.tmStgDetailObs.stgHrList[j].obsTime,
          "HH:mm"
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].diffTopendHght,
          obsData.tmStgDetailObs.stgHrList[j].stgCcd,
          2
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].rnHr,
          obsData.tmStgDetailObs.stgHrList[j].rnHrCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmStgDetailObs.stgHrList[j].rnInc,
          obsData.tmStgDetailObs.stgHrList[j].rnIncCcd,
          1
        );
      valuesData.hourStgHght.copyValues.push(copyHourStgHghtValue);
    }
    obsTimeBefore = Util.formatDate24(
      obsData.tmStgDetailObs.stgHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataStageXsec(obsData) {
  for (var i = 0; i < obsData.crossDataObs.trStg10m.length; i++) {
    obsData.crossDataObs.trStg10m[i].elevation = checkCcdForGraph(
      obsData.crossDataObs.trStg10m[i].elevation,
      obsData.crossDataObs.trStg10m[i].stg_ccd
    );
    obsData.crossDataObs.trStg10m[i].date = Util.formatDate24(
      obsData.crossDataObs.trStg10m[i].date
    );
  }

  for (var j = 0; j < obsData.crossDataObs.trStg1h.length; j++) {
    obsData.crossDataObs.trStg1h[j].elevation = checkCcdForGraph(
      obsData.crossDataObs.trStg1h[j].elevation,
      obsData.crossDataObs.trStg1h[j].stg_ccd
    );
    obsData.crossDataObs.trStg1h[j].date = Util.formatDate24(
      obsData.crossDataObs.trStg1h[j].date
    );
  }

  obsData.crossDataObs.stgobs = {
    altiStdCd: obsData.tmStgDetailInfo.altiStdCd,
    zeroHigh: obsData.tmStgDetailInfo.zeroHigh,
    upgate1: obsData.tmStgDetailInfo.upgate1,
    upgate2: obsData.tmStgDetailInfo.upgate2,
    topendHght: obsData.tmStgDetailInfo.topendHght,
    drawType: obsData.tmStgDetailInfo.drawType,
    leftBnkHghtLat: obsData.tmStgDetailInfo.leftBnkHghtLat,
    leftBnkHghtLon: obsData.tmStgDetailInfo.leftBnkHghtLon,
    rightBnkHghtLat: obsData.tmStgDetailInfo.rightBnkHghtLat,
    rightBnkHghtLon: obsData.tmStgDetailInfo.rightBnkHghtLon,
    rsrvStg: obsData.tmStgDetailInfo.rsrvStg,
    rsrvStgTopendHght: obsData.tmStgDetailInfo.rsrvStgDiffTopendHght,
    warnStg: obsData.tmStgDetailInfo.warnStg,
    warnStgTopendHght: obsData.tmStgDetailInfo.warnStgDiffTopendHght,
    dsgnMoblzdStg: obsData.tmStgDetailInfo.dsgnMoblzdStg,
    spclWarnStg: obsData.tmStgDetailInfo.spclWarnStg,
    spclWarnStgTopendHght: obsData.tmStgDetailInfo.spclWarnStgDiffTopendHght,
    dngStg: obsData.tmStgDetailInfo.dngStg,
    dngStgTopendHght: obsData.tmStgDetailInfo.dngStgDiffTopendHght,
    dsgnHighStg: obsData.tmStgDetailInfo.dsgnHighStg,
    fldStg: obsData.tmStgDetailInfo.fldStg,
    fldStgTopendHght: obsData.tmStgDetailInfo.fldStgDiffTopendHght,
    zeroHighFix: obsData.tmStgDetailInfo.zeroHighFix,
    embDrawDist: obsData.tmStgDetailInfo.embDrawDist,
    drawPosMax: obsData.tmStgDetailInfo.drawPosMax,
    drawPosMin: obsData.tmStgDetailInfo.drawPosMin,
  };

  return obsData.crossDataObs;
}

/**
 * [水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataStageCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmStgDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [水質観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsWtrQual(obsData) {
  return {
    tmQwtrDetailInfo: obsData.tmQwtrDetailInfo,
    obsInfo: createDataQwtrObsInfo(obsData),
    standardValue: createDataQwtrStandardValue(obsData),
    curt: createDataQwtrCurt(obsData),
    graph: createDataWtrQualGraph(obsData),
    obsValues: createDataWtrQualValues(obsData),
    codeInfo: createDataWtrQualCodeInfo(obsData),
  };
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataQwtrObsInfo(obsData) {
  const info = obsData.tmQwtrDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
      unit: "",
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
  ];
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataQwtrStandardValue(obsData) {
  const info = obsData.tmQwtrDetailInfo;
  return [
    {
      title: "pH",
      value:
        "上限値 " +
        formatFloat(info.phUplmt, 1) +
        "pH" +
        "\n下限値 " +
        formatFloat(info.phLolmt, 1) +
        "pH",
    },
    {
      title: "DO",
      value: "下限値 " + formatFloat(info.doxLolmt, 1) + "mg/l",
    },
    {
      title: "COD",
      value: "上限値 " + formatFloat(info.codUplmt, 1) + "mg/l",
    },
  ];
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataQwtrCurt(obsData) {
  const info = obsData.tmQwtrDetailInfo;
  return {
    category: [
      {
        title: "水温",
        master: [
          {
            label: "水温",
            value: checkCcd(info.wtrtmp, info.wtrtmpCcd, 1),
            unit: checkCcdOfUnit("&#8451;", info.wtrtmpCcd),
            ovflg: isBkColoring(info.wtrtmpOvcd),
          },
        ],
      },
      {
        title: "pH",
        master: [
          {
            label: "pH",
            value: checkCcd(info.ph, info.phCcd, 1),
            unit: checkCcdOfUnit("pH", info.phCcd),
            ovflg: isBkColoring(info.phOvcd),
          },
        ],
      },
      {
        title: "DO",
        master: [
          {
            label: "DO",
            value: checkCcd(info.dox, info.doxCcd, 1),
            unit: checkCcdOfUnit("mg/l", info.doxCcd),
            ovflg: isBkColoring(info.doxOvcd),
          },
        ],
      },
      {
        title: "導電率",
        master: [
          {
            label: "導電率",
            value: checkCcd(info.conduct, info.conductCcd, 1),
            unit: checkCcdOfUnit("mS/m", info.conductCcd),
            ovflg: isBkColoring(info.conductOvcd),
          },
        ],
      },
      {
        title: "濁度",
        master: [
          {
            label: "濁度",
            value: checkCcd(info.turbdty, info.turbdtyCcd, 1),
            unit: checkCcdOfUnit("度", info.turbdtyCcd),
            ovflg: isBkColoring(info.turbdtyOvcd),
          },
        ],
      },
      {
        title: "アンモニウムイオン",
        master: [
          {
            label: "アンモニウムイオン",
            value: checkCcd(info.amn, info.amnCcd, 1),
            unit: checkCcdOfUnit("mg/l", info.amnCcd),
            ovflg: isBkColoring(info.amnOvcd),
          },
        ],
      },
      {
        title: "塩分濃度",
        master: [
          {
            label: "塩分濃度",
            value: checkCcd(info.slt, info.sltCcd, 1),
            unit: checkCcdOfUnit("mg/l", info.sltCcd),
            ovflg: isBkColoring(info.sltOvcd),
          },
        ],
      },
      {
        title: "COD",
        master: [
          {
            label: "COD",
            value: checkCcd(info.cod, info.codCcd, 1),
            unit: checkCcdOfUnit("mg/l", info.codCcd),
            ovflg: isBkColoring(info.codOvcd),
          },
        ],
      },
    ],
    obs: [
      {
        title: "水温",
        value: checkCcd(info.wtrtmp, info.wtrtmpCcd, 1),
        unit: checkCcdOfUnit("&#8451;", info.wtrtmpCcd),
      },
      {
        title: "pH",
        value: checkCcd(info.ph, info.phCcd, 1),
        unit: checkCcdOfUnit("pH", info.phCcd),
      },
      {
        title: "DO",
        value: checkCcd(info.dox, info.doxCcd, 1),
        unit: checkCcdOfUnit("mg/l", info.doxCcd),
      },
      {
        title: "導電率",
        value: checkCcd(info.conduct, info.conductCcd, 1),
        unit: checkCcdOfUnit("mS/m", info.conductCcd),
      },
      {
        title: "濁度",
        value: checkCcd(info.turbdty, info.turbdtyCcd, 1),
        unit: checkCcdOfUnit("度", info.turbdtyCcd),
      },
      {
        title: "アンモニウムイオン",
        value: checkCcd(info.amn, info.amnCcd, 1),
        unit: checkCcdOfUnit("mg/l", info.amnCcd),
      },
      {
        title: "塩分濃度",
        value: checkCcd(info.slt, info.sltCcd, 1),
        unit: checkCcdOfUnit("mg/l", info.sltCcd),
      },
      {
        title: "COD",
        value: checkCcd(info.cod, info.codCcd, 1),
        unit: checkCcdOfUnit("mg/l", info.codCcd),
      },
    ],
    obsTime: !checkNotCollected(6, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataWtrQualGraph(obsData) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: [
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "水温",
          /** 単位 */
          unit: "℃",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: obsData.tmQwtrDetailInfo.phLolmt,
          /** 基準値2 */
          ref2: obsData.tmQwtrDetailInfo.phUplmt,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "pH",
          /** 単位 */
          unit: "",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: obsData.tmQwtrDetailInfo.doxLolmt,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "DO",
          /** 単位 */
          unit: "mg/l",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "導電率",
          /** 単位 */
          unit: "mS/m",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "濁度",
          /** 単位 */
          unit: "度",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "アンモニウムイオン",
          /** 単位 */
          unit: "mg/l",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: null,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "塩分濃度",
          /** 単位 */
          unit: "mg/l",
        },
        {
          /** 最大値 */
          max: null,
          /** 基準値1 */
          ref1: null,
          /** 基準値2 */
          ref2: obsData.tmQwtrDetailInfo.codUplmt,
          /** 最小値 */
          min: null,
          /** ラベル */
          title: "COD",
          /** 単位 */
          unit: "mg/l",
        },
      ],
      value: [],
    },
  };

  let graphKey = new Array(
    "wtrtmp",
    "ph",
    "dox",
    "conduct",
    "turbdty",
    "amn",
    "slt",
    "cod"
  );
  let graphKeyCcd = new Array(
    "wtrtmpCcd",
    "phCcd",
    "doxCcd",
    "conductCcd",
    "turbdtyCcd",
    "amnCcd",
    "sltCcd",
    "codCcd"
  );

  // 時間グラフデータ
  for (var i = obsData.tmQwtrDetailObs.qwtrList.length - 1; 0 <= i; i--) {
    for (var j = 0; j < graphData.hour.spec.length; j++) {
      // 最大値・最小値格納
      graphData.hour.spec[j].max = mathMax(
        graphData.hour.spec[j].max,
        graphData.hour.spec[j].ref1,
        graphData.hour.spec[j].ref2,
        checkCcdForGraph(
          obsData.tmQwtrDetailObs.qwtrList[i][graphKey[j]],
          obsData.tmQwtrDetailObs.qwtrList[i][graphKeyCcd[j]]
        )
      );
      graphData.hour.spec[j].min = mathMin(
        graphData.hour.spec[j].min,
        graphData.hour.spec[j].ref1,
        graphData.hour.spec[j].ref2,
        checkCcdForGraph(
          obsData.tmQwtrDetailObs.qwtrList[i][graphKey[j]],
          obsData.tmQwtrDetailObs.qwtrList[i][graphKeyCcd[j]]
        )
      );
    }

    graphData.hour.value.unshift({
      date: Util.formatDate24(
        obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
        "HH:mm"
      ),
      tmp: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].wtrtmp,
        obsData.tmQwtrDetailObs.qwtrList[i].wtrtmpCcd
      ),
      ph: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].ph,
        obsData.tmQwtrDetailObs.qwtrList[i].phCcd
      ),
      do: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].dox,
        obsData.tmQwtrDetailObs.qwtrList[i].doxCcd
      ),
      conduct: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].conduct,
        obsData.tmQwtrDetailObs.qwtrList[i].conductCcd
      ),
      turbdty: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].turbdty,
        obsData.tmQwtrDetailObs.qwtrList[i].turbdtyCcd
      ),
      amn: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].amn,
        obsData.tmQwtrDetailObs.qwtrList[i].amnCcd
      ),
      slt: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].slt,
        obsData.tmQwtrDetailObs.qwtrList[i].sltCcd
      ),
      cod: checkCcdForGraph(
        obsData.tmQwtrDetailObs.qwtrList[i].cod,
        obsData.tmQwtrDetailObs.qwtrList[i].codCcd
      ),
    });
  }

  for (var k = 0; k < graphData.hour.spec.length; k++) {
    // let dif = graphData.hour.spec[k].max - graphData.hour.spec[k].min;
    // let quarter = dif / 4;

    if (k === 0 || k === 1) {
      graphData.hour.spec[k].max = Math.ceil(graphData.hour.spec[k].max);
      graphData.hour.spec[k].min = Math.floor(graphData.hour.spec[k].min);

      let dif = graphData.hour.spec[k].max - graphData.hour.spec[k].min;
      let quarter = dif / 4;

      // 水温・ph
      if (quarter <= 0.5) {
        // <=0.5は0.5
        quarter = 0.5;
      } else {
        // １<以上は、小数点第一位を切り上げ
        quarter = Math.ceil(quarter);
      }
      graphData.hour.spec[k].max = graphData.hour.spec[k].min + quarter * 4;
    } else {
      graphData.hour.spec[k].max = Math.ceil(graphData.hour.spec[k].max);
      // graphData.hour.spec[k].min = Math.floor(graphData.hour.spec[k].min);
      graphData.hour.spec[k].min =
        Math.floor(graphData.hour.spec[k].min / 5) * 5;

      let dif = graphData.hour.spec[k].max - graphData.hour.spec[k].min;
      let quarter = dif / 4;

      // DO・導電率・濁度・アンモニウムイオン・塩分濃度・COD
      if (quarter <= 0.5) {
        // <=0.5は0.5
        quarter = 0.5;
      } else if (quarter < 10) {
        // 0.5<かつ<=10は、小数点第一位を切り上げ
        quarter = Math.ceil(quarter);
      } else {
        // 10以上は、一の位を切り上げ5の倍数
        // quarter = Math.ceil(quarter / 5) * 5;
        quarter = Math.ceil(quarter / 10) * 10;
      }
      graphData.hour.spec[k].max = graphData.hour.spec[k].min + quarter * 4;
    }

    if (k === 3) {
      if (graphData.hour.spec[k].max >= 1000) {
        // 導電率の上限値が1000を超える場合、単位を変更
        graphData.hour.spec[k].max /= 1000;
        graphData.hour.spec[k].min /= 1000;
        graphData.hour.spec[k].unit = "S/m";
        graphData.hour.value.forEach((value) => {
          value.conduct == invalidVal ? invalidVal : (value.conduct /= 1000);
        });
      }
    } else if (k === 6) {
      if (graphData.hour.spec[k].max >= 1000) {
        // 塩分濃度の上限値が1000を超える場合、単位を変更
        graphData.hour.spec[k].max /= 1000;
        graphData.hour.spec[k].min /= 1000;

        // 5の倍数にする
        graphData.hour.spec[k].min =
          Math.floor(graphData.hour.spec[k].min / 5) * 5;

        let dif6 = graphData.hour.spec[k].max - graphData.hour.spec[k].min;
        let quarter6 = dif6 / 4;
        if (quarter6 <= 0.5) {
          // <=0.5は0.5
          quarter6 = 0.5;
        } else if (quarter6 < 10) {
          // 0.5<かつ<=10は、小数点第一位を切り上げ
          quarter6 = Math.ceil(quarter6);
        } else {
          // 10以上は、一の位を切り上げ5の倍数
          quarter6 = Math.ceil(quarter6 / 10) * 10;
        }
        graphData.hour.spec[k].max = graphData.hour.spec[k].min + quarter6 * 4;
        graphData.hour.spec[k].unit = "g/l";
        graphData.hour.value.forEach((value) => {
          value.slt == invalidVal ? invalidVal : (value.slt /= 1000);
        });
      }
    }
  }
  return graphData;
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataWtrQualValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "10%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "10%",
        },
        {
          text: "水温[℃]",
          align: "center",
          value: "wtrtmp",
          width: "10%",
        },
        {
          text: "pH",
          align: "center",
          value: "ph",
          width: "10%",
        },
        {
          text: "DO[mg/l]",
          align: "center",
          value: "dox",
          width: "10%",
        },
        {
          text: "導電率[mS/m]",
          align: "center",
          value: "conduct",
          width: "10%",
        },
        {
          text: "濁度[度]",
          align: "center",
          value: "turbdty",
          width: "10%",
        },
        {
          text: "アンモニウムイオン[mg/l]",
          align: "center",
          value: "amn",
          width: "10%",
        },
        {
          text: "塩分濃度[mg/l]",
          align: "center",
          value: "slt",
          width: "10%",
        },
        {
          text: "COD[mg/l]",
          align: "center",
          value: "cod",
          width: "10%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };
  // コピー用データのヘッダー追加
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 時間観測値一覧データ
  if (obsData.tmQwtrDetailObs.qwtrList != undefined) {
    for (var i = 0; i < obsData.tmQwtrDetailObs.qwtrList.length; i++) {
      obsTime = Util.formatDate24(
        obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
        "MM/DD"
      );
      if (obsTimeBefore === obsTime) {
        obsTime = "";
      }

      valuesData.hour.values.push({
        cd: i,
        date: obsTime,
        time: Util.formatDate24(
          obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
          "HH:mm"
        ),
        wtrtmp: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].wtrtmp,
          obsData.tmQwtrDetailObs.qwtrList[i].wtrtmpCcd,
          1
        ),
        wtrtmpOvcd: obsData.tmQwtrDetailObs.qwtrList[i].wtrtmpOvcd,
        ph: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].ph,
          obsData.tmQwtrDetailObs.qwtrList[i].phCcd,
          1
        ),
        phOvcd: obsData.tmQwtrDetailObs.qwtrList[i].phOvcd,
        dox: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].dox,
          obsData.tmQwtrDetailObs.qwtrList[i].doxCcd,
          1
        ),
        doxOvcd: obsData.tmQwtrDetailObs.qwtrList[i].doxOvcd,
        conduct: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].conduct,
          obsData.tmQwtrDetailObs.qwtrList[i].conductCcd,
          1
        ),
        conductOvcd: obsData.tmQwtrDetailObs.qwtrList[i].conductOvcd,
        turbdty: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].turbdty,
          obsData.tmQwtrDetailObs.qwtrList[i].turbdtyCcd,
          1
        ),
        turbdtyOvcd: obsData.tmQwtrDetailObs.qwtrList[i].turbdtyOvcd,
        amn: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].amn,
          obsData.tmQwtrDetailObs.qwtrList[i].amnCcd,
          1
        ),
        amnOvcd: obsData.tmQwtrDetailObs.qwtrList[i].amnOvcd,
        slt: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].slt,
          obsData.tmQwtrDetailObs.qwtrList[i].sltCcd,
          1
        ),
        sltOvcd: obsData.tmQwtrDetailObs.qwtrList[i].sltOvcd,
        cod: checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].cod,
          obsData.tmQwtrDetailObs.qwtrList[i].codCcd,
          1
        ),
        codOvcd: obsData.tmQwtrDetailObs.qwtrList[i].codOvcd,
      });

      let copyHrValue =
        Util.formatDate24(
          obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
          "MM/DD"
        ) +
        "\t" +
        Util.formatDate24(
          obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
          "HH:mm"
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].wtrtmp,
          obsData.tmQwtrDetailObs.qwtrList[i].wtrtmpCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].ph,
          obsData.tmQwtrDetailObs.qwtrList[i].phCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].dox,
          obsData.tmQwtrDetailObs.qwtrList[i].doxCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].conduct,
          obsData.tmQwtrDetailObs.qwtrList[i].conductCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].turbdty,
          obsData.tmQwtrDetailObs.qwtrList[i].turbdtyCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].amn,
          obsData.tmQwtrDetailObs.qwtrList[i].amnCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].slt,
          obsData.tmQwtrDetailObs.qwtrList[i].sltCcd,
          1
        ) +
        "\t" +
        checkCcd(
          obsData.tmQwtrDetailObs.qwtrList[i].cod,
          obsData.tmQwtrDetailObs.qwtrList[i].codCcd,
          1
        );
      valuesData.hour.copyValues.push(copyHrValue);

      obsTimeBefore = Util.formatDate24(
        obsData.tmQwtrDetailObs.qwtrList[i].obsTime,
        "MM/DD"
      );
      obsTime = "";
    }
  }

  return valuesData;
}

/**
 * [水質観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataWtrQualCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmQwtrDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [ダム諸量観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function convertObsDam(obsData, stgMsg) {
  const relatList = getRelatList(obsData);
  return {
    tmDamDetailInfo: obsData.tmDamDetailInfo,
    obsInfo: createDataDamObsInfo(obsData, relatList),
    waterValue: createDataDamWaterValue(obsData),
    standardValue: createDataDamStandardValue(obsData, relatList),
    curt: createDataDamCurt(obsData, relatList, stgMsg),
    diag: createDataDamDiag(obsData),
    graph: createDataDamGraph(obsData, relatList),
    obsValues: createDataDamValues(obsData),
    codeInfo: createDataDamCodeInfo(obsData),
  };
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamObsInfo(obsData, relatList) {
  const info = obsData.tmDamDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  let codeParamLinkObsRelat = "";
  if (relatList.obsCd !== null && global.KWB_MODE === "admin") {
    codeParamLinkObsRelat =
      codeParamHeadLinkObs + relatList.obsCd + codeParamTailLinkObs;
  }
  let codeParamLinkObsDwStage = "";
  if (info.dwStgObsCd !== null && global.KWB_MODE === "admin") {
    codeParamLinkObsDwStage =
      codeParamHeadLinkObs + info.dwStgObsCd + codeParamTailLinkObs;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "関連雨量観測所",
      value: formatFloat(relatList.value),
      ofcCd: formatFloat(relatList.ofcCd),
      itmkndCd: relatList.itmkndCd,
      obsCd: formatFloat(relatList.obsCd),
      code: codeParamLinkObsRelat,
    },
    {
      title: "関連水位観測所",
      value: formatFloat(info.dwStgObsNm),
      ofcCd: formatFloat(info.dwStgOfcCd),
      itmkndCd: info.dwStgItmkndCd,
      obsCd: formatFloat(info.dwStgObsCd),
      code: codeParamLinkObsDwStage,
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
    {
      title: "流域面積",
      value: formatFloat(info.bsnArea),
      unit: "km&sup2;",
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
    {
      title: "ダム貯水状況",
      value: info.lnkNm != null ? info.lnkNm : invalidStr,
      url: info.lnkUrl,
    },
  ];
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function getRelatList(obsData) {
  let result = [];
  if (
    obsData.tmDamDetailInfo.relatTmObsFcd !== null &&
    obsData.tmDamDetailInfo.relatTmObsFcd !== "0000000000000"
  ) {
    result = {
      value:
        obsData.tmDamDetailInfo.relatTmItmkndCd != 1
          ? formatFloat(obsData.tmDamDetailInfo.relatTmObsNm) + "(流域平均)"
          : formatFloat(obsData.tmDamDetailInfo.relatTmObsNm),
      ofcCd: formatFloat(obsData.tmDamDetailInfo.relatTmOfcCd),
      itmkndCd: obsData.tmDamDetailInfo.relatTmItmkndCd,
      obsCd: formatFloat(obsData.tmDamDetailInfo.relatTmObsCd),
      rnHrCaut: obsData.tmDamDetailInfo.tmRnHrCaut,
      rnHrWarn: obsData.tmDamDetailInfo.tmRnHrWarn,
      rn10mCaut: obsData.tmDamDetailInfo.tmRn10mCaut,
      rn10mWarn: obsData.tmDamDetailInfo.tmRn10mWarn,
      rnIncCaut: obsData.tmDamDetailInfo.tmRnIncCaut,
      rnIncWarn: obsData.tmDamDetailInfo.tmRnIncWarn,
      rn10m: obsData.tmDamDetailInfo.bsnrn10m,
      rn10mCcd: obsData.tmDamDetailInfo.bsnrn10mCcd,
      rn10mCautOvflg: obsData.tmDamDetailInfo.bsnrn10mCautOvflg,
      rn10mWarnOvflg: obsData.tmDamDetailInfo.bsnrn10mWarnOvflg,
      rnHr: obsData.tmDamDetailInfo.bsnrnHr10m,
      rnHrCcd: obsData.tmDamDetailInfo.bsnrnHr10mCcd,
      rnHrCautOvflg: obsData.tmDamDetailInfo.bsnrnHr10mCautOvflg,
      rnHrWarnOvflg: obsData.tmDamDetailInfo.bsnrnHr10mWarnOvflg,
      rnInc: obsData.tmDamDetailInfo.bsnrnInc,
      rnIncCcd: obsData.tmDamDetailInfo.bsnrnIncCcd,
      rnIncCautOvflg: obsData.tmDamDetailInfo.bsnrnIncCautOvflg,
      rnIncWarnOvflg: obsData.tmDamDetailInfo.bsnrnIncWarnOvflg,
    };
  } else if (
    obsData.tmDamDetailInfo.relatRdObsFcd !== null &&
    obsData.tmDamDetailInfo.relatRdObsFcd !== "0000000000000"
  ) {
    result = {
      value:
        obsData.tmDamDetailInfo.relatRdItmkndCd != 1
          ? formatFloat(obsData.tmDamDetailInfo.relatRdObsNm) + "(レーダ流域)"
          : formatFloat(obsData.tmDamDetailInfo.relatRdObsNm),
      ofcCd: formatFloat(obsData.tmDamDetailInfo.relatRdOfcCd),
      itmkndCd: obsData.tmDamDetailInfo.relatRdItmkndCd,
      obsCd: formatFloat(obsData.tmDamDetailInfo.relatRdObsCd),
      rnHrCaut: obsData.tmDamDetailInfo.rdRnHrCaut,
      rnHrWarn: obsData.tmDamDetailInfo.rdRnHrWarn,
      rn10mCaut: obsData.tmDamDetailInfo.rdRn10mCaut,
      rn10mWarn: obsData.tmDamDetailInfo.rdRn10mWarn,
      rnIncCaut: obsData.tmDamDetailInfo.rdRnIncCaut,
      rnIncWarn: obsData.tmDamDetailInfo.rdRnIncWarn,
      rn10m: obsData.tmDamDetailInfo.rdbsnrn10m,
      rn10mCcd: obsData.tmDamDetailInfo.rdbsnrn10mCcd,
      rn10mCautOvflg: obsData.tmDamDetailInfo.rdbsnrn10mCautOvflg,
      rn10mWarnOvflg: obsData.tmDamDetailInfo.rdbsnrn10mWarnOvflg,
      rnHr: obsData.tmDamDetailInfo.rdbsnrnHr10m,
      rnHrCcd: obsData.tmDamDetailInfo.rdbsnrnHr10mCcd,
      rnHrCautOvflg: obsData.tmDamDetailInfo.rdbsnrnHr10mCautOvflg,
      rnHrWarnOvflg: obsData.tmDamDetailInfo.rdbsnrnHr10mWarnOvflg,
      rnInc: obsData.tmDamDetailInfo.rdbsnrnInc,
      rnIncCcd: obsData.tmDamDetailInfo.rdbsnrnIncCcd,
      rnIncCautOvflg: obsData.tmDamDetailInfo.rdbsnrnIncCautOvflg,
      rnIncWarnOvflg: obsData.tmDamDetailInfo.rdbsnrnIncWarnOvflg,
    };
  } else {
    result = {
      value: null,
      ofcCd: null,
      itmkndCd: null,
      obsCd: null,
      rnHrCaut: null,
      rnHrWarn: null,
      rn10mCaut: null,
      rn10mWarn: null,
      rnIncCaut: null,
      rnIncWarn: null,
      rn10m: null,
      rn10mCcd: 160,
      rnHr: null,
      rnHrCcd: 160,
      rnInc: null,
      rnIncCcd: 160,
    };
  }
  return result;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamWaterValue(obsData) {
  let result = [
    {
      title: "最低水位",
      value: formatFloat(obsData.tmDamDetailInfo.minStg),
      unit: "m",
    },
    {
      title:
        "予備放流水位(" +
        formatFloat(obsData.tmDamDetailInfo.sprStgStrt) +
        "～" +
        formatFloat(obsData.tmDamDetailInfo.sprStgEnd) +
        ")",
      value: formatFloat(obsData.tmDamDetailInfo.sprStg),
      unit: "m",
    },
    {
      title:
        "洪水貯留準備水位(" +
        formatFloat(obsData.tmDamDetailInfo.lmtStgStrt) +
        "～" +
        formatFloat(obsData.tmDamDetailInfo.lmtStgEnd) +
        ")",
      value: formatFloat(obsData.tmDamDetailInfo.lmtStg),
      unit: "m",
    },
    {
      title: "平常時最高貯水位",
      value: formatFloat(obsData.tmDamDetailInfo.nrmlHighStg),
      unit: "m",
    },
    {
      title: "洪水時最高水位",
      value: formatFloat(obsData.tmDamDetailInfo.srchgStg),
      unit: "m",
    },
    {
      title: "計画最大放流量",
      value: formatFloat(obsData.tmDamDetailInfo.dsgnHighFlow),
      unit: "m&sup3;/s",
    },
    {
      title: "洪水貯留操作開始流量",
      value: formatFloat(obsData.tmDamDetailInfo.fldctlStrtFlw),
      unit: "m&sup3;/s",
    },
  ];

  // 異常洪水時防災操作開始水位を算出
  const prvStgValue = setPrvsStg(
    obsData.tmDamDetailInfo,
    obsData.tmDamDetailInfo.prvsStg
  );

  if (prvStgValue.valid) {
    // 異常洪水時防災操作開始水位を出力する場合
    let prvStgItem = {
      title: "緊急放流（異常洪水時防災操作）判断水位",
      value: prvStgValue.value,
      unit: "m",
    };
    result.splice(6, 0, prvStgItem);
  }

  return result;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamStandardValue(obsData, relatList) {
  let result = [
    {
      title: "時間雨量",
      value: formatCautWarn(relatList.rnHrCaut, relatList.rnHrWarn, "mm", 1),
    },
    {
      title: "10分雨量",
      value: formatCautWarn(relatList.rn10mCaut, relatList.rn10mWarn, "mm", 1),
    },
    {
      title: "降り始めからの雨量",
      value: formatCautWarn(relatList.rnIncCaut, relatList.rnIncWarn, "mm", 1),
    },
  ];
  return result;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 * @param {*} stgMsg 水位表示切替メッセージ設定
 */
function createDataDamCurt(obsData, relatList, stgMsg) {
  const info = obsData.tmDamDetailInfo;
  return {
    category: [
      {
        title: "貯水関連",
        master: [
          {
            label: "貯水位",
            value: checkCcd(info.storLvl, info.storLvlCcd, 2),
            unit: checkCcdOfUnit("m", info.storLvlCcd),
            ovflg: isBkColoringDam(info.storLvlOvflg, "storLvl"),
          },
          {
            label: "貯水量",
            value: checkCcd(info.storCap, info.storCapCcd, 2),
            unit: checkCcdOfUnit("千m&sup3;", info.storCapCcd),
          },
        ],
      },
      {
        title: "貯水率関連",
        master: [
          {
            label: "治水容量",
            value: checkCcd(info.storFcntIrr, info.storFcntIrrCcd, 1),
            unit: checkCcdOfUnit("%", info.storFcntIrrCcd),
          },
          {
            label: "有効容量",
            value: checkCcd(info.storPcntEff, info.storPcntEffCcd, 1),
            unit: checkCcdOfUnit("%", info.storPcntEffCcd),
          },
          {
            label: "利水容量",
            value: checkCcd(info.storPcntIrr, info.storPcntIrrCcd, 1),
            unit: checkCcdOfUnit("%", info.storPcntIrrCcd),
          },
        ],
      },
      {
        title: "放流・流入関連",
        master: [
          {
            label: "全放流量",
            value: checkCcd(info.allDisch, info.allDischCcd, 2),
            unit: checkCcdOfUnit("m&sup3;/s", info.allDischCcd),
          },
          {
            label: "全流入量",
            value: checkCcd(info.allSink, info.allSinkCcd, 2),
            unit: checkCcdOfUnit("m&sup3;/s", info.allSinkCcd),
            ovflg: isBkColoringDam(info.allSinkOvflg, "allSink"),
          },
        ],
      },
      {
        title: "雨量関連",
        master: [
          {
            label: "時間雨量",
            value: checkCcd(relatList.rnHr, relatList.rnHrCcd, 1),
            unit: checkCcdOfUnit("mm", relatList.rnHrCcd),
            ovflg: isBkColoringCutWrn(
              relatList.rnHrCautOvflg,
              relatList.rnHrWarnOvflg
            ),
            bgColor: checkRainBgColor(relatList.rnHrCcd),
          },
          {
            label: "10分雨量",
            value: checkCcd(relatList.rn10m, relatList.rn10mCcd, 1),
            unit: checkCcdOfUnit("mm", relatList.rn10mCcd),
            ovflg: isBkColoringCutWrn(
              relatList.rn10mCautOvflg,
              relatList.rn10mWarnOvflg
            ),
            bgColor: checkRainBgColor(relatList.rn10mCcd),
          },
          {
            label: "降り始めからの雨量",
            value: checkCcd(relatList.rnInc, relatList.rnIncCcd, 1),
            unit: checkCcdOfUnit("mm", relatList.rnIncCcd),
            ovflg: isBkColoringCutWrn(
              relatList.rnIncCautOvflg,
              relatList.rnIncWarnOvflg
            ),
            bgColor: checkRainBgColor(relatList.rnIncCcd),
          },
        ],
      },
      {
        title: "下流の水位",
        master: [
          {
            label: "下流の水位",
            labelList: [stgMsg.normalStg, stgMsg.topendStg],
            value: [
              checkCcd(info.dwStg, info.dwStgCcd, 2),
              checkCcd(info.dwStgTopendHghtDiff, info.dwStgCcd, 2),
            ],
            unit: checkCcdOfUnit("m", info.dwStgCcd),
            stgOvlvl: info.dwStgOvlvl,
            stgCcd: info.dwStgCcd,
          },
        ],
      },
    ],
    obs: [
      {
        title: "貯水位",
        value: checkCcd(info.storLvl, info.storLvlCcd, 2),
        unit: checkCcdOfUnit("m", info.storLvlCcd),
      },
      {
        title: "貯水量",
        value: checkCcd(info.storCap, info.storCapCcd, 2),
        unit: checkCcdOfUnit("千m&sup3;", info.storCapCcd),
      },
      {
        title: "全流入量",
        value: checkCcd(info.allSink, info.allSinkCcd, 2),
        unit: checkCcdOfUnit("m&sup3;/s", info.allSinkCcd),
      },
      {
        title: "全放流量",
        value: checkCcd(info.allDisch, info.allDischCcd, 2),
        unit: checkCcdOfUnit("m&sup3;/s", info.allDischCcd),
      },
      {
        title: "貯水率治水容量",
        value: checkCcd(info.storFcntIrr, info.storFcntIrrCcd, 1),
        unit: checkCcdOfUnit("%", info.storFcntIrrCcd),
      },
      {
        title: "貯水率有効容量",
        value: checkCcd(info.storPcntEff, info.storPcntEffCcd, 1),
        unit: checkCcdOfUnit("%", info.storPcntEffCcd),
      },
      {
        title: "貯水率利水容量",
        value: checkCcd(info.storPcntIrr, info.storPcntIrrCcd, 1),
        unit: checkCcdOfUnit("%", info.storPcntIrrCcd),
      },
      {
        title: "時間雨量",
        value: checkCcd(relatList.rnHr, relatList.rnHrCcd, 1),
        unit: checkCcdOfUnit("mm", relatList.rnHrCcd),
      },
      {
        title: "10分雨量",
        value: checkCcd(relatList.rn10m, relatList.rn10mCcd, 1),
        unit: checkCcdOfUnit("mm", relatList.rn10mCcd),
      },
      {
        title: "降り始めからの雨量",
        value: checkCcd(relatList.rnInc, relatList.rnIncCcd, 1),
        unit: checkCcdOfUnit("mm", relatList.rnIncCcd),
      },
    ],
    obsTime: !checkNotCollected(7, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
    dwStg: {
      stgOvlvl: info.dwStgOvlvl,
      stgCcd: info.dwStgCcd,
      rsrvStg: info.dwRsrvStg,
      warnStg: info.dwWarnStg,
      spclWarnStg: info.dwSpclWarnStg,
      dngStg: info.dwDngStg,
    },
  };
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamDiag(obsData) {
  // ダム観測所と水位観測所の緯度・経度から距離を求める
  if (obsData.diag.dam.spec.stage !== null) {
    let distance = geodesic.getDistance(
      [obsData.diag.dam.spec.stage.damLat, obsData.diag.dam.spec.stage.damLon],
      [obsData.diag.dam.spec.stage.stgLat, obsData.diag.dam.spec.stage.stgLon]
    );
    let stage = {
      name: obsData.diag.dam.spec.stage.name,
      distance: Math.round(distance * 10) / 10,
      // labelはコンポーネント側で設定
      label: null,
    };

    obsData.diag.dam.spec.stage = stage;
  }

  // ダム模式図情報(放流通知のデータ)の補正
  if (obsData.diag.dam.dsch.lvl === null) {
    obsData.diag.dam.dsch.lvl = 0;
  }

  return obsData.diag;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamGraph(obsData, relatList) {
  // 異常洪水時防災操作開始水位を算出
  const prvStgValue = setPrvsStg(
    obsData.tmDamDetailInfo,
    obsData.tmDamDetailInfo.prvsStg
  );
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        rain: {
          max: 0,
          min: damRainGraphHourMin,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: damRainGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        stor: {
          max: 0,
          prvs: prvStgValue.valid ? prvStgValue.value : null,
          min: null,
          title: "貯水位",
          unit: "m",
        },
        all: {
          max: 0,
          fldctl: obsData.tmDamDetailInfo.fldctlStrtFlw,
          min: null,
          titleSink: "全流入",
          titleDisch: "放流量",
          unit: "㎥/s",
        },
      },
      value: [],
    },
    min10: {
      spec: {
        rain: {
          max: 0,
          min: damRainGraphMin10Min,
          title: "雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          min: damRainGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
        stor: {
          max: 0,
          prvs: obsData.tmDamDetailInfo.prvsStg,
          min: null,
          title: "貯水位",
          unit: "m",
        },
        all: {
          max: 0,
          fldctl: obsData.tmDamDetailInfo.fldctlStrtFlw,
          min: null,
          titleSink: "全流入",
          titleDisch: "放流量",
          unit: "㎥/s",
        },
      },
      value: [],
    },
  };

  // 10分グラフデータ
  for (var i = obsData.tmDamDetailObs.dam10mList.length - 1; 0 <= i; i--) {
    let rain;
    let rainCcd;
    let total;
    let totalCcd;
    if (
      obsData.tmDamDetailInfo.relatTmObsFcd !== null &&
      obsData.tmDamDetailInfo.relatTmObsFcd !== "0000000000000"
    ) {
      rain = obsData.tmDamDetailObs.dam10mList[i].bsnrn10m;
      rainCcd = obsData.tmDamDetailObs.dam10mList[i].bsnrn10mCcd;
      total = obsData.tmDamDetailObs.dam10mList[i].bsnrnInc;
      totalCcd = obsData.tmDamDetailObs.dam10mList[i].bsnrnIncCcd;
    } else {
      rain = obsData.tmDamDetailObs.dam10mList[i].rdbsnrn10m;
      rainCcd = obsData.tmDamDetailObs.dam10mList[i].rdbsnrn10mCcd;
      total = obsData.tmDamDetailObs.dam10mList[i].rdbsnrnInc;
      totalCcd = obsData.tmDamDetailObs.dam10mList[i].rdbsnrnIncCcd;
    }

    // 最大値/最小値格納
    graphData.min10.spec.rain.max = mathMax(
      graphData.min10.spec.rain.max,
      checkCcdForGraph(rain, rainCcd)
    );
    graphData.min10.spec.total.max = mathMax(
      graphData.min10.spec.total.max,
      checkCcdForGraph(total, totalCcd)
    );

    graphData.min10.spec.stor.max = mathMax(
      graphData.min10.spec.stor.max,
      checkCcdForGraph(
        obsData.tmDamDetailObs.dam10mList[i].storLvl,
        obsData.tmDamDetailObs.dam10mList[i].storLvlCcd
      )
    );

    graphData.min10.spec.stor.min = mathMin(
      graphData.min10.spec.stor.min,
      checkCcdForGraph(
        obsData.tmDamDetailObs.dam10mList[i].storLvl,
        obsData.tmDamDetailObs.dam10mList[i].storLvlCcd
      )
    );
    let allSink = checkCcdForGraph(
      obsData.tmDamDetailObs.dam10mList[i].allSink,
      obsData.tmDamDetailObs.dam10mList[i].allSinkCcd
    );
    let allDisch = checkCcdForGraph(
      obsData.tmDamDetailObs.dam10mList[i].allDisch,
      obsData.tmDamDetailObs.dam10mList[i].allDischCcd
    );
    graphData.min10.spec.all.max = mathMax(
      graphData.min10.spec.all.max,
      allSink,
      allDisch
    );
    // 全流入量・全放流量の最小値は0固定
    // graphData.min10.spec.all.min = mathMin(
    //   graphData.min10.spec.all.min,
    //   allSink,
    //   allDisch
    // );

    graphData.min10.value.unshift({
      date: Util.formatDate24(
        obsData.tmDamDetailObs.dam10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmDamDetailObs.dam10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(rain, rainCcd),
      total: checkCcdForGraph(total, totalCcd),
      level: checkCcdForGraph(
        obsData.tmDamDetailObs.dam10mList[i].storLvl,
        obsData.tmDamDetailObs.dam10mList[i].storLvlCcd
      ),
      irr: checkCcdForGraph(
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrr,
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrrCcd
      ),
      flood: checkCcdForGraph(
        obsData.tmDamDetailObs.dam10mList[i].flood,
        obsData.tmDamDetailObs.dam10mList[i].floodCcd
      ),
      sink: allSink,
      disch: allDisch,
    });
  }

  // 最大値/最小値セット
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    relatList.rn10mCaut,
    relatList.rn10mWarn
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    relatList.rnIncCaut,
    relatList.rnIncWarn
  );
  graphData.min10.spec.stor.max = mathMax(
    graphData.min10.spec.stor.max,
    graphData.min10.spec.stor.prvs
  );
  graphData.min10.spec.stor.min = mathMin(
    graphData.min10.spec.stor.min,
    obsData.tmDamDetailInfo.minStg
  );
  graphData.min10.spec.all.max = mathMax(
    graphData.min10.spec.all.max,
    obsData.tmDamDetailInfo.fldctlStrtFlw
  );
  // 全流入量・全放流量の最小値は0固定
  // graphData.min10.spec.all.min = mathMin(
  //   graphData.min10.spec.all.min,
  //   obsData.tmDamDetailInfo.fldctlStrtFlw
  // );

  // 値無しの場合を考慮
  if (!graphData.min10.spec.all.min) {
    graphData.min10.spec.all.min = 0;
  }
  if (!graphData.min10.spec.stor.min) {
    graphData.min10.spec.stor.min = 0;
  }
  // 1の位を切り捨て
  // graphData.min10.spec.rain.max = valueCeil(graphData.min10.spec.rain.max, 10);
  // graphData.min10.spec.total.max = valueCeil(
  //   graphData.min10.spec.total.max,
  //   10
  // );

  // graphData.min10.spec.rain.max = graphMaxAdd(
  //   graphData.min10.spec.rain.max,
  //   damRainGraphMin10MaxAdd,
  //   damRainGraphMin10Max
  // );
  // graphData.min10.spec.total.max = graphMaxAdd(
  //   graphData.min10.spec.total.max,
  //   damRainGraphTotalMaxAdd,
  //   damRainGraphTotalMax
  // );
  // graphData.min10.spec.stor.max = graphMaxAdd(
  //   graphData.min10.spec.stor.max,
  //   damStorGraphMin10MaxAdd,
  //   null
  // );
  // graphData.min10.spec.all.max = graphMaxAdd(
  //   graphData.min10.spec.all.max,
  //   0,
  //   null
  // );
  // // 最小値セット
  // graphData.min10.spec.stor.min = graphMinAdd(
  //   graphData.min10.spec.stor.min,
  //   damStorGraphMin10MinAdd,
  //   obsData.tmDamDetailInfo.minStg
  // );
  // graphData.min10.spec.all.min = graphMinAdd(
  //   graphData.min10.spec.all.min,
  //   0,
  //   null
  // );

  // 上限値・下限値の値調整
  // graphData.min10.spec.rain.max = roundMax(
  //   graphData.min10.spec.rain.max,
  //   damRainGraphMin10MaxAdd,
  //   damRainGraphMin10Max,
  //   10
  // );
  // graphData.min10.spec.total.max = roundMax(
  //   graphData.min10.spec.total.max,
  //   damRainGraphTotalMaxAdd,
  //   damRainGraphTotalMax,
  //   10
  // );
  // graphData.min10.spec.stor.max +=
  //   (graphData.min10.spec.stor.max - graphData.min10.spec.stor.min) * 0.2;
  // graphData.min10.spec.stor.max = roundMax(
  //   graphData.min10.spec.stor.max,
  //   damStorGraphMin10MaxAdd,
  //   null,
  //   1
  // );
  // graphData.min10.spec.all.max = roundMax(
  //   Math.ceil(graphData.min10.spec.all.max),
  //   damAllGraphMin10MaxAdd,
  //   null,
  //   1
  // );
  // graphData.min10.spec.stor.min = roundMin(
  //   graphData.min10.spec.stor.min,
  //   damStorGraphMin10MinAdd,
  //   obsData.tmDamDetailInfo.minStg,
  //   1
  // );
  // if (obsData.tmDamDetailInfo.dsgnHighFlow !== null) {
  //   graphData.min10.spec.all.min = roundMin(
  //     graphData.min10.spec.all.min,
  //     damAllGraphMin10MinAdd,
  //     obsData.tmDamDetailInfo.dsgnHighFlow * -2,
  //     1
  //   );
  // } else {
  //   graphData.min10.spec.all.min = roundMin(
  //     graphData.min10.spec.all.min,
  //     damAllGraphMin10MinAdd,
  //     null,
  //     1
  //   );
  // }

  for (var j = obsData.tmDamDetailObs.damHrList.length - 1; 0 <= j; j--) {
    let rain;
    let rainCcd;
    let total;
    let totalCcd;
    if (
      obsData.tmDamDetailInfo.relatTmObsFcd !== null &&
      obsData.tmDamDetailInfo.relatTmObsFcd !== "0000000000000"
    ) {
      rain = obsData.tmDamDetailObs.damHrList[j].bsnrnHr;
      rainCcd = obsData.tmDamDetailObs.damHrList[j].bsnrnHrCcd;
      total = obsData.tmDamDetailObs.damHrList[j].bsnrnInc;
      totalCcd = obsData.tmDamDetailObs.damHrList[j].bsnrnIncCcd;
    } else {
      rain = obsData.tmDamDetailObs.damHrList[j].rdbsnrnHr;
      rainCcd = obsData.tmDamDetailObs.damHrList[j].rdbsnrnHrCcd;
      total = obsData.tmDamDetailObs.damHrList[j].rdbsnrnInc;
      totalCcd = obsData.tmDamDetailObs.damHrList[j].rdbsnrnIncCcd;
    }

    // 最大値/最小値格納
    graphData.hour.spec.rain.max = mathMax(
      graphData.hour.spec.rain.max,
      checkCcdForGraph(rain, rainCcd)
    );
    graphData.hour.spec.total.max = mathMax(
      graphData.hour.spec.total.max,
      checkCcdForGraph(total, totalCcd)
    );
    graphData.hour.spec.stor.max = mathMax(
      graphData.hour.spec.stor.max,
      checkCcdForGraph(
        obsData.tmDamDetailObs.damHrList[j].storLvl,
        obsData.tmDamDetailObs.damHrList[j].storLvlCcd
      )
    );
    graphData.hour.spec.stor.min = mathMin(
      graphData.hour.spec.stor.min,
      checkCcdForGraph(
        obsData.tmDamDetailObs.damHrList[j].storLvl,
        obsData.tmDamDetailObs.damHrList[j].storLvlCcd
      )
    );
    let allSink = checkCcdForGraph(
      obsData.tmDamDetailObs.damHrList[j].allSink,
      obsData.tmDamDetailObs.damHrList[j].allSinkCcd
    );
    let allDisch = checkCcdForGraph(
      obsData.tmDamDetailObs.damHrList[j].allDisch,
      obsData.tmDamDetailObs.damHrList[j].allDischCcd
    );
    graphData.hour.spec.all.max = mathMax(
      graphData.hour.spec.all.max,
      allSink,
      allDisch
    );
    // 全流入量・全放流量の最小値は0固定
    // graphData.hour.spec.all.min = mathMin(
    //   graphData.hour.spec.all.min,
    //   allSink,
    //   allDisch
    // );

    graphData.hour.value.unshift({
      date: Util.formatDate24(
        obsData.tmDamDetailObs.damHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmDamDetailObs.damHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(rain, rainCcd),
      total: checkCcdForGraph(total, totalCcd),
      level: checkCcdForGraph(
        obsData.tmDamDetailObs.damHrList[j].storLvl,
        obsData.tmDamDetailObs.damHrList[j].storLvlCcd
      ),
      irr: checkCcdForGraph(
        obsData.tmDamDetailObs.damHrList[j].storPcntIrr,
        obsData.tmDamDetailObs.damHrList[j].storPcntIrrCcd
      ),
      flood: checkCcdForGraph(
        obsData.tmDamDetailObs.damHrList[j].flood,
        obsData.tmDamDetailObs.damHrList[j].floodCcd
      ),
      sink: allSink,
      disch: allDisch,
    });
  }

  // 最大値/最小値セット
  graphData.hour.spec.rain.max = mathMax(
    graphData.hour.spec.rain.max,
    relatList.rnHrCaut,
    relatList.rnHrWarn
  );
  graphData.hour.spec.total.max = mathMax(
    graphData.hour.spec.total.max,
    relatList.rnIncCaut,
    relatList.rnIncWarn
  );
  graphData.hour.spec.stor.max = mathMax(
    graphData.hour.spec.stor.max,
    graphData.hour.spec.stor.prvs
  );
  graphData.hour.spec.stor.min = mathMin(
    graphData.hour.spec.stor.min,
    obsData.tmDamDetailInfo.minStg
  );
  graphData.hour.spec.all.max = mathMax(
    graphData.hour.spec.all.max,
    obsData.tmDamDetailInfo.fldctlStrtFlw
  );
  // graphData.hour.spec.all.min = mathMin(
  //   graphData.hour.spec.all.min,
  //   obsData.tmDamDetailInfo.fldctlStrtFlw
  // );
  // 最小値を0とする
  graphData.hour.spec.all.min = 0;

  // 値無しの場合を考慮
  // if (!graphData.hour.spec.all.min) {
  //   graphData.hour.spec.all.min = 0;
  // }
  // if (!graphData.hour.spec.stor.min) {
  //   graphData.hour.spec.stor.min = 0;
  // }
  // 1の位を切り捨て
  // graphData.hour.spec.rain.max = valueCeil(graphData.hour.spec.rain.max, 10);
  // graphData.hour.spec.total.max = valueCeil(graphData.hour.spec.total.max, 10);

  // 最大値セット
  // graphData.hour.spec.rain.max = graphMaxAdd(
  //   graphData.hour.spec.rain.max,
  //   damRainGraphHourMaxAdd,
  //   damRainGraphHourMax
  // );
  // graphData.hour.spec.total.max = graphMaxAdd(
  //   graphData.hour.spec.total.max,
  //   damRainGraphTotalMaxAdd,
  //   damRainGraphTotalMax
  // );
  // graphData.hour.spec.stor.max = graphMaxAdd(
  //   graphData.hour.spec.stor.max,
  //   damStorGraphHourMaxAdd,
  //   null
  // );
  // graphData.hour.spec.all.max = graphMaxAdd(
  //   graphData.hour.spec.all.max,
  //   0,
  //   null
  // );
  // // 最小値セット
  // graphData.hour.spec.stor.min = graphMinAdd(
  //   graphData.hour.spec.stor.min,
  //   damStorGraphHourMinAdd,
  //   obsData.tmDamDetailInfo.minStg
  // );
  // graphData.hour.spec.all.min = graphMinAdd(
  //   graphData.hour.spec.all.min,
  //   0,
  //   null
  // );

  // 上限値・下限値の値調整
  // graphData.hour.spec.rain.max = roundMax(
  //   graphData.hour.spec.rain.max,
  //   damRainGraphHourMaxAdd,
  //   damRainGraphHourMax,
  //   10
  // );
  // graphData.hour.spec.total.max = roundMax(
  //   graphData.hour.spec.total.max,
  //   damRainGraphTotalMaxAdd,
  //   damRainGraphTotalMax,
  //   10
  // );
  // graphData.hour.spec.stor.max +=
  //   (graphData.hour.spec.stor.max - graphData.hour.spec.stor.min) * 0.2;
  // graphData.hour.spec.stor.max = roundMax(
  //   graphData.hour.spec.stor.max,
  //   damStorGraphHourMaxAdd,
  //   null,
  //   1
  // );
  // graphData.hour.spec.all.max = roundMax(
  //   Math.ceil(graphData.hour.spec.all.max),
  //   damAllGraphHourMaxAdd,
  //   null,
  //   1
  // );
  // graphData.hour.spec.stor.min = roundMin(
  //   graphData.hour.spec.stor.min,
  //   damStorGraphHourMinAdd,
  //   obsData.tmDamDetailInfo.minStg,
  //   1
  // );
  // if (obsData.tmDamDetailInfo.dsgnHighFlow !== null) {
  //   graphData.hour.spec.all.min = roundMin(
  //     graphData.hour.spec.all.min,
  //     damAllGraphHourMinAdd,
  //     obsData.tmDamDetailInfo.dsgnHighFlow * -2,
  //     1
  //   );
  // } else {
  //   graphData.hour.spec.all.min = roundMin(
  //     graphData.hour.spec.all.min,
  //     damAllGraphHourMinAdd,
  //     null,
  //     1
  //   );
  // }

  // 10分と時間で、上下限を合わせる
  graphData.hour.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    graphData.hour.spec.rain.max
  );

  let difHourRain = graphData.hour.spec.rain.max - graphData.hour.spec.rain.min;
  let quarterHourRain = difHourRain / 4;

  if (quarterHourRain <= 20) {
    // <=20は20
    quarterHourRain = 20;
  } else if (quarterHourRain > 20 && quarterHourRain <= 30) {
    // 20<かつ<=30は30
    quarterHourRain = 30;
  } else if (quarterHourRain > 30 && quarterHourRain <= 40) {
    // 30<かつ<=40は40
    quarterHourRain = 40;
  } else {
    // 40<かつ<=50は50
    quarterHourRain = 50;
  }

  graphData.hour.spec.rain.max =
    graphData.hour.spec.rain.min + quarterHourRain * 4;

  // graphData.hour.spec.rain.max = graphData.min10.spec.rain.max;
  graphData.min10.spec.rain.max = graphData.hour.spec.rain.max;

  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    graphData.hour.spec.total.max
  );

  let difMin10Total =
    graphData.min10.spec.total.max - graphData.min10.spec.total.min;
  let quarterMin10Total = difMin10Total / 4;

  if (quarterMin10Total <= 50) {
    // <=50は50
    quarterMin10Total = 50;
  } else if (quarterMin10Total > 50 && quarterMin10Total <= 100) {
    // <=100は100
    quarterMin10Total = 100;
  } else if (quarterMin10Total > 100 && quarterMin10Total <= 200) {
    // 100<かつ<=200は200
    quarterMin10Total = 200;
  } else if (quarterMin10Total > 200 && quarterMin10Total <= 500) {
    // 200<かつ<=500は500
    quarterMin10Total = 500;
  } else {
    // 500<は750
    quarterMin10Total = 750;
  }

  graphData.min10.spec.total.max =
    graphData.min10.spec.total.min + quarterMin10Total * 4;

  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  graphData.min10.spec.stor.max = mathMax(
    graphData.min10.spec.stor.max,
    graphData.hour.spec.stor.max
  );

  graphData.hour.spec.stor.max = graphData.min10.spec.stor.max;
  graphData.min10.spec.stor.min = mathMin(
    graphData.min10.spec.stor.min,
    graphData.hour.spec.stor.min
  );

  // グラフの下限は小数点以下を切り捨てる
  graphData.min10.spec.stor.min = Math.floor(graphData.min10.spec.stor.min);
  graphData.hour.spec.stor.min = graphData.min10.spec.stor.min;

  let difMin10Stor =
    Math.ceil(graphData.min10.spec.stor.max) - graphData.min10.spec.stor.min;
  let difHourStor =
    Math.ceil(graphData.hour.spec.stor.max) - graphData.hour.spec.stor.min;

  // 下限については、上下端差が４０以上かつ最下位の数字が２桁以上の場合は、１の位を切り捨て
  if (difMin10Stor >= 40 && graphData.min10.spec.stor.min >= 10) {
    graphData.min10.spec.stor.min = valueCeil(
      graphData.min10.spec.stor.min,
      10
    );
    difMin10Stor =
      Math.ceil(graphData.min10.spec.stor.max) - graphData.min10.spec.stor.min;
  }
  // 下限については、上下端差が４０以上かつ最下位の数字が２桁以上の場合は、１の位を切り捨て
  if (difHourStor >= 40 && graphData.hour.spec.stor.min >= 10) {
    graphData.hour.spec.stor.min = valueCeil(graphData.hour.spec.stor.min, 10);
    difHourStor =
      Math.ceil(graphData.hour.spec.stor.max) - graphData.hour.spec.stor.min;
  }

  let quarterMin10Stor = difMin10Stor / 4;
  let quarterHourStor = difHourStor / 4;

  if (quarterMin10Stor <= 0.5) {
    // <=0.5の場合は0.5
    quarterMin10Stor = 0.5;
  } else if (quarterMin10Stor > 0.5 && quarterMin10Stor <= 10) {
    // 0.5<かつ<=10の場合は（上下端差÷4の切り上げ整数)
    quarterMin10Stor = Math.ceil(quarterMin10Stor);
  } else if (quarterMin10Stor > 10 && quarterMin10Stor <= 15) {
    // 10<かつ<=15の場合は（上下端差÷4の切り上げ15)
    quarterMin10Stor = 15;
  } else if (quarterMin10Stor > 15 && quarterMin10Stor <= 100) {
    // 15<かつ<=100の場合は、（上下端差÷4の切り上げ10又は５の倍数)
    quarterMin10Stor = Math.ceil(quarterMin10Stor / 5) * 5;
  } else {
    // 100<の場合は、（上下端差÷4の切り上げ１０の倍数)
    quarterMin10Stor = Math.ceil(quarterMin10Stor / 10) * 10;
  }

  if (quarterHourStor <= 0.5) {
    // <=0.5の場合は0.5
    quarterHourStor = 0.5;
  } else if (quarterHourStor > 0.5 && quarterHourStor <= 10) {
    // 0.5<かつ<=10の場合は（上下端差÷4の切り上げ整数)
    quarterHourStor = Math.ceil(quarterHourStor);
  } else if (quarterHourStor > 10 && quarterHourStor <= 15) {
    // 10<かつ<=15の場合は（上下端差÷4の切り上げ15)
    quarterHourStor = 15;
  } else if (quarterHourStor > 15 && quarterHourStor <= 100) {
    // 15<かつ<=100の場合は、（上下端差÷4の切り上げ10又は５の倍数)
    quarterHourStor = Math.ceil(quarterHourStor / 5) * 5;
  } else {
    // 100<の場合は、（上下端差÷4の切り上げ１０の倍数)
    quarterHourStor = Math.ceil(quarterHourStor / 10) * 10;
  }

  graphData.min10.spec.stor.max =
    graphData.min10.spec.stor.min + quarterMin10Stor * 4;

  graphData.hour.spec.stor.max =
    graphData.hour.spec.stor.min + quarterHourStor * 4;

  graphData.min10.spec.all.max = mathMax(
    graphData.min10.spec.all.max,
    graphData.hour.spec.all.max
  );
  graphData.min10.spec.all.min = mathMin(
    graphData.min10.spec.all.min,
    graphData.hour.spec.all.min
  );

  let difMin10All =
    Math.ceil(graphData.min10.spec.all.max) - graphData.min10.spec.all.min;
  let quarterMin10All = difMin10All / 4;

  if (quarterMin10All <= 2) {
    // <＝2のときは2とする
    quarterMin10All = 2;
  } else if (quarterMin10All > 2 && quarterMin10All <= 20) {
    // 2<かつ<=20の場合は（上下端差÷4の切り上げ整数)
    quarterMin10All = Math.ceil(quarterMin10All);
  } else if (quarterMin10All > 20 && quarterMin10All <= 100) {
    // 20<かつ＜100の場合は（上下端差÷4の切り上げ10の倍数)
    quarterMin10All = Math.ceil(quarterMin10All / 10) * 10;
  } else {
    // 100<の場合は（上下端差÷４の切り上げ100の倍数）}
    quarterMin10All = Math.ceil(quarterMin10All / 100) * 100;
  }

  graphData.min10.spec.all.max =
    graphData.min10.spec.all.min + quarterMin10All * 4;

  graphData.hour.spec.all.max = graphData.min10.spec.all.max;
  graphData.hour.spec.all.min = graphData.min10.spec.all.min;

  return graphData;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "9%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "9%",
        },
        {
          text: "貯水位[m]",
          align: "center",
          value: "level",
          width: "9%",
        },
        {
          text: "貯水量[千m³]",
          align: "center",
          value: "storage",
          width: "9%",
        },
        {
          text: "貯水率利水容量[%]",
          align: "center",
          value: "irr",
          width: "9%",
        },
        {
          text: "貯水率有効容量[%]",
          align: "center",
          value: "effective",
          width: "9%",
        },
        {
          text: "貯水率治水容量[%]",
          align: "center",
          value: "flood",
          width: "9%",
        },
        {
          text: "全流入量[m³/s]",
          align: "center",
          value: "sink",
          width: "9%",
        },
        {
          text: "全放流量[m³/s]",
          align: "center",
          value: "disch",
          width: "9%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "9%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "9%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "9%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "9%",
        },
        {
          text: "貯水位[m]",
          align: "center",
          value: "level",
          width: "9%",
        },
        {
          text: "貯水量[千m³]",
          align: "center",
          value: "storage",
          width: "9%",
        },
        {
          text: "貯水率利水容量[%]",
          align: "center",
          value: "irr",
          width: "9%",
        },
        {
          text: "貯水率有効容量[%]",
          align: "center",
          value: "effective",
          width: "9%",
        },
        {
          text: "貯水率治水容量[%]",
          align: "center",
          value: "flood",
          width: "9%",
        },
        {
          text: "全流入量[m³/s]",
          align: "center",
          value: "sink",
          width: "9%",
        },
        {
          text: "全放流量[m³/s]",
          align: "center",
          value: "disch",
          width: "9%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "9%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "9%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < obsData.tmDamDetailObs.dam10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmDamDetailObs.dam10mList[i].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    let rain;
    let rainCcd;
    let total;
    let totalCcd;
    if (
      obsData.tmDamDetailInfo.relatTmObsFcd !== null &&
      obsData.tmDamDetailInfo.relatTmObsFcd !== "0000000000000"
    ) {
      rain = obsData.tmDamDetailObs.dam10mList[i].bsnrn10m;
      rainCcd = obsData.tmDamDetailObs.dam10mList[i].bsnrn10mCcd;
      total = obsData.tmDamDetailObs.dam10mList[i].bsnrnInc;
      totalCcd = obsData.tmDamDetailObs.dam10mList[i].bsnrnIncCcd;
    } else {
      rain = obsData.tmDamDetailObs.dam10mList[i].rdbsnrn10m;
      rainCcd = obsData.tmDamDetailObs.dam10mList[i].rdbsnrn10mCcd;
      total = obsData.tmDamDetailObs.dam10mList[i].rdbsnrnInc;
      totalCcd = obsData.tmDamDetailObs.dam10mList[i].rdbsnrnIncCcd;
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmDamDetailObs.dam10mList[i].obsTime,
        "HH:mm"
      ),
      level: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storLvl,
        obsData.tmDamDetailObs.dam10mList[i].storLvlCcd,
        2
      ),
      reservoirUnit: "m",
      storage: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storCap,
        obsData.tmDamDetailObs.dam10mList[i].storCapCcd,
        2
      ),
      irr: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrr,
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrrCcd,
        1
      ),
      effective: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storPcntEff,
        obsData.tmDamDetailObs.dam10mList[i].storPcntEffCcd,
        1
      ),
      flood: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].flood,
        obsData.tmDamDetailObs.dam10mList[i].floodCcd,
        1
      ),
      sink: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].allSink,
        obsData.tmDamDetailObs.dam10mList[i].allSinkCcd,
        2
      ),
      disch: checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].allDisch,
        obsData.tmDamDetailObs.dam10mList[i].allDischCcd,
        2
      ),
      rain: checkCcd(rain, rainCcd, 1),
      total: checkCcd(total, totalCcd, 1),
    });

    let copyMin10Value =
      Util.formatDate24(obsData.tmDamDetailObs.dam10mList[i].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmDamDetailObs.dam10mList[i].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storLvl,
        obsData.tmDamDetailObs.dam10mList[i].storLvlCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storCap,
        obsData.tmDamDetailObs.dam10mList[i].storCapCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrr,
        obsData.tmDamDetailObs.dam10mList[i].storPcntIrrCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].storPcntEff,
        obsData.tmDamDetailObs.dam10mList[i].storPcntEffCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].flood,
        obsData.tmDamDetailObs.dam10mList[i].floodCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].allSink,
        obsData.tmDamDetailObs.dam10mList[i].allSinkCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.dam10mList[i].allDisch,
        obsData.tmDamDetailObs.dam10mList[i].allDischCcd,
        2
      ) +
      "\t" +
      checkCcd(rain, rainCcd, 1) +
      "\t" +
      checkCcd(total, totalCcd, 1);
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(
      obsData.tmDamDetailObs.dam10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  // 時間観測値一覧データ
  obsTimeBefore = null;
  for (var j = 0; j < obsData.tmDamDetailObs.damHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmDamDetailObs.damHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    let rain;
    let rainCcd;
    let total;
    let totalCcd;
    if (
      obsData.tmDamDetailInfo.relatTmObsFcd !== null &&
      obsData.tmDamDetailInfo.relatTmObsFcd !== "0000000000000"
    ) {
      rain = obsData.tmDamDetailObs.damHrList[j].bsnrnHr;
      rainCcd = obsData.tmDamDetailObs.damHrList[j].bsnrnHrCcd;
      total = obsData.tmDamDetailObs.damHrList[j].bsnrnInc;
      totalCcd = obsData.tmDamDetailObs.damHrList[j].bsnrnIncCcd;
    } else {
      rain = obsData.tmDamDetailObs.damHrList[j].rdbsnrnHr;
      rainCcd = obsData.tmDamDetailObs.damHrList[j].rdbsnrnHrCcd;
      total = obsData.tmDamDetailObs.damHrList[j].rdbsnrnInc;
      totalCcd = obsData.tmDamDetailObs.damHrList[j].rdbsnrnIncCcd;
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmDamDetailObs.damHrList[j].obsTime,
        "HH:mm"
      ),
      level: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storLvl,
        obsData.tmDamDetailObs.damHrList[j].storLvlCcd,
        2
      ),
      reservoirUnit: "m",
      storage: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storCap,
        obsData.tmDamDetailObs.damHrList[j].storCapCcd,
        2
      ),
      irr: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storPcntIrr,
        obsData.tmDamDetailObs.damHrList[j].storPcntIrrCcd,
        1
      ),
      effective: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storPcntEff,
        obsData.tmDamDetailObs.damHrList[j].storPcntEffCcd,
        1
      ),
      flood: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].flood,
        obsData.tmDamDetailObs.damHrList[j].floodCcd,
        1
      ),
      sink: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].allSink,
        obsData.tmDamDetailObs.damHrList[j].allSinkCcd,
        2
      ),
      disch: checkCcd(
        obsData.tmDamDetailObs.damHrList[j].allDisch,
        obsData.tmDamDetailObs.damHrList[j].allDischCcd,
        2
      ),
      rain: checkCcd(rain, rainCcd, 1),
      total: checkCcd(total, totalCcd, 1),
    });

    let copyHrValue =
      Util.formatDate24(obsData.tmDamDetailObs.damHrList[j].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(obsData.tmDamDetailObs.damHrList[j].obsTime, "HH:mm") +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storLvl,
        obsData.tmDamDetailObs.damHrList[j].storLvlCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storCap,
        obsData.tmDamDetailObs.damHrList[j].storCapCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storPcntIrr,
        obsData.tmDamDetailObs.damHrList[j].storPcntIrrCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].storPcntEff,
        obsData.tmDamDetailObs.damHrList[j].storPcntEffCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].flood,
        obsData.tmDamDetailObs.damHrList[j].floodCcd
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].allSink,
        obsData.tmDamDetailObs.damHrList[j].allSinkCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmDamDetailObs.damHrList[j].allDisch,
        obsData.tmDamDetailObs.damHrList[j].allDischCcd,
        2
      ) +
      "\t" +
      checkCcd(rain, rainCcd, 1) +
      "\t" +
      checkCcd(total, totalCcd, 1);
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmDamDetailObs.damHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

/**
 * [ダム諸量観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataDamCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmDamDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [海岸観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsCoast(obsData) {
  return {
    tmCoastDetailInfo: obsData.tmCoastDetailInfo,
    obsInfo: createDataCoastObsInfo(obsData),
    standardValue: createDataCoastStandardValue(obsData),
    curt: createDataCoastCurt(obsData),
    graph: createDataCoastGraph(obsData),
    obsValues: createDataCoastValues(obsData),
    codeInfo: createDataCoastCodeInfo(obsData),
  };
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastObsInfo(obsData) {
  const info = obsData.tmCoastDetailInfo;
  let codeParam = "";
  if (info.jrsCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.jrsCd + codeParamTail;
  }
  return [
    {
      title: "管理者",
      value: formatFloat(info.jrsNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.jrsNmKana !== null ? info.jrsNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "ゼロ点高",
      value: formatFloat(info.dsgnWvHght),
      unit: "m",
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastStandardValue(obsData) {
  const info = obsData.tmCoastDetailInfo;
  return [
    {
      title: "1/3有義波高",
      value: formatCautWarn(info.wvHghtCaut, info.wvHghtWarn, "m", 2),
    },
    {
      title: "潮位",
      value: formatCautWarn(info.tidlvlCaut, info.tidlvlWarn, "T.P.m", 2),
    },
    {
      title: "平均風速",
      value: formatCautWarn(info.wndSpdCaut, info.wndSpdWarn, "m/s", 1),
    },
  ];
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastCurt(obsData) {
  const info = obsData.tmCoastDetailInfo;
  return {
    category: [
      {
        title: "潮位",
        master: [
          {
            label: "潮位",
            value: checkCcd(info.tidlvl, info.tidlvlCcd, 2),
            unit: checkCcdOfUnit("T.P.m", info.tidlvlCcd),
            ovflg: isBkColoringCutWrn(
              info.tidlvlCautOvflg,
              info.tidlvlWarnOvflg
            ),
          },
        ],
      },
      {
        title: "最大波",
        master: [
          {
            label: "波高",
            value: checkCcd(info.maxwvHght, info.maxwvHghtCcd, 2),
            unit: checkCcdOfUnit("m", info.maxwvHghtCcd),
            ovflg: false,
          },
          {
            label: "周期",
            value: checkCcd(info.maxwvCycl, info.maxwvCyclCcd, 1),
            unit: checkCcdOfUnit("s", info.maxwvCyclCcd),
            ovflg: false,
          },
        ],
      },
      {
        title: "1/3有義波",
        master: [
          {
            label: "波高",
            value: checkCcd(info.onthwvHght, info.onthwvHghtCcd, 2),
            unit: checkCcdOfUnit("m", info.onthwvHghtCcd),
            ovflg: isBkColoringCutWrn(
              info.onthwvHghtCautOvflg,
              info.onthwvHghtWarnOvflg
            ),
          },
          {
            label: "周期",
            value: checkCcd(info.onthwvCycl, info.onthwvCyclCcd, 1),
            unit: checkCcdOfUnit("s", info.onthwvCyclCcd),
            ovflg: false,
          },
        ],
      },
      {
        title: "風向・風速",
        master: [
          {
            label: "風向き",
            value: formatWndDir(checkCcd(info.avewndDir, info.avewndDirCcd)),
            unit: "",
            ovflg: false,
          },
          {
            label: "風速",
            value: checkCcd(info.avewndSpd, info.avewndSpdCcd, 1),
            unit: checkCcdOfUnit("m/s", info.avewndSpdCcd),
            ovflg: isBkColoringCutWrn(
              info.avewndSpdCautOvflg,
              info.avewndSpdWarnOvflg
            ),
          },
        ],
      },
    ],
    obs: [
      {
        title: "最大波高",
        value: checkCcd(info.maxwvHght, info.maxwvHghtCcd, 2),
        unit: checkCcdOfUnit("m", info.maxwvHghtCcd),
      },
      {
        title: "最大波周期",
        value: checkCcd(info.maxwvCycl, info.maxwvCyclCcd, 1),
        unit: checkCcdOfUnit("s", info.maxwvCyclCcd),
      },
      {
        title: "1/3有義波高",
        value: checkCcd(info.onthwvHght, info.onthwvHghtCcd, 2),
        unit: checkCcdOfUnit("m", info.onthwvHghtCcd),
      },
      {
        title: "1/3有義波周期",
        value: checkCcd(info.onthwvCycl, info.onthwvCyclCcd, 1),
        unit: checkCcdOfUnit("s", info.onthwvCyclCcd),
      },
      {
        title: "潮位",
        value: checkCcd(info.tidlvl, info.tidlvlCcd, 2),
        unit: checkCcdOfUnit("T.P.m", info.tidlvlCcd),
      },
      {
        title: "平均風向",
        value: formatWndDir(checkCcd(info.avewndDir, info.avewndDirCcd)),
        unit: "",
      },
      {
        title: "平均風速",
        value: checkCcd(info.avewndSpd, info.avewndSpdCcd, 1),
        unit: checkCcdOfUnit("m/s", info.avewndSpdCcd),
      },
    ],
    obsTime: !checkNotCollected(12, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastGraph(obsData) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        wndspd: {
          max: null,
          warning: obsData.tmCoastDetailInfo.wndSpdWarn,
          caution: obsData.tmCoastDetailInfo.wndSpdCaut,
          min: coastGraphWndspdMin,
          title: "風速",
          unit: "m/s",
        },
        wnddir: {
          title: "風向",
          unit: "",
        },
        tide: {
          max: null,
          warning: obsData.tmCoastDetailInfo.tidlvlWarn,
          caution: obsData.tmCoastDetailInfo.tidlvlCaut,
          min: null,
          minOrigin: null,
          title: "潮位",
          unit: "T.P.m",
        },
        wave: {
          max: null,
          warning: obsData.tmCoastDetailInfo.wvHghtWarn,
          caution: obsData.tmCoastDetailInfo.wvHghtCaut,
          min: null,
          minOrigin: null,
          title: "波高",
          unit: "m",
        },
        cycle: {
          max: null,
          min: null,
          title: "周期",
          unit: "s",
        },
        onthwvhght: {
          max: null,
          min: null,
        },
      },
      value: [],
    },
    min10: {
      spec: {
        wndspd: {
          max: null,
          warning: obsData.tmCoastDetailInfo.wndSpdWarn,
          caution: obsData.tmCoastDetailInfo.wndSpdCaut,
          min: coastGraphWndspdMin,
          title: "風速",
          unit: "m/s",
        },
        wnddir: {
          title: "風向",
          unit: "",
        },
        tide: {
          max: null,
          warning: obsData.tmCoastDetailInfo.tidlvlWarn,
          caution: obsData.tmCoastDetailInfo.tidlvlCaut,
          min: null,
          minOrigin: null,
          title: "潮位",
          unit: "T.P.m",
        },
        wave: {
          max: null,
          warning: obsData.tmCoastDetailInfo.wvHghtWarn,
          caution: obsData.tmCoastDetailInfo.wvHghtCaut,
          min: null,
          minOrigin: null,
          title: "波高",
          unit: "m",
        },
        cycle: {
          max: null,
          min: null,
          title: "周期",
          unit: "s",
        },
        onthwvhght: {
          max: null,
          min: null,
        },
      },
      value: [],
    },
  };

  // 10分グラフデータ
  for (var i = obsData.tmCoastDetailObs.coast10mList.length - 1; 0 <= i; i--) {
    let maxwvCycl = checkCcdForGraph(
      obsData.tmCoastDetailObs.coast10mList[i].maxwvCycl,
      obsData.tmCoastDetailObs.coast10mList[i].maxwvCyclCcd
    );
    let onthwvcycl = checkCcdForGraph(
      obsData.tmCoastDetailObs.coast10mList[i].onthwvCycl,
      obsData.tmCoastDetailObs.coast10mList[i].onthwvCyclCcd
    );

    // 最大値/最小値格納
    graphData.min10.spec.wndspd.max = mathMax(
      graphData.min10.spec.wndspd.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpd,
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdCcd
      )
    );
    graphData.min10.spec.tide.max = mathMax(
      graphData.min10.spec.tide.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvl,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCcd
      )
    );
    graphData.min10.spec.tide.min = mathMin(
      graphData.min10.spec.tide.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvl,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCcd
      )
    );

    graphData.min10.spec.wave.max = mathMax(
      graphData.min10.spec.wave.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHghtCcd
      )
    );
    graphData.min10.spec.wave.min = mathMin(
      graphData.min10.spec.wave.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHghtCcd
      )
    );
    graphData.min10.spec.cycle.max = mathMax(
      graphData.min10.spec.cycle.max,
      maxwvCycl,
      onthwvcycl
    );
    graphData.min10.spec.cycle.min = mathMin(
      graphData.min10.spec.cycle.min,
      maxwvCycl,
      onthwvcycl
    );
    graphData.min10.spec.onthwvhght.max = mathMax(
      graphData.min10.spec.onthwvhght.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCcd
      )
    );
    graphData.min10.spec.onthwvhght.min = mathMin(
      graphData.min10.spec.onthwvhght.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCcd
      )
    );

    graphData.min10.value.unshift({
      date: Util.formatDate24(
        obsData.tmCoastDetailObs.coast10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmCoastDetailObs.coast10mList[i].obsTime,
        "HH:mm"
      ),
      wnddir: checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].avewndDir,
        obsData.tmCoastDetailObs.coast10mList[i].avewndDirCcd
      ),
      wndspd: checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpd,
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdCcd
      ),
      maxwvhght: checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHghtCcd
      ),
      maxwvcycl: maxwvCycl,
      onthwvhght: checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCcd
      ),
      onthwvcycl: onthwvcycl,
      tidlvl: checkCcdForGraph(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvl,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCcd
      ),
    });
  }

  // 注意値/警戒値を含めて上限値を算出(潮位/波高の上限値算出には有義波高も使用する)
  graphData.min10.spec.tide.max = mathMax(
    graphData.min10.spec.tide.max,
    obsData.tmCoastDetailInfo.tidlvlCaut,
    obsData.tmCoastDetailInfo.tidlvlWarn,
    // graphData.min10.spec.wave.max,
    graphData.min10.spec.onthwvhght.max,
    obsData.tmCoastDetailInfo.wvHghtCaut,
    obsData.tmCoastDetailInfo.wvHghtWarn
  );
  graphData.min10.spec.wave.max = mathMax(
    graphData.min10.spec.wave.max,
    graphData.min10.spec.onthwvhght.max,
    obsData.tmCoastDetailInfo.wvHghtCaut,
    obsData.tmCoastDetailInfo.wvHghtWarn
  );
  graphData.min10.spec.wndspd.max = mathMax(
    graphData.min10.spec.wndspd.max,
    obsData.tmCoastDetailInfo.wndSpdCaut,
    obsData.tmCoastDetailInfo.wndSpdWarn
  );

  // 注意値/警戒値を含めて下限値を算出(潮位/波高の下限値算出には有義波高も使用する)
  graphData.min10.spec.tide.min = mathMin(
    graphData.min10.spec.tide.min,
    obsData.tmCoastDetailInfo.tidlvlCaut,
    obsData.tmCoastDetailInfo.tidlvlWarn,
    // graphData.min10.spec.wave.min,
    graphData.min10.spec.onthwvhght.min,
    obsData.tmCoastDetailInfo.wvHghtCaut,
    obsData.tmCoastDetailInfo.wvHghtWarn
  );
  graphData.min10.spec.wave.min = mathMin(
    graphData.min10.spec.wave.min,
    graphData.min10.spec.onthwvhght.min,
    obsData.tmCoastDetailInfo.wvHghtCaut,
    obsData.tmCoastDetailInfo.wvHghtWarn
  );

  // 時間グラフデータ
  for (var j = obsData.tmCoastDetailObs.coastHrList.length - 1; 0 <= j; j--) {
    let maxwvCycl = checkCcdForGraph(
      obsData.tmCoastDetailObs.coastHrList[j].maxwvCycl,
      obsData.tmCoastDetailObs.coastHrList[j].maxwvCyclCcd
    );
    let onthwvcycl = checkCcdForGraph(
      obsData.tmCoastDetailObs.coastHrList[j].onthwvCycl,
      obsData.tmCoastDetailObs.coastHrList[j].onthwvCyclCcd
    );

    // 最大値/最小値格納
    graphData.hour.spec.wndspd.max = mathMax(
      graphData.hour.spec.wndspd.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpd,
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdCcd
      )
    );
    graphData.hour.spec.tide.max = mathMax(
      graphData.hour.spec.tide.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvl,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCcd
      )
    );
    graphData.hour.spec.tide.min = mathMin(
      graphData.hour.spec.tide.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvl,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCcd
      )
    );
    graphData.hour.spec.wave.max = mathMax(
      graphData.hour.spec.wave.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHghtCcd
      )
    );
    graphData.hour.spec.wave.min = mathMin(
      graphData.hour.spec.wave.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHghtCcd
      )
    );
    graphData.hour.spec.cycle.max = mathMax(
      graphData.hour.spec.cycle.max,
      maxwvCycl,
      onthwvcycl
    );
    graphData.hour.spec.cycle.min = mathMin(
      graphData.hour.spec.cycle.min,
      maxwvCycl,
      onthwvcycl
    );
    graphData.hour.spec.onthwvhght.max = mathMax(
      graphData.hour.spec.onthwvhght.max,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCcd
      )
    );
    graphData.hour.spec.onthwvhght.min = mathMin(
      graphData.hour.spec.onthwvhght.min,
      checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCcd
      )
    );

    graphData.hour.value.unshift({
      date: Util.formatDate24(
        obsData.tmCoastDetailObs.coastHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmCoastDetailObs.coastHrList[j].obsTime,
        "HH:mm"
      ),
      wnddir: checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].avewndDir,
        obsData.tmCoastDetailObs.coastHrList[j].avewndDirCcd
      ),
      wndspd: checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpd,
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdCcd
      ),
      maxwvhght: checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHghtCcd
      ),
      maxwvcycl: maxwvCycl,
      onthwvhght: checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCcd
      ),
      onthwvcycl: onthwvcycl,
      tidlvl: checkCcdForGraph(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvl,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCcd
      ),
    });

    // 注意値/警戒値を含めて上限値を算出(潮位/波高の上限値算出には有義波高も使用する)
    graphData.hour.spec.tide.max = mathMax(
      graphData.hour.spec.tide.max,
      obsData.tmCoastDetailInfo.tidlvlCaut,
      obsData.tmCoastDetailInfo.tidlvlWarn,
      graphData.hour.spec.onthwvhght.max,
      obsData.tmCoastDetailInfo.wvHghtCaut,
      obsData.tmCoastDetailInfo.wvHghtWarn
    );
    graphData.hour.spec.wave.max = mathMax(
      graphData.hour.spec.wave.max,
      graphData.hour.spec.onthwvhght.max,
      obsData.tmCoastDetailInfo.wvHghtCaut,
      obsData.tmCoastDetailInfo.wvHghtWarn
    );
    graphData.hour.spec.wndspd.max = mathMax(
      graphData.hour.spec.wndspd.max,
      obsData.tmCoastDetailInfo.wndSpdCaut,
      obsData.tmCoastDetailInfo.wndSpdWarn
    );

    // 注意値/警戒値を含めて下限値を算出(潮位/波高の下限値算出には有義波高も使用する)
    graphData.hour.spec.tide.min = mathMin(
      graphData.hour.spec.tide.min,
      obsData.tmCoastDetailInfo.tidlvlCaut,
      obsData.tmCoastDetailInfo.tidlvlWarn,
      graphData.hour.spec.onthwvhght.min,
      obsData.tmCoastDetailInfo.wvHghtCaut,
      obsData.tmCoastDetailInfo.wvHghtWarn
    );
    graphData.hour.spec.wave.min = mathMin(
      graphData.hour.spec.wave.min,
      graphData.hour.spec.onthwvhght.min,
      obsData.tmCoastDetailInfo.wvHghtCaut,
      obsData.tmCoastDetailInfo.wvHghtWarn
    );
  }

  // 10分と時間で、上下限を合わせる
  graphData.min10.spec.tide.max = mathMax(
    graphData.min10.spec.tide.max,
    graphData.hour.spec.tide.max
  );
  graphData.hour.spec.tide.max = graphData.min10.spec.tide.max;

  graphData.min10.spec.tide.min = mathMin(
    graphData.min10.spec.tide.min,
    graphData.hour.spec.tide.min
  );
  graphData.hour.spec.tide.min = graphData.min10.spec.tide.min;

  graphData.min10.spec.wave.max = mathMax(
    graphData.min10.spec.wave.max,
    graphData.hour.spec.wave.max
  );
  graphData.hour.spec.wave.max = graphData.min10.spec.wave.max;

  graphData.min10.spec.wave.min = mathMin(
    graphData.min10.spec.wave.min,
    graphData.hour.spec.wave.min
  );
  graphData.hour.spec.wave.min = graphData.min10.spec.wave.min;

  graphData.min10.spec.cycle.max = mathMax(
    graphData.min10.spec.cycle.max,
    graphData.hour.spec.cycle.max
  );
  graphData.hour.spec.cycle.max = graphData.min10.spec.cycle.max;

  graphData.min10.spec.cycle.min = mathMin(
    graphData.min10.spec.cycle.min,
    graphData.hour.spec.cycle.min
  );
  graphData.hour.spec.cycle.min = graphData.min10.spec.cycle.min;

  graphData.min10.spec.wndspd.max = mathMax(
    graphData.min10.spec.wndspd.max,
    graphData.hour.spec.wndspd.max
  );
  graphData.hour.spec.wndspd.max = graphData.min10.spec.wndspd.max;

  // 潮位/波高の下限値を複製しておく
  graphData.min10.spec.tide.minOrigin = graphData.min10.spec.tide.min;
  graphData.min10.spec.wave.minOrigin = graphData.min10.spec.wave.min;
  graphData.hour.spec.tide.minOrigin = graphData.hour.spec.tide.min;
  graphData.hour.spec.wave.minOrigin = graphData.hour.spec.wave.min;

  // 潮位

  // 上端：最大値の小数点第一位を切り上げ
  // 下端：最小値の小数点第一位を切り下げ
  graphData.min10.spec.tide.max = Math.ceil(graphData.min10.spec.tide.max);
  // graphData.min10.spec.tide.min = Math.floor(graphData.min10.spec.tide.min);
  // 下限を5の倍数にする
  graphData.min10.spec.tide.min =
    Math.floor(graphData.min10.spec.tide.min / 5) * 5;

  graphData.min10.spec.wave.max = Math.ceil(graphData.min10.spec.wave.max);
  // 下限を5の倍数にする
  graphData.min10.spec.wave.min =
    Math.floor(graphData.min10.spec.wave.min / 5) * 5;

  // 潮位・波高で最大・最小を揃える
  let max = mathMax(
    graphData.min10.spec.tide.max,
    graphData.min10.spec.wave.max
  );
  let min = mathMin(
    graphData.min10.spec.tide.min,
    graphData.min10.spec.wave.min
  );

  // let difMin10Tide =
  //   graphData.min10.spec.tide.max - graphData.min10.spec.tide.min;
  let difMin10Tide = max - min;

  let quarterMin10Tide = difMin10Tide / 4;

  if (quarterMin10Tide <= 0.5) {
    // <=0.5は0.5
    quarterMin10Tide = 0.5;
  } else if (quarterMin10Tide > 0.5 && quarterMin10Tide <= 10) {
    // 0.5<かつ<=10は、小数点第一位を切り上げる
    quarterMin10Tide = Math.ceil(quarterMin10Tide);
  } else {
    // １０<以上は、一の位を切り上げ5の倍数
    quarterMin10Tide = Math.ceil(quarterMin10Tide / 5) * 5;
  }

  graphData.min10.spec.tide.max = min + quarterMin10Tide * 4;
  graphData.min10.spec.tide.min = min;

  graphData.hour.spec.tide.max = graphData.min10.spec.tide.max;
  graphData.hour.spec.tide.min = graphData.min10.spec.tide.min;

  // 波高の最大・最小を設定
  graphData.min10.spec.wave.max = graphData.min10.spec.tide.max;
  graphData.min10.spec.wave.min = graphData.min10.spec.tide.min;
  graphData.hour.spec.wave.max = graphData.min10.spec.wave.max;
  graphData.hour.spec.wave.min = graphData.min10.spec.wave.min;

  // 周期

  // 上端：最大値の小数点第一位を切り上げ
  // 下端：最小値の小数点第一位を切り下げ
  graphData.min10.spec.cycle.max = Math.ceil(graphData.min10.spec.cycle.max);
  // graphData.min10.spec.cycle.min = Math.floor(graphData.min10.spec.cycle.min);
  // 下限を5の倍数にする
  graphData.min10.spec.cycle.min =
    Math.floor(graphData.min10.spec.cycle.min / 5) * 5;

  let difMin10Cycle =
    graphData.min10.spec.cycle.max - graphData.min10.spec.cycle.min;
  let quarterMin10Cycle = difMin10Cycle / 4;

  if (quarterMin10Cycle <= 0.5) {
    // <=0.5は0.5
    quarterMin10Cycle = 0.5;
  } else if (quarterMin10Cycle > 0.5 && quarterMin10Cycle <= 10) {
    // 0.5<かつ<=10は、小数点第一位を切り上げる
    quarterMin10Cycle = Math.ceil(quarterMin10Cycle);
  } else {
    // 10<以上は、一の位を切り上げ
    quarterMin10Cycle = Math.ceil(quarterMin10Cycle / 5) * 5;
  }

  graphData.min10.spec.cycle.max =
    graphData.min10.spec.cycle.min + quarterMin10Cycle * 4;
  graphData.hour.spec.cycle.max = graphData.min10.spec.cycle.max;
  graphData.hour.spec.cycle.min = graphData.min10.spec.cycle.min;

  // 風速

  // 上端：最大値の小数点第一位を切り上げ、０，５で丸めて切り上げる
  // 下端：常に０
  graphData.min10.spec.wndspd.max = Math.ceil(graphData.min10.spec.wndspd.max);
  // graphData.min10.spec.wndspd.min = Math.ceil(graphData.min10.spec.wndspd.min);
  graphData.min10.spec.wndspd.min = 0;

  let difMin10Wndspd =
    graphData.min10.spec.wndspd.max - graphData.min10.spec.wndspd.min;
  let quarterMin10Wndspd = difMin10Wndspd / 4;

  if (quarterMin10Wndspd <= 0.5) {
    // <=0.5は0.5
    quarterMin10Wndspd = 0.5;
  } else if (quarterMin10Wndspd > 0.5 && quarterMin10Wndspd <= 3) {
    // 0.5<かつ<=3は、小数点第一位を切り上げ
    quarterMin10Wndspd = Math.ceil(quarterMin10Wndspd);
  } else if (quarterMin10Wndspd > 3 && quarterMin10Wndspd <= 5) {
    // 3<かつ<=5は、5
    quarterMin10Wndspd = 5;
  } else if (quarterMin10Wndspd > 5 && quarterMin10Wndspd <= 10) {
    // 5<かつ<=10は、10
    quarterMin10Wndspd = 10;
  } else {
    // 10<以上は、一の位を切り上げ5の倍数
    quarterMin10Wndspd = Math.ceil(quarterMin10Wndspd / 5) * 5;
  }

  graphData.min10.spec.wndspd.max =
    graphData.min10.spec.wndspd.min + quarterMin10Wndspd * 4;
  graphData.hour.spec.wndspd.max = graphData.min10.spec.wndspd.max;
  graphData.hour.spec.wndspd.min = graphData.min10.spec.wndspd.min;

  return graphData;
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "11%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "11%",
        },
        {
          text: "潮位[T.P.m]",
          align: "center",
          value: "tidlvl",
          width: "11%",
        },
        {
          text: "最大波高[m]",
          align: "center",
          value: "maxwvhght",
          width: "11%",
        },
        {
          text: "最大波周期[s]",
          align: "center",
          value: "maxwvcycl",
          width: "11%",
        },
        {
          text: "1/3有義波波高[m]",
          align: "center",
          value: "onthwvhght",
          width: "11%",
        },
        {
          text: "1/3有義波周期[s]",
          align: "center",
          value: "onthwvcycl",
          width: "11%",
        },
        {
          text: "平均風向",
          align: "center",
          value: "wnddir",
          width: "11%",
        },
        {
          text: "平均風速[m/s]",
          align: "center",
          value: "wndspd",
          width: "11%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "11%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "11%",
        },
        {
          text: "潮位[T.P.m]",
          align: "center",
          value: "tidlvl",
          width: "11%",
        },
        {
          text: "最大波高[m]",
          align: "center",
          value: "maxwvhght",
          width: "11%",
        },
        {
          text: "最大波周期[s]",
          align: "center",
          value: "maxwvcycl",
          width: "11%",
        },
        {
          text: "1/3有義波波高[m]",
          align: "center",
          value: "onthwvhght",
          width: "11%",
        },
        {
          text: "1/3有義波周期[s]",
          align: "center",
          value: "onthwvcycl",
          width: "11%",
        },
        {
          text: "平均風向",
          align: "center",
          value: "wnddir",
          width: "11%",
        },
        {
          text: "平均風速[m/s]",
          align: "center",
          value: "wndspd",
          width: "11%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  // 10分観測値一覧データ
  let obsTime;
  let obsTimeBefore;
  for (var i = 0; i < obsData.tmCoastDetailObs.coast10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmCoastDetailObs.coast10mList[i].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }
    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmCoastDetailObs.coast10mList[i].obsTime,
        "HH:mm"
      ),
      tidlvl: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvl,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCcd,
        2
      ),
      tidlvlovcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCautOvflg,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlWarnOvflg
      ),
      maxwvhght: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHghtCcd,
        2
      ),
      maxwvcycl: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvCycl,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvCyclCcd,
        1
      ),
      onthwvhght: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCcd,
        2
      ),
      onthwvhghtcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCautOvflg,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtWarnOvflg
      ),
      onthwvcycl: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvCycl,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvCyclCcd,
        1
      ),
      wnddir: formatWndDir(
        checkCcd(
          obsData.tmCoastDetailObs.coast10mList[i].avewndDir,
          obsData.tmCoastDetailObs.coast10mList[i].avewndDirCcd
        )
      ),
      wndspd: checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpd,
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdCcd,
        1
      ),
      wndspdovfcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdCautOvflg,
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdWarnOvflg
      ),
    });

    let copyMin10Value =
      Util.formatDate24(
        obsData.tmCoastDetailObs.coast10mList[i].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmCoastDetailObs.coast10mList[i].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].tidlvl,
        obsData.tmCoastDetailObs.coast10mList[i].tidlvlCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvHghtCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].maxwvCycl,
        obsData.tmCoastDetailObs.coast10mList[i].maxwvCyclCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHght,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvHghtCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].onthwvCycl,
        obsData.tmCoastDetailObs.coast10mList[i].onthwvCyclCcd,
        1
      ) +
      "\t" +
      formatWndDir(
        checkCcd(
          obsData.tmCoastDetailObs.coast10mList[i].avewndDir,
          obsData.tmCoastDetailObs.coast10mList[i].avewndDirCcd
        )
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpd,
        obsData.tmCoastDetailObs.coast10mList[i].avewndSpdCcd,
        1
      );
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(
      obsData.tmCoastDetailObs.coast10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  obsTimeBefore = null;
  for (var j = 0; j < obsData.tmCoastDetailObs.coastHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmCoastDetailObs.coastHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }
    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmCoastDetailObs.coastHrList[j].obsTime,
        "HH:mm"
      ),
      tidlvl: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvl,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCcd,
        2
      ),
      maxwvhght: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHghtCcd,
        2
      ),
      tidlvlovcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCautOvflg,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlWarnOvflg
      ),
      maxwvcycl: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvCycl,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvCyclCcd,
        1
      ),
      onthwvhght: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCcd,
        2
      ),
      onthwvhghtcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCautOvflg,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtWarnOvflg
      ),
      onthwvcycl: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvCycl,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvCyclCcd,
        1
      ),
      wnddir: formatWndDir(
        checkCcd(
          obsData.tmCoastDetailObs.coastHrList[j].avewndDir,
          obsData.tmCoastDetailObs.coastHrList[j].avewndDirCcd
        )
      ),
      wndspd: checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpd,
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdCcd,
        1
      ),
      wndspdovfcutwrn: isBkColoringCutWrn(
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdCautOvflg,
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdWarnOvflg
      ),
    });

    let copyHrValue =
      Util.formatDate24(
        obsData.tmCoastDetailObs.coastHrList[j].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmCoastDetailObs.coastHrList[j].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].tidlvl,
        obsData.tmCoastDetailObs.coastHrList[j].tidlvlCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvHghtCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].maxwvCycl,
        obsData.tmCoastDetailObs.coastHrList[j].maxwvCyclCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHght,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvHghtCcd,
        2
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].onthwvCycl,
        obsData.tmCoastDetailObs.coastHrList[j].onthwvCyclCcd,
        1
      ) +
      "\t" +
      formatWndDir(
        checkCcd(
          obsData.tmCoastDetailObs.coastHrList[j].avewndDir,
          obsData.tmCoastDetailObs.coastHrList[j].avewndDirCcd
        )
      ) +
      "\t" +
      checkCcd(
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpd,
        obsData.tmCoastDetailObs.coastHrList[j].avewndSpdCcd,
        1
      );
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmCoastDetailObs.coastHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

/**
 * [海岸観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataCoastCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.tmCoastDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.obsCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [レーダ流域観測所情報]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsRdBsn(obsData) {
  return {
    tmRdBsnDetailInfo: obsData.tmRdBsnDetailInfo,
    obsInfo: createDataRdBsnObsInfo(obsData),
    standardValue: createDataRdBsnStandardValue(obsData),
    curt: createDataRdBsnCurt(obsData),
    graph: createDataRdBsnGraph(obsData),
    obsValues: createDataRdBsnValues(obsData),
  };
}

/**
 * [レーダ流域観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRdBsnObsInfo(obsData) {
  const info = obsData.tmRdBsnDetailInfo;
  return [
    {
      title: "位置",
      value: formatFloat(info.obsSadr),
    },
    {
      title: "所在地",
      value: formatFloat(info.obsAdr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.obsAdrKana !== null ? info.obsAdrKana : invalidStr,
      notMb: true,
    },
    {
      title: "流域面積",
      value: formatFloat(info.bsnArea),
      unit: "km&sup2;",
    },
    {
      title: "水文水質関連情報",
      value: invalidStr,
      obsValue: "観測所情報",
      qwtrObsCd: info.qwtrObsCd,
      dbLink: info.dbLink,
    },
  ];
}

/**
 * [レーダ流域観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRdBsnStandardValue(obsData) {
  const info = obsData.tmRdBsnDetailInfo;
  return [
    {
      title: "時間雨量",
      value: formatCautWarn(info.rnHrCaut, info.rnHrWarn, "mm", 1),
    },
    {
      title: "10分雨量",
      value: formatCautWarn(info.rn10mCaut, info.rn10mWarn, "mm", 1),
    },
    {
      title: "降り始めからの雨量",
      value: formatCautWarn(info.rnIncCaut, info.rnIncWarn, "mm", 1),
    },
  ];
}

/**
 * [レーダ流域観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRdBsnCurt(obsData) {
  const info = obsData.tmRdBsnDetailInfo;
  return {
    category: [
      {
        title: "時間雨量",
        value: checkCcd(info.rdbsnrnHr10m, info.rdbsnrnHr10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.rdbsnrnHr10mCcd),
        ovflg: isBkColoringCutWrn(
          info.rdbsnrnHr10mCautOvflg,
          info.rdbsnrnHr10mWarnOvflg
        ),
        bgColor: checkRainBgColor(info.rdbsnrnHr10mCcd),
      },
      {
        title: "10分雨量",
        value: checkCcd(info.rdbsnrn10m, info.rdbsnrn10mCcd, 1),
        unit: checkCcdOfUnit("mm", info.rdbsnrn10mCcd),
        ovflg: isBkColoringCutWrn(
          info.rdbsnrn10mCautOvflg,
          info.rdbsnrn10mWarnOvflg
        ),
        bgColor: checkRainBgColor(info.rdbsnrn10mCcd),
      },
      {
        title: "降り始めからの雨量",
        value: checkCcd(info.rdbsnrnInc, info.rdbsnrnIncCcd, 1),
        unit: checkCcdOfUnit("mm", info.rdbsnrnIncCcd),
        ovflg: isBkColoringCutWrn(
          info.rdbsnrnIncCautOvflg,
          info.rdbsnrnIncWarnOvflg
        ),
        bgColor: checkRainBgColor(info.rdbsnrnIncCcd),
      },
    ],
    obsTime: !checkNotCollected(20, info)
      ? formatDateNonNull(info.obsTime)
      : invalidStr,
  };
}

/**
 * [レーダ流域観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRdBsnGraph(obsData) {
  // グラフデータ成形
  let graphData = {
    hour: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmRdBsnDetailInfo.rnHrWarn,
          caution: obsData.tmRdBsnDetailInfo.rnHrCaut,
          min: rdBsnGraphMin10Min,
          title: "時間雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmRdBsnDetailInfo.rnIncWarn,
          caution: obsData.tmRdBsnDetailInfo.rnIncCaut,
          min: rdBsnGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
    min10: {
      spec: {
        rain: {
          max: 0,
          warning: obsData.tmRdBsnDetailInfo.rn10mWarn,
          caution: obsData.tmRdBsnDetailInfo.rn10mCaut,
          min: rdBsnGraphHourMin,
          title: "10分雨量",
          unit: "mm",
        },
        total: {
          max: 0,
          warning: obsData.tmRdBsnDetailInfo.rnIncWarn,
          caution: obsData.tmRdBsnDetailInfo.rnIncCaut,
          min: rdBsnGraphTotalMin,
          title: "累加雨量",
          unit: "mm",
        },
      },
      value: [],
    },
  };

  // 10分グラフデータ
  for (var i = 0; i < obsData.tmRdBsnDetailObs.rdbsnrn10mList.length; i++) {
    graphData.min10.spec.rain.max = mathMax(
      graphData.min10.spec.rain.max,
      checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10m,
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10mCcd
      )
    );
    graphData.min10.spec.total.max = mathMax(
      graphData.min10.spec.total.max,
      checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnIncCcd
      )
    );

    graphData.min10.value.push({
      date: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10m,
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10mCcd
      ),
      total: checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    obsData.tmRdBsnDetailInfo.rn10mCaut,
    obsData.tmRdBsnDetailInfo.rn10mWarn
  );
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    obsData.tmRdBsnDetailInfo.rnIncCaut,
    obsData.tmRdBsnDetailInfo.rnIncWarn
  );

  // 1の位を切り捨て
  graphData.min10.spec.rain.max = valueCeil(graphData.min10.spec.rain.max, 10);
  graphData.min10.spec.total.max = valueCeil(
    graphData.min10.spec.total.max,
    10
  );

  // 最大値セット
  graphData.min10.spec.rain.max = graphMaxAdd(
    graphData.min10.spec.rain.max,
    rdBsnGraphMin10MaxAdd,
    rdBsnGraphMin10Max
  );
  graphData.min10.spec.total.max = graphMaxAdd(
    graphData.min10.spec.total.max,
    rdBsnGraphTotalMaxAdd,
    rdBsnGraphTotalMax
  );

  // 上限値・下限値の値調整
  graphData.min10.spec.rain.max = roundMax(
    graphData.min10.spec.rain.max,
    rdBsnGraphMin10MaxAdd,
    rdBsnGraphMin10Max,
    10
  );
  graphData.min10.spec.total.max = roundMax(
    graphData.min10.spec.total.max,
    rdBsnGraphTotalMaxAdd,
    rdBsnGraphTotalMax,
    10
  );

  // 時間グラフデータ
  for (var j = 0; j < obsData.tmRdBsnDetailObs.rdbsnrnHrList.length; j++) {
    graphData.hour.spec.rain.max = mathMax(
      graphData.hour.spec.rain.max,
      checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHr,
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHrCcd
      )
    );
    graphData.hour.spec.total.max = mathMax(
      graphData.hour.spec.total.max,
      checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnIncCcd
      )
    );

    graphData.hour.value.push({
      date: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].obsTime,
        "YYYY/MM/DD"
      ),
      time: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHr,
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHrCcd
      ),
      total: checkCcdForGraph(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnIncCcd
      ),
    });
  }

  // 注意値/警戒値を含めて最大値を算出
  graphData.hour.spec.rain.max = mathMax(
    graphData.hour.spec.rain.max,
    obsData.tmRdBsnDetailInfo.rnHrCaut,
    obsData.tmRdBsnDetailInfo.rnHrWarn
  );
  graphData.hour.spec.total.max = mathMax(
    graphData.hour.spec.total.max,
    obsData.tmRdBsnDetailInfo.rnIncCaut,
    obsData.tmRdBsnDetailInfo.rnIncWarn
  );

  // 1の位を切り捨て
  graphData.hour.spec.rain.max = valueCeil(graphData.hour.spec.rain.max, 10);
  graphData.hour.spec.total.max = valueCeil(graphData.hour.spec.total.max, 10);

  // 最大値セット
  graphData.hour.spec.rain.max = graphMaxAdd(
    graphData.hour.spec.rain.max,
    rdBsnGraphHourMaxAdd,
    rdBsnGraphHourMax
  );
  graphData.hour.spec.total.max = graphMaxAdd(
    graphData.hour.spec.total.max,
    rdBsnGraphTotalMaxAdd,
    rdBsnGraphTotalMax
  );

  // 上限値・下限値の値調整
  graphData.hour.spec.rain.max = roundMax(
    graphData.hour.spec.rain.max,
    rdBsnGraphHourMaxAdd,
    rdBsnGraphHourMax,
    10
  );
  graphData.hour.spec.total.max = roundMax(
    graphData.hour.spec.total.max,
    rdBsnGraphTotalMaxAdd,
    rdBsnGraphTotalMax,
    10
  );

  // 10分と時間で、上限を合わせる
  graphData.min10.spec.rain.max = mathMax(
    graphData.min10.spec.rain.max,
    graphData.hour.spec.rain.max
  );
  graphData.hour.spec.rain.max = graphData.min10.spec.rain.max;
  graphData.min10.spec.total.max = mathMax(
    graphData.min10.spec.total.max,
    graphData.hour.spec.total.max
  );
  graphData.hour.spec.total.max = graphData.min10.spec.total.max;

  return graphData;
}

/**
 * [レーダ流域観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataRdBsnValues(obsData) {
  // 観測値一覧データ成形
  let valuesData = {
    hour: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "時間雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "25%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "25%",
        },
        {
          text: "10分雨量[mm]",
          align: "center",
          value: "rain",
          width: "25%",
        },
        {
          text: "降り始めからの雨量[mm]",
          align: "center",
          value: "total",
          width: "25%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(getCopyHeader(valuesData.min10.headers));
  valuesData.hour.copyValues.push(getCopyHeader(valuesData.hour.headers));

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < obsData.tmRdBsnDetailObs.rdbsnrn10mList.length; i++) {
    obsTime = Util.formatDate24(
      obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10m,
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10mCcd,
        1
      ),
      total: checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnIncCcd,
        1
      ),
    });

    let copyMin10Value =
      Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10m,
        obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].rdbsnrn10mCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrn10mIncList[i].rdbsnrnIncCcd,
        1
      );
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(
      obsData.tmRdBsnDetailObs.rdbsnrn10mList[i].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  // 時間観測値一覧データ
  obsTimeBefore = null;
  for (var j = 0; j < obsData.tmRdBsnDetailObs.rdbsnrnHrList.length; j++) {
    obsTime = Util.formatDate24(
      obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].obsTime,
      "MM/DD"
    );
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.hour.values.push({
      cd: j,
      date: obsTime,
      time: Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].obsTime,
        "HH:mm"
      ),
      rain: checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHr,
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHrCcd,
        1
      ),
      total: checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnIncCcd,
        1
      ),
    });

    let copyHrValue =
      Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].obsTime,
        "MM/DD"
      ) +
      "\t" +
      Util.formatDate24(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].obsTime,
        "HH:mm"
      ) +
      "\t" +
      checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHr,
        obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].rdbsnrnHrCcd,
        1
      ) +
      "\t" +
      checkCcd(
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnInc,
        obsData.tmRdBsnDetailObs.rdbsnrnHrIncList[j].rdbsnrnIncCcd,
        1
      );
    valuesData.hour.copyValues.push(copyHrValue);

    obsTimeBefore = Util.formatDate24(
      obsData.tmRdBsnDetailObs.rdbsnrnHrList[j].obsTime,
      "MM/DD"
    );
    obsTime = "";
  }

  return valuesData;
}

//------------------------------------------------------------
/**
 * [河川カメラ]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsCctv(obsData) {
  return {
    cctvDetailInfo: obsData.cctvDetailInfo,
    obsInfo: createDataCctvObsInfo(obsData),
    cctvInfo: createDataCctvInfo(obsData),
    codeInfo: createDataCctvCodeInfo(obsData),
  };
}

/**
 * [河川カメラ]観測所情報取得
 * @param {*} obsData
 */
function createDataCctvObsInfo(obsData) {
  const info = obsData.cctvDetailInfo;
  // 水位観測所コード
  let codeParam = "";
  if (info.ofcCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.ofcCd + codeParamTail;
  }
  let codeParamLinkObs = "";
  if (info.obsCd !== null && global.KWB_MODE === "admin") {
    codeParamLinkObs = codeParamHeadLinkObs + info.obsCd + codeParamTailLinkObs;
  }

  // 危機水位観測所コード
  let swCodeParamLinkObs = "";
  if (info.obsCd !== null && global.KWB_MODE === "admin") {
    swCodeParamLinkObs =
      codeParamHeadLinkObs + info.swobsCd + codeParamTailLinkObs;
  }

  return [
    {
      title: "管理者",
      value: formatFloat(info.ownName),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.ownKana !== null ? info.ownKana : invalidStr,
      notMb: true,
    },
    {
      title: "所在地",
      value: formatFloat(info.addr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.addrKana !== null ? info.addrKana : invalidStr,
      notMb: true,
    },
    {
      title: "関連水位観測所",
      value: formatStgSw([info.obsNm, info.swobsNm]),
      ofcCd: [info.obsOfcCd, info.swofcCd],
      itmkndCd: [info.itmkndCd, info.swobsCd != null ? 300 : null],
      obsCd: [info.obsCd, info.swobsCd],
      code: [codeParamLinkObs, swCodeParamLinkObs],
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
  ];
}

/**
 * [河川カメラ]画像情報取得
 * @param {*} obsData
 */
function createDataCctvInfo(obsData) {
  let result = {
    latestUrl: obsData.cctvDetailInfo.currProvUrl,
    usualUrl: obsData.cctvDetailInfo.normProvUrl,
    subLatestUrl: obsData.cctvDetailInfo.currentUrl,
    subUsualUrl: obsData.cctvDetailInfo.normallyUrl,
    liveUrl: obsData.cctvDetailInfo.liveUrl,
    camKind: obsData.cctvDetailInfo.camKind,
    sysId: obsData.cctvDetailInfo.sysId,
  };
  return result;
}

/**
 * [河川カメラ]
 * @param {*} obsData 観測所情報
 */
function createDataCctvCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.cctvDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.ownCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------
/**
 * [簡易カメラ]表示データ作成
 * @param {*} obsData 観測所情報
 */
function convertObsScam(obsData) {
  return {
    scamDetailInfo: obsData.scamDetailInfo,
    obsInfo: createDataScamObsInfo(obsData),
    scamInfo: createDataScamInfo(obsData),
    codeInfo: createDataScamCodeInfo(obsData),
  };
}

/**
 * [簡易カメラ]観測所情報取得
 * @param {*} obsData
 */
function createDataScamObsInfo(obsData) {
  const info = obsData.scamDetailInfo;
  // 水位観測所コード
  let codeParam = "";
  if (info.ofcCd !== null && global.KWB_MODE === "admin") {
    codeParam = codeParamHead + info.ofcCd + codeParamTail;
  }
  let codeParamLinkObs = "";
  if (info.obsCd !== null && global.KWB_MODE === "admin") {
    codeParamLinkObs = codeParamHeadLinkObs + info.obsCd + codeParamTailLinkObs;
  }

  // 危機水位観測所コード
  let swCodeParamLinkObs = "";
  if (info.obsCd !== null && global.KWB_MODE === "admin") {
    swCodeParamLinkObs =
      codeParamHeadLinkObs + info.swobsCd + codeParamTailLinkObs;
  }

  return [
    {
      title: "管理者",
      value: formatFloat(info.ownName),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.ownKana !== null ? info.ownKana : invalidStr,
      notMb: true,
    },
    {
      title: "所在地",
      value: formatFloat(info.addr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.addrKana !== null ? info.addrKana : invalidStr,
      notMb: true,
    },
    {
      title: "関連水位観測所",
      value: formatStgSw([info.obsNm, info.swobsNm]),
      ofcCd: [info.obsOfcCd, info.swofcCd],
      itmkndCd: [info.itmkndCd, info.swobsCd != null ? 300 : null],
      obsCd: [info.obsCd, info.swobsCd],
      code: [codeParamLinkObs, swCodeParamLinkObs],
    },
    {
      title: "緯度経度",
      value: formatLatLon(info.lat, info.lon),
    },
  ];
}

/**
 * [簡易カメラ]画像情報取得
 * @param {*} obsData
 */
function createDataScamInfo(obsData) {
  let result = {
    latestUrl: obsData.scamDetailInfo.currProvUrl,
    usualUrl: obsData.scamDetailInfo.normProvUrl,
    latestScamTime: getLatestScamTime(obsData),
    liveUrl: obsData.scamDetailInfo.liveUrl,
    sysId: obsData.scamDetailInfo.sysId
  };
  return result;
}

function updateLatestScamTime(scamNowDetailInfo) {
  var dateType = scamNowDetailInfo != null ? scamNowDetailInfo.data.date_type : null
  var getTime = scamNowDetailInfo != null
  ? formatDateNonNull(scamNowDetailInfo.data.get_time)
  : null
  var createTime = scamNowDetailInfo != null
  ? formatDateNonNull(scamNowDetailInfo.data.create_time)
  : null

  if (dateType === 2 && createTime != null) {
    return createTime;
  } else if (
    (dateType === 2 && getTime != null) ||
    (dateType === 0 && getTime != null)
  ) {
    return getTime;
  } else {
    return null;
  } 
}

/**
 * [簡易カメラ]
 * @param {*} obsData 観測所情報
 */
function createDataScamCodeInfo(obsData) {
  if (global.KWB_MODE === "admin") {
    const info = obsData.scamDetailInfo;
    return [
      {
        title: "観測所コード",
        value: formatFloat(info.ownCd),
      },
      {
        title: "河川コード",
        value: formatFloat(info.rvrCd),
        unit: "",
      },
      {
        title: "水系コード",
        value: formatFloat(info.rsysCd),
        unit: "",
      },
    ];
  } else {
    return [];
  }
}

//------------------------------------------------------------

function getXsecArr(surfaceInfo) {
  var arr = [
    {
      lat: surfaceInfo.surfaceConf.locationA[0],
      lng: surfaceInfo.surfaceConf.locationA[1],
    },
    {
      lat: surfaceInfo.surfaceConf.locationB[0],
      lng: surfaceInfo.surfaceConf.locationB[1],
    },
  ];
  return arr;
}

function getXsecPresent(surfaceInfo) {
  var present = {
    lat: surfaceInfo.surfaceConf.locationP[0],
    lng: surfaceInfo.surfaceConf.locationP[1],
  };
  return present;
}

function getXsecCross(self, stgMode, mode) {
  var cross = {
    mode: mode,
    stgMode: stgMode,
    sys: self.riverInfo.sys,
    drawType: 1,
    // ポイント情報
    points: self.riverInfo.data.points,
    totalDistance: self.riverInfo.data.totalDistance,
    presentDistance: self.riverInfo.data.presentDistance,
    // 横断データ
    pointsOutBank: self.riverInfo.points,
    sfLeftLimit: self.riverInfo.sfLeftLimit,
    sfRightLimit: self.riverInfo.sfRightLimit,
    // 基準値
    levelValue: self.riverInfo.levelValue,
    // 基準値表示色
    stgFillColor: self.riverInfo.stgFillColor,
    // 描画位置上限
    drawMaxValue: self.riverInfo.display.drawMaxValue,
    // 描画位置下限
    drawMinValue: self.riverInfo.display.drawMinValue,

    zeroHighFix: self.riverInfo.zeroHighFix,

    leftBankIdx: self.riverInfo.leftBankIdx,
    rightBankIdx: self.riverInfo.rightBankIdx,
    AIdx: self.riverInfo.AIdx,
    BIdx: self.riverInfo.BIdx,
    drawWidthMag: self.riverInfo.display.drawWidthMag,

    pointA: self.riverInfo.pointA,
    pointB: self.riverInfo.pointB,
    pointP: self.riverInfo.pointP,
    dispP: self.riverInfo.dispP,

    rvrwid: self.riverInfo.rvrwid,
    rvrbed: self.riverInfo.rvrbed,
    upgate: self.riverInfo.upgate,

    // 描画最高位置(%)
    highCfg1: self.riverInfo.highCfg1,
    // 描画最低位置(%)
    lowCnf1: self.riverInfo.lowCnf1,
    drawPosMax: self.riverInfo.drawPosMax,
    drawPosMin: self.riverInfo.drawPosMin,
    isDispPresent: self.riverInfo.isDispPresent,
    isPresentOut: self.riverInfo.isPresentOut,
    nearIndex: self.riverInfo.nearIndex,
    detailMode: false,
    point: self.riverInfo.point,
    obsLabel: self.riverInfo.obsLabel,
    obsLabelZeroHigh: self.riverInfo.obsLabelZeroHigh,
    allStageNullMes: self.riverInfo.allStageNullMes,
  };
  return cross;
}

function getXsecSpecialCross(surfaceInfo, crossConfig, stgMode, mode) {
  let leftBankIdx = -1;
  let rightBankIdx = -1;
  let rvrwid = 0;

  for (var idx = 0; idx < surfaceInfo.surface.crssct.length; idx++) {
    var crssct = surfaceInfo.surface.crssct[idx];
    if (crssct.drawLength < surfaceInfo.surface.crs.sfLeftLimit) {
      continue;
    } else if (leftBankIdx < 0) {
      leftBankIdx = idx;
    }

    if (crssct.drawLength < surfaceInfo.surface.crs.sfRightLimit) {
      continue;
    } else {
      rightBankIdx = idx;
      break;
    }
  }

  // 横断データから左右岸堤防高のインデックスを取得
  if (leftBankIdx != -1 && rightBankIdx != -1) {
    rvrwid =
      surfaceInfo.surface.crssct[rightBankIdx].drawLength -
      surfaceInfo.surface.crssct[leftBankIdx].drawLength;
  }

  // 予測水位の日付フォーマット
  for (var i = 0; i < surfaceInfo.surface.trPredStg.length; i++) {
    surfaceInfo.surface.trPredStg[i].date = Util.formatDate24(
      surfaceInfo.surface.trPredStg[i].date
    );
  }

  var cross = {
    drawType: 2,
    mode: mode,
    stgMode: stgMode,
    sys: "ph2",
    // ポイント情報
    points: surfaceInfo.surface.crssct,
    totalDistance: rvrwid,
    // 横断データ
    pointsOutBank: surfaceInfo.surface.crssct,
    sfLeftLimit: surfaceInfo.surface.crs.sfLeftLimit,
    sfRightLimit: surfaceInfo.surface.crs.sfRightLimit,

    // 基準値
    levelValue: {
      stageLvl1: {
        label: "水防団待機水位",
        value:
          surfaceInfo.surface.stgobs.rsrvStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.rsrvStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.rsrvStg,
      },
      stageLvl2: {
        label: "氾濫注意水位",
        value:
          surfaceInfo.surface.stgobs.warnStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.warnStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.warnStg,
      },
      stageLvl3: {
        label: "避難判断水位",
        value:
          surfaceInfo.surface.stgobs.spclWarnStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.spclWarnStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.spclWarnStg,
      },
      stageLvl4: {
        label: "氾濫危険水位",
        value:
          surfaceInfo.surface.stgobs.dngStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.dngStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.dngStg,
      },
      // stageLvl5: {
      //   label: "堤防天端",
      //   value: surfaceInfo.surface.stgobs.topendHght,
      // },
      stageLvl5: {
        label: "氾濫開始水位",
        value:
          surfaceInfo.surface.stgobs.fldStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.fldStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.fldStg,
      },
    },

    // 描画位置上限
    drawMaxValue: surfaceInfo.surface.stgobs.topendHght,
    // 描画位置下限
    drawMinValue: surfaceInfo.surface.crs.riverBed,

    zeroHighFix: surfaceInfo.surface.stgobs.zeroHighFix,

    leftBankIdx: leftBankIdx,
    rightBankIdx: rightBankIdx,
    drawPosMax: surfaceInfo.surface.stgobs.drawPosMax,
    drawPosMin: surfaceInfo.surface.stgobs.drawPosMin,

    // drawWidthMag: self.riverInfo.display.drawWidthMag,
    drawWidthMag: 1,

    // pointA: self.riverInfo.pointA,
    // pointB: self.riverInfo.pointB,
    // pointP: self.riverInfo.pointP,
    // rvrwid: self.riverInfo.rvrwid,
    rvrwid: rvrwid,
    rvrbed: surfaceInfo.surface.crs.riverBed,
    upgate: surfaceInfo.surface.stgobs.topendHght,

    intervalValue: crossConfig.intervalValue,
    riverSideMinWidth: crossConfig.riverSideMinWidth,
    onMapLine: crossConfig.onMapLine,
    point: crossConfig.point,

    stgFillColor: crossConfig.stgFillColor,
    lndFillColor: crossConfig.lndFillColor,
    strokeStyle: crossConfig.strokeStyle,
    rvrwidCfg1: crossConfig.rvrwidCfg1,
    rvrwidRatio1: crossConfig.rvrwidRatio1,
    rvrwidCfg2: crossConfig.rvrwidCfg2,
    rvrwidRatio2: crossConfig.rvrwidRatio2,
    rvrwidRatioDefault: crossConfig.rvrwidRatioDefault,
    rvrwidCfg3: crossConfig.rvrwidCfg3,
    rvrwidCfg4: crossConfig.rvrwidCfg4,
    highCfg1: crossConfig.highCfg1,
    lowCnf1: crossConfig.lowCnf1,
    tileAnnotation: crossConfig.tileAnnotation,
    allStageNullMes: crossConfig.allStageNullMes,
    legendButtonLabel: crossConfig.legendButtonLabel,
    obsLabel: crossConfig.obsLabel,
    obsLabelZeroHigh: crossConfig.obsLabelZeroHigh,

    isDispPresent: false,
    isPresentOut: true,
    nearIndex: 0,
    detailMode: false,
    stagesPrediction: surfaceInfo.surface.trPredStg,
  };
  return cross;
}
function getSwXsecSpecialCross(surfaceInfo, crossConfig, stgMode, mode) {
  let leftBankIdx = -1;
  let rightBankIdx = -1;
  let rvrwid = 0;
  for (var idx = 0; idx < surfaceInfo.surface.crssct.length; idx++) {
    var crssct = surfaceInfo.surface.crssct[idx];
    if (crssct.drawLength < surfaceInfo.surface.crs.sfLeftLimit) {
      continue;
    } else if (leftBankIdx < 0) {
      leftBankIdx = idx;
    }

    if (crssct.drawLength < surfaceInfo.surface.crs.sfRightLimit) {
      continue;
    } else {
      rightBankIdx = idx;
      break;
    }
  }

  // 横断データから左右岸堤防高のインデックスを取得
  if (leftBankIdx != -1 && rightBankIdx != -1) {
    rvrwid =
      surfaceInfo.surface.crssct[rightBankIdx].drawLength -
      surfaceInfo.surface.crssct[leftBankIdx].drawLength;
  }
  var cross = {
    drawType: 2,
    mode: mode,
    stgMode: stgMode,
    sys: "sw",
    // ポイント情報
    points: surfaceInfo.surface.crssct,
    totalDistance: rvrwid,
    // 横断データ
    pointsOutBank: surfaceInfo.surface.crssct,
    sfLeftLimit: surfaceInfo.surface.crs.sfLeftLimit,
    sfRightLimit: surfaceInfo.surface.crs.sfRightLimit,

    // 基準値
    levelValue: {
      stageLvl1: {
        label: "",
        value: null,
        stg: null,
      },
      stageLvl2: {
        label: "観測開始",
        value:
          surfaceInfo.surface.obsInfo.strtStg != null
          ? Math.floor((surfaceInfo.surface.obsInfo.topendHght +
            surfaceInfo.surface.obsInfo.strtStgHght) * 100)/ 100
          : null,
        stg: surfaceInfo.surface.obsInfo.strtStg,
      },
      stageLvl3: {
        label: "",
        value: null,
        stg: null,
      },
      stageLvl4: {
        label: "危険水位",
        value:
          surfaceInfo.surface.obsInfo.dngStg != null
            ? Math.floor((surfaceInfo.surface.obsInfo.topendHght +
              surfaceInfo.surface.obsInfo.dngStgHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.obsInfo.dngStg,
      },
      stageLvl5: {
        label: "氾濫開始水位",
        value:
          surfaceInfo.surface.obsInfo.fldStg != null
            ? Math.floor((surfaceInfo.surface.obsInfo.topendHght +
              surfaceInfo.surface.obsInfo.fldStgHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.obsInfo.fldStg,
      },
    },

    // 描画位置上限
    drawMaxValue: surfaceInfo.surface.obsInfo.topendHght,
    // 描画位置下限
    drawMinValue: surfaceInfo.surface.crs.riverBed,

    zeroHighFix: surfaceInfo.surface.obsInfo.zeroHighFix,

    leftBankIdx: leftBankIdx,
    rightBankIdx: rightBankIdx,
    drawPosMax: surfaceInfo.surface.crs.drawPosMax,
    drawPosMin: surfaceInfo.surface.crs.drawPosMin,

    // drawWidthMag: self.riverInfo.display.drawWidthMag,
    drawWidthMag: 1,

    // pointA: self.riverInfo.pointA,
    // pointB: self.riverInfo.pointB,
    // pointP: self.riverInfo.pointP,
    // rvrwid: self.riverInfo.rvrwid,
    rvrwid: rvrwid,
    rvrbed: surfaceInfo.surface.crs.riverBed,
    upgate: surfaceInfo.surface.obsInfo.topendHght,

    intervalValue: crossConfig.intervalValue,
    riverSideMinWidth: crossConfig.riverSideMinWidth,
    onMapLine: crossConfig.onMapLine,
    point: crossConfig.point,

    stgFillColor: crossConfig.stgFillColor,
    lndFillColor: crossConfig.lndFillColor,
    strokeStyle: crossConfig.strokeStyle,
    rvrwidCfg1: crossConfig.rvrwidCfg1,
    rvrwidRatio1: crossConfig.rvrwidRatio1,
    rvrwidCfg2: crossConfig.rvrwidCfg2,
    rvrwidRatio2: crossConfig.rvrwidRatio2,
    rvrwidRatioDefault: crossConfig.rvrwidRatioDefault,
    rvrwidCfg3: crossConfig.rvrwidCfg3,
    rvrwidCfg4: crossConfig.rvrwidCfg4,
    highCfg1: crossConfig.highCfg1,
    lowCnf1: crossConfig.lowCnf1,
    tileAnnotation: crossConfig.tileAnnotation,
    allStageNullMes: crossConfig.allStageNullMes,
    legendButtonLabel: crossConfig.legendButtonLabel,
    obsLabel: crossConfig.obsLabel,
    obsLabelZeroHigh: crossConfig.obsLabelZeroHigh,

    isDispPresent: false,
    isPresentOut: true,
    nearIndex: 0,
    detailMode: false,
    stagesPrediction: surfaceInfo.surface.trPredStg,
  };
  return cross;
}

function getXsecRiverInfo(surfaceInfo, crossConfig) {
  // 予測水位の日付フォーマット
  for (var i = 0; i < surfaceInfo.surface.trPredStg.length; i++) {
    surfaceInfo.surface.trPredStg[i].date = Util.formatDate24(
      surfaceInfo.surface.trPredStg[i].date
    );
  }

  // riverInfo生成
  var riverInfo = {
    sys: "ph2",
    rvrwid: surfaceInfo.surface.stgobs.rvrwid * 1000,
    upgate: surfaceInfo.surface.stgobs.topendHght,
    rvrbed: surfaceInfo.surface.crs.riverBed,
    leftBankInfo: {
      lon: surfaceInfo.surface.stgobs.leftBnkHghtLon,
      lat: surfaceInfo.surface.stgobs.leftBnkHghtLat,
      elevation: surfaceInfo.surface.stgobs.upgate1,
    },
    rightBankInfo: {
      lon: surfaceInfo.surface.stgobs.rightBnkHghtLon,
      lat: surfaceInfo.surface.stgobs.rightBnkHghtLat,
      elevation: surfaceInfo.surface.stgobs.upgate2,
    },
    sfLeftLimit: surfaceInfo.surface.crs.sfLeftLimit,
    sfRightLimit: surfaceInfo.surface.crs.sfRightLimit,
    drawPosMax: surfaceInfo.surface.stgobs.drawPosMax,
    drawPosMin: surfaceInfo.surface.stgobs.drawPosMin,
    points: surfaceInfo.surface.crssct,
    strtStage: surfaceInfo.surface.stgobs.strtStage,
    levelValue: {
      stageLvl1: {
        label: "水防団待機水位",
        value:
          surfaceInfo.surface.stgobs.rsrvStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.rsrvStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.rsrvStg,
      },
      stageLvl2: {
        label: "氾濫注意水位",
        value:
          surfaceInfo.surface.stgobs.warnStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.warnStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.warnStg,
      },
      stageLvl3: {
        label: "避難判断水位",
        value:
          surfaceInfo.surface.stgobs.spclWarnStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.spclWarnStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.spclWarnStg,
      },
      stageLvl4: {
        label: "氾濫危険水位",
        value:
          surfaceInfo.surface.stgobs.dngStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.dngStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.dngStg,
      },
      stageLvl5: {
        label: "氾濫開始水位",
        value:
          surfaceInfo.surface.stgobs.fldStg != null
            ? Math.floor((surfaceInfo.surface.stgobs.topendHght +
              surfaceInfo.surface.stgobs.fldStgTopendHght) * 100)/ 100
            : null,
        stg: surfaceInfo.surface.stgobs.fldStg,
      },
    },
    zeroHighFix: surfaceInfo.surface.stgobs.zeroHighFix,
    intervalValue: crossConfig.intervalValue,
    riverSideMinWidth: crossConfig.riverSideMinWidth,
    onMapLine: crossConfig.onMapLine,
    point: crossConfig.point,
    stgFillColor: crossConfig.stgFillColor,
    lndFillColor: crossConfig.lndFillColor,
    strokeStyle: crossConfig.strokeStyle,
    rvrwidCfg1: crossConfig.rvrwidCfg1,
    rvrwidRatio1: crossConfig.rvrwidRatio1,
    rvrwidCfg2: crossConfig.rvrwidCfg2,
    rvrwidRatio2: crossConfig.rvrwidRatio2,
    rvrwidRatioDefault: crossConfig.rvrwidRatioDefault,
    rvrwidCfg3: crossConfig.rvrwidCfg3,
    rvrwidCfg4: crossConfig.rvrwidCfg4,
    highCfg1: crossConfig.highCfg1,
    lowCnf1: crossConfig.lowCnf1,
    tileAnnotation: crossConfig.tileAnnotation,
    allStageNullMes: crossConfig.allStageNullMes,
    legendButtonLabel: crossConfig.legendButtonLabel,
    obsLabel: crossConfig.obsLabel,
    obsLabelZeroHigh: crossConfig.obsLabelZeroHigh,
  };

  riverInfo.pointA = [
    surfaceInfo.surfaceConf.locationA[1],
    surfaceInfo.surfaceConf.locationA[0],
  ];
  riverInfo.pointB = [
    surfaceInfo.surfaceConf.locationB[1],
    surfaceInfo.surfaceConf.locationB[0],
  ];

  riverInfo.pointP = surfaceInfo.surfaceConf.locationP;
  riverInfo.dispP = surfaceInfo.surfaceConf.dispP;

  switch (surfaceInfo.surfaceConf.dispP) {
    case 0:
      riverInfo.isDispPresent = false;
      riverInfo.isPresentOut = false;
      break;
    case 1:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = true;
      break;
    case 2:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = true;
      break;
    case 3:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = false;
      break;
  }
  return riverInfo;
}

function getSwXsecRiverInfo(surfaceInfo, crossConfig) {
  // riverInfo生成
  var riverInfo = {
    sys: "sw",
    rvrwid: surfaceInfo.surface.rvrwid * 1000,
    upgate: surfaceInfo.surface.obsInfo.topendHght,
    sec: surfaceInfo.surface.obsInfo.topendHght,
    rvrbed: surfaceInfo.surface.crs.riverBed,
    leftBankInfo: {
      lon: surfaceInfo.surface.obsInfo.leftBnkLon,
      lat: surfaceInfo.surface.obsInfo.leftBnkLat,
      elevation: surfaceInfo.surface.obsInfo.leftBnkHght,
    },
    rightBankInfo: {
      lon: surfaceInfo.surface.obsInfo.rightBnkLon,
      lat: surfaceInfo.surface.obsInfo.rightBnkLat,
      elevation: surfaceInfo.surface.obsInfo.rightBnkHght,
    },
    sfLeftLimit: surfaceInfo.surface.crs.sfLeftLimit,
    sfRightLimit: surfaceInfo.surface.crs.sfRightLimit,
    drawPosMax: surfaceInfo.surface.crs.drawPosMax,
    drawPosMin: surfaceInfo.surface.crs.drawPosMin,
    points: surfaceInfo.surface.crssct,
    strtStage: surfaceInfo.surface.obsInfo.strtStg,
    levelValue: {
      stageLvl1: {
        label: "",
        value: null,
      },
      stageLvl2: {
        label: "観測開始水位",
        value:
          surfaceInfo.surface.obsInfo.strtStg != null
            ? Math.floor((surfaceInfo.surface.obsInfo.topendHght +
              surfaceInfo.surface.obsInfo.strtStgHght) * 100)/ 100
            : null,
      },
      stageLvl3: {
        label: "",
        value: null,
      },
      stageLvl4: {
        label: "危険水位",
        value:
          surfaceInfo.surface.obsInfo.dngStg != null
            ?  Math.floor((surfaceInfo.surface.obsInfo.topendHght +
              surfaceInfo.surface.obsInfo.dngStgHght) * 100)/ 100
            : null,
      },
      stageLvl5: {
        label: "氾濫開始水位",
        value: surfaceInfo.surface.obsInfo.topendHght,
      },
    },
    intervalValue: crossConfig.intervalValue,
    riverSideMinWidth: crossConfig.riverSideMinWidth,
    onMapLine: crossConfig.onMapLine,
    point: crossConfig.point,
    stgFillColor: crossConfig.stgFillColor,
    lndFillColor: crossConfig.lndFillColor,
    strokeStyle: crossConfig.strokeStyle,
    rvrwidCfg1: crossConfig.rvrwidCfg1,
    rvrwidRatio1: crossConfig.rvrwidRatio1,
    rvrwidCfg2: crossConfig.rvrwidCfg2,
    rvrwidRatio2: crossConfig.rvrwidRatio2,
    rvrwidRatioDefault: crossConfig.rvrwidRatioDefault,
    rvrwidCfg3: crossConfig.rvrwidCfg3,
    rvrwidCfg4: crossConfig.rvrwidCfg4,
    highCfg1: crossConfig.highCfg1,
    lowCnf1: crossConfig.lowCnf1,
    tileAnnotation: crossConfig.tileAnnotation,
    allStageNullMes: crossConfig.allStageNullMes,
    legendButtonLabel: crossConfig.legendButtonLabel,
    obsLabel: crossConfig.obsLabel,
  };

  riverInfo.pointA = [
    surfaceInfo.surfaceConf.locationA[1],
    surfaceInfo.surfaceConf.locationA[0],
  ];
  riverInfo.pointB = [
    surfaceInfo.surfaceConf.locationB[1],
    surfaceInfo.surfaceConf.locationB[0],
  ];

  riverInfo.pointP = surfaceInfo.surfaceConf.locationP;
  riverInfo.dispP = surfaceInfo.surfaceConf.dispP;

  switch (surfaceInfo.surfaceConf.dispP) {
    case 0:
      riverInfo.isDispPresent = false;
      riverInfo.isPresentOut = false;
      break;
    case 1:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = true;
      break;
    case 2:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = true;
      break;
    case 3:
      riverInfo.isDispPresent = true;
      riverInfo.isPresentOut = false;
      break;
  }
  return riverInfo;
}

//------------------------------------------------------------
/**
 * 観測所情報 数値フォーマット
 *
 * @param {?number} val1 数値
 * @param {number} digit 小数点有効桁数 (省略可能)
 * @returns {string} フォーマット後の文字列(数値が null の場合 invalidStr)
 */
function formatFloat(val1, digit) {
  if (val1 === null) {
    return invalidStr;
  }
  if (digit === undefined) {
    // 小数点有効桁数の調整なし
    return val1;
  }

  const val1Str = val1.toString();
  const pattern = new RegExp("^[-]?([1-9]\\d*|0)(\\.\\d+)?$");
  if (pattern.test(val1Str)) {
    // 入力された値が数値の場合、
    // 文字列に変換して小数点有効桁数の調整を行なう
    // 小数点有効桁数に足りなければ 0 を足す
    // 例1: digit 2 の場合  1.234 → 1.23
    // 例2: digit 2 の場合  1.2 → 1.20

    // 小数点の位置を調べる
    const index = val1Str.indexOf(".");
    if (index === -1) {
      // 小数点が含まれない場合、
      if (digit > 0) {
        // 「小数点 . 」と「小数点有効桁数の 0 」を付加する
        let zeroFill = "";
        for (let i = 0; i < digit; i++) {
          zeroFill = zeroFill + "0";
        }
        return val1Str + "." + zeroFill;
      } else {
        return val1Str;
      }
    } else {
      // 小数点が含まれる場合、
      const val1Digit = val1Str.length - index - 1;
      if (val1Digit < digit) {
        // 小数点以下が 小数点有効桁数 より少ない
        // 不足分の 0 を付加する
        let zeroFill = "";
        for (let i = 0; i < digit - val1Digit; i++) {
          zeroFill = zeroFill + "0";
        }
        return val1Str + zeroFill;
      } else if (val1Digit > digit) {
        // 小数点以下が 小数点有効桁数 より多い
        // 余剰分の小数点以下を削除する
        if (digit <= 0) {
          // 小数点有効桁数 に 0 以下を指定された場合、
          // 小数点まで削除する
          return val1Str.slice(0, (val1Digit + 1) * -1);
        } else {
          return val1Str.slice(0, (val1Digit - digit) * -1);
        }
      } else {
        // 小数点以下が 小数点有効桁数 とイコール
        // そのまま返す
        return val1Str;
      }
    }
  }

  // 入力された値が数値ではない場合
  return invalidStr;
}

/**
 * 観測所情報 数値フォーマット(四捨五入)
 *
 * @param {?number} val1 数値
 * @param {number} digit 小数点有効桁数 (省略可能)
 * @returns {string} フォーマット後の文字列(数値が null の場合 invalidStr)
 */
function formatFloatRound(val1, digit) {
  if (val1 === null) {
    return invalidStr;
  }
  if (digit === undefined) {
    // 小数点有効桁数の調整なし
    return val1;
  }

  // 四捨五入して値を返す
  return Number(val1).toFixed(digit);
}

/** 観測所情報 緯度経度フォーマット */
function formatLatLon(lat, lon) {
  return "緯度 " + formatFloat(lat) + "\n経度 " + formatFloat(lon);
}

/** 観測所情報 関連水位観測所フォーマット */
function formatStgSw([stg, sw]) {
  if (!isObjEmpty(stg) && !isObjEmpty(sw)) {
    return [stg + "(水位観測)", sw + "(水位計)"];
  } else if (!isObjEmpty(stg) && isObjEmpty(sw)) {
    return [stg + "(水位観測)", null];
  } else if (isObjEmpty(stg) && !isObjEmpty(sw)) {
    return [null, sw + "(水位計)"];
  } else {
    return null;
  }
}

/** オブジェクトがnull/undefinedの判定 */
function isObjEmpty(obj) {
  if (obj === null || obj === undefined) {
    return true;
  } else {
    return false;
  }
}

/**
 * 風向 名称変換
 * @param {*} wnd 平均風向(コード)
 */
function formatWndDir(wnd) {
  if (wnd === 0) return "無風";
  else if (wnd === 1) return "NNE";
  else if (wnd === 2) return "NE";
  else if (wnd === 3) return "ENE";
  else if (wnd === 4) return "E";
  else if (wnd === 5) return "ESE";
  else if (wnd === 6) return "SE";
  else if (wnd === 7) return "SSE";
  else if (wnd === 8) return "S";
  else if (wnd === 9) return "SSW";
  else if (wnd === 10) return "SW";
  else if (wnd === 11) return "WSW";
  else if (wnd === 12) return "W";
  else if (wnd === 13) return "WNW";
  else if (wnd === 14) return "NW";
  else if (wnd === 15) return "NNW";
  else if (wnd === 16) return "N";
  else return wnd; // 1 - 16 に該当しない場合、そのまま返す。'欠測' や '閉局'、'--' など。
}

/** 観測所情報 グラフ最大値を調整 */
function graphMaxAdd(val, add, max) {
  val = nullConvertZero(val) + add;
  if (max === null) {
    return val;
  } else {
    return val <= max ? val : max;
  }
}

/** 観測所情報 グラフ最小値を調整 */
// function graphMinAdd(val, add, min) {
//   val = nullConvertZero(val) - add;
//   if (min === null) {
//     return val;
//   } else {
//     return val >= min ? val : min;
//   }
// }

/**
 *  観測所情報 注意値/警戒値フォーマット
 *
 * @param {?number} cautVal 注意値
 * @param {?number} warnVal 警戒値
 * @param {string} unit 単位
 * @param {number} digit 小数点有効桁数 (省略可能)
 * @returns {string}
 */
function formatCautWarn(cautVal, warnVal, unit, digit) {
  return (
    "注意値 " +
    formatFloat(cautVal, digit) +
    unit +
    "\n警戒値 " +
    formatFloat(warnVal, digit) +
    unit
  );
}

/** 日付フォーマット */
function formatDateNonNull(val1) {
  return val1 == null ? "" : Util.formatDate24(val1);
}

/** 遷移先観測所 パラメータ生成 */
function formatParam(ofcCd, itmkndCd, obsCd) {
  if (ofcCd === null || itmkndCd === null || obsCd == null) {
    return null;
  }
  return [ofcCd, itmkndCd, obsCd];
}

/** 海岸周期の最大値を4の倍数で観測値が収まる値に変換 */
// function formatCoastCycleMax(maxValue) {
//   // 4の倍数ジャストの場合は+4されるよう考慮
//   return maxValue + (4 - (maxValue % 4));
// }

/** 指定桁数未満切り捨て（10→10の位まで有効値、0.1→小数第1位まで有効値） */
function valueCeil(value, base) {
  var valDotPosition = getDotPosition(value);
  var baseDotPosition = getDotPosition(base);

  // 文字列化 小数点を除いて整数の値にする
  var intVal = parseInt((value + "").replace(".", ""));

  // 10^N の値を計算
  var powerBase = 1;
  var powerVal = 1;
  if (baseDotPosition > 0) {
    if (valDotPosition > 0 && valDotPosition > baseDotPosition) {
      powerVal = Math.pow(10, valDotPosition);
      powerBase = Math.pow(10, valDotPosition - baseDotPosition);
    } else {
      powerVal = Math.pow(10, valDotPosition);
    }
  } else {
    if (valDotPosition > 0) {
      powerVal = Math.pow(10, valDotPosition);
      powerBase = Math.pow(10, baseDotPosition + valDotPosition);
    } else {
      powerBase = base;
    }
  }

  // マイナス値を考慮
  if (intVal < 0) {
    intVal = intVal * -1;
    powerVal = powerVal * -1;
  }

  // 指定桁数以下切り捨て後に10^Nで割る
  // -0打消し
  return (Math.floor(intVal / powerBase) * powerBase) / powerVal + 0;
}

/** 小数点の位置を取得する */
function getDotPosition(value) {
  var strVal = String(value);
  var dotPosition = 0;
  if (strVal.lastIndexOf(".") !== -1) {
    dotPosition = strVal.length - 1 - strVal.lastIndexOf(".");
  }
  return dotPosition;
}

/** nullデータを0に変換 */
function nullConvertZero(val) {
  return val == null ? 0 : val;
}

/** 背景色判定 */
function isBkColoring(ovFlg) {
  // 数値/真偽値/-が引数として渡ってくる可能性がある。
  return ovFlg == true || ovFlg > 0 ? 1 : 0;
}

/** ダム個別観測所背景色判定 */
function isBkColoringDam(ovFlg, type) {
  if (type === "storLvl") {
    // 貯水量の着色の場合
    // 数値/真偽値/-が引数として渡ってくる可能性がある。
    return ovFlg == true || ovFlg > 0 ? 1 : 0;
  }

  // 全流入量の着色の場合
  return ovFlg == true || ovFlg > 0 ? 2 : 0;
}

/**
 * 背景色判定（基準値2つ）
 *
 * 引数1：注意値超過フラグ
 * 引数2：警戒値超過フラグ
 */
function isBkColoringCutWrn(cautFlg, warnFlg) {
  if (isBkColoring(warnFlg)) {
    return 2;
  } else if (isBkColoring(cautFlg)) {
    return 1;
  }
  return 0;
}

/** 無効データチェック */
function isInvalid(ccd) {
  if (ccd === CCD_MISSING) {
    return true;
  } else if (ccd === CCD_CLOSING) {
    return true;
  } else if (ccd >= 130 || ccd === null) {
    return true;
  } else {
    return false;
  }
}

/**
 *  内容コードチェック
 *
 * @param {?number} val1 数値
 * @param {?number} ccd 内容コード
 * @param {number} digit 小数点有効桁数 (省略可能)
 * @returns {string} 内容コードを判断した結果の文字列
 */
function checkCcd(val1, ccd, digit) {
  if (ccd === CCD_MISSING) {
    return "欠測";
  } else if (ccd === CCD_CLOSING) {
    return "閉局";
  } else if (ccd >= 130 || ccd === null) {
    return invalidStr;
  } else {
    // val1 が null のときの処理は formatFloat() に含まれている
    return formatFloat(val1, digit);
  }
}

/**
 * 表示対象値それ自体 と 内容コード を元に
 * 表示対象値が有効な値かどうかを返す
 *
 * @param val1 表示対象値
 * @param ccd 内容コード
 * @returns {boolean}
 */
function checkCcdBoolean(val1, ccd) {
  if (val1 === null) {
    return false;
  } else {
    return !isInvalid(ccd);
  }
}

/**
 * 「単位」の表示有無に対する 内容コード チェック
 * ・内容コードが欠測または閉局の場合、単位を表示しない
 *
 * @param unit 単位文字列
 * @param ccd 内容コード
 */
function checkCcdOfUnit(unit, ccd) {
  if (ccd === CCD_MISSING || ccd === CCD_CLOSING) {
    return "";
  } else {
    return unit;
  }
}

/** 内容コードチェック（グラフ用） */
function checkCcdForGraph(val1, ccd) {
  return isInvalid(ccd) ? invalidVal : nullConvertZero(val1);
}

/** 内容コードチェック（グラフ用） val1が null の場合でもそのまま返す */
function checkCcdForGraphNullable(val1, ccd) {
  return isInvalid(ccd) ? invalidVal : val1;
}

/** 雨量観測所最新観測値着色判定 */
function checkRainBgColor(ccd) {
  if (ccd >= 130 || ccd == null) {
    return 2;
  } else {
    return 1;
  }
}

function mathMax(...values) {
  let list = [];
  values.forEach(function (value) {
    if (value !== null) {
      list.push(value);
    }
  });
  if (list.length > 0) {
    return Math.max(...list);
  }
  return null;
}

function mathMin(...values) {
  let list = [];
  values.forEach(function (value) {
    if (value !== null) {
      list.push(value);
    }
  });
  if (list.length > 0) {
    return Math.min(...list);
  }
  return null;
}

/**
 * 上限値の調整(割り切れる直近の値を算出。限界値は超えないこと)
 * 引数1:値
 * 引数2:間隔
 * 引数3:限界値
 * 引数4:小数点桁数（10→10の位、0.1→小数第１位）
 */
function roundMax(value, interval, limit, base) {
  let quo = Math.floor(value / interval); // 商
  let rem = valueCeil(value % interval, base); // 余り
  let ret = 0;
  if (rem == 0) {
    ret = quo * interval;
  } else {
    if (0 < value) {
      ret = (quo + 1) * interval;
    } else {
      ret = quo * interval;
    }
  }
  if (limit !== null) {
    // 限界値を超えている場合は、限界値をセット
    if (limit < ret) {
      ret = limit;
    }
  }
  return roundUpValue(ret, 1 / base);
}

/**
 * 下限値の調整(割り切れる直近の値を算出。限界値は超えないこと)
 * 引数1:値
 * 引数2:間隔
 * 引数3:限界値
 * 引数4:小数点桁数（10→10の位、0.1→小数第１位）
 */
// function roundMin(value, interval, limit, base) {
//   let quo = Math.floor(value / interval); // 商
//   let ret = quo * interval;
//   if (limit !== null) {
//     // 限界値を超えている場合は、限界値をセット
//     if (ret < limit) {
//       ret = limit;
//     }
//   }
//   return valueCeil(ret, base);
// }

/**
 * 河川カメラ情報の latestUrl を持っているか
 * @param cctvInfo
 * @returns {boolean}
 */
function hasLatestUrl(cctvInfo) {
  return (
    cctvInfo !== undefined &&
    cctvInfo !== null &&
    ((cctvInfo.latestUrl !== undefined && cctvInfo.latestUrl !== null) ||
      (cctvInfo.subLatestUrl !== undefined && cctvInfo.subLatestUrl !== null))
  );
}

/**
 * 河川カメラ情報の usualUrl を持っているか
 * @param cctvInfo
 * @returns {boolean}
 */
function hasUsualUrl(cctvInfo) {
  return (
    cctvInfo !== undefined &&
    cctvInfo !== null &&
    ((cctvInfo.usualUrl !== undefined && cctvInfo.usualUrl !== null) ||
      (cctvInfo.subUsualUrl !== undefined && cctvInfo.subUsualUrl !== null))
  );
}

/**
 * 河川カメラ情報を持っているか
 * @param selectedTm
 * @returns {boolean}
 */
function hasCctvInfo(selectedTm) {
  if (selectedTm.cctvInfo === undefined || selectedTm.cctvInfo === null) {
    return false;
  }
  const cctvInfo = selectedTm.cctvInfo;
  return hasLatestUrl(cctvInfo) || hasUsualUrl(cctvInfo);
}

/**
 * 横断マスタ、横断断面マスタを持っているか
 * @param crs
 * @returns {boolean}
 */
function hasCrs(crs) {
  if (crs === undefined || crs === null) {
    return false;
  }
  if (crs.sfLeftLimit === undefined || crs.sfLeftLimit === null) {
    return false;
  }
  if (crs.sfRightLimit === undefined || crs.sfRightLimit === null) {
    return false;
  }
  return true;
}

/**
 * 左右岸緯度経度を持っているか
 * @param stgobs
 * @returns {boolean}
 */
function hasStgobs(stgobs) {
  if (stgobs === undefined || stgobs === null) {
    return false;
  }
  if (stgobs.leftBnkHghtLat === undefined || stgobs.leftBnkHghtLat === null) {
    return false;
  }
  if (stgobs.leftBnkHghtLon === undefined || stgobs.leftBnkHghtLon === null) {
    return false;
  }
  if (stgobs.rightBnkHghtLat === undefined || stgobs.rightBnkHghtLat === null) {
    return false;
  }
  if (stgobs.rightBnkHghtLon === undefined || stgobs.rightBnkHghtLon === null) {
    return false;
  }
  return true;
}

function hasXsec(selectedTm) {
  if (selectedTm.xsec === undefined || selectedTm.xsec === null) {
    return false;
  }
  const xsec = selectedTm.xsec;
  if (xsec.stgobs === undefined || xsec.stgobs === null) {
    return false;
  }
  const stgobs = xsec.stgobs;

  if (stgobs.drawType === 0) {
    // 水位観測所マスタの横断図描画種別が 0 の場合は、無条件で描画無し
    return false;
  }

  const crs = xsec.crs;

  // 「横断マスタ、横断断面マスタ」か 「左右岸緯度経度」
  // のどちらかを持っていれば描画あり
  if (hasStgobs(stgobs) || hasCrs(crs)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 零点高の値を持っているかどうか
 * @param selectedTm
 * @returns {boolean}
 */
function hasZeroHighFix(selectedTm) {
  const zeroHighFix = selectedTm.tmStgDetailInfo.zeroHighFix;
  if (zeroHighFix === undefined || zeroHighFix === null) {
    return false;
  } else {
    return true;
  }
}

/**
 *  [水位観測所情報]予測水位を判定してリストを生成する
 *
 * @param {*} tmData 予測水位リスト
 * @param {*} obsData 水位観測所情報
 * @param {*} targetTime 検索時刻
 * @param {string} type 種別(graph-->水位グラフの予測水位 cross-->横断の予測水位)
 */
function getTargetPredStgData(tmData, obsData, targetTime, type) {
  let result = [];

  // 1.予測水位が存在する場合
  // 2.現況の基準水位超過が氾濫注意以上
  // 3.管理区分1(河川)
  if (
    tmData &&
    Object.keys(tmData.predstgValues).length > 0 &&
    checkCrntPredOvlvl(tmData.predstgValues, obsData.obsInfo) &&
    obsData.obsInfo.obsSct === 1
  ) {
    for (var predstgValue of tmData.predstgValues) {
      // 1.検索時刻よりも未来の予測水位データ
      // 2.観測日時文字表現が現況ではない
      // 3.状態が正常、または有効
      // 4.発令時刻が検索時刻よりも過去
      if (
        Util.formatDate(predstgValue.obsTime) > Util.formatDate(targetTime) &&
        predstgValue.obsTimeStr != "現況" &&
        (predstgValue.cond === "正常" || predstgValue.cond === "有効") &&
        Util.formatDate(predstgValue.annTime) <= Util.formatDate(targetTime)
      ) {
        var prefStg;
        if (type === "cross") {
          // 横断の予測水位の場合
          prefStg = {
            date: Util.formatDate(predstgValue.obsTime, "YYYY-MM-DD HH:mm:ss"),
            // 水位＋零点高＋標高基準面補正値
            elevation: predstgValue.stgCrsHght,
            stg: predstgValue.stg,
            cond: predstgValue.cond,
          };
        } else {
          // 水位グラフの予測水位の場合
          prefStg = {
            obsTime: predstgValue.obsTime,
            stg: predstgValue.stg,
            // 堤防天端からの高さ
            stgDiffTopendHght: predstgValue.stgHght,
          };
        }
        result.push(prefStg);
      }
    }
  }

  return result;
}

/**
 *  [水位観測所情報]予測水位から現況の時刻を取得する
 *
 * @param {*} tmData 予測水位リスト
 * @param {*} obsData 水位観測所情報
 * @param {*} targetTime 検索時刻
 */
function getCrntPredTime(tmData, obsData, targetTime) {
  const latestObsTime = getLaterPredTime(tmData.predstgValues);
  // 1.予測水位が存在する場合
  // 2.現況の基準水位超過が氾濫注意以上
  // 3.管理区分1(河川)
  // 4.予測水位の最大観測日時が現在時刻より未来のデータ
  if (
    tmData &&
    Object.keys(tmData.predstgValues).length > 0 &&
    checkCrntPredOvlvl(tmData.predstgValues, obsData.obsInfo) &&
    obsData.obsInfo.obsSct === 1 &&
    latestObsTime != null &&
    Util.formatDate(latestObsTime) > Util.formatDate(targetTime)
  ) {
    for (var predstgValue of tmData.predstgValues) {
      // 1.状態が正常、または有効
      // 2.観測日時文字表現が現況
      // 3.発令時刻が検索時刻よりも過去
      if (
        (predstgValue.cond === "正常" || predstgValue.cond === "有効") &&
        predstgValue.obsTimeStr == "現況" &&
        Util.formatDate(predstgValue.annTime) <= Util.formatDate(targetTime)
      ) {
        // 現況の観測日時を返す
        return predstgValue.obsTime;
      }
    }
  }
  return null;
}

/**
 * 予測水位の氾濫超過を判定する
 * @param {*} predstgValues 予測水位リスト
 * @param {*} obsInfo 水位観測所情報
 */
function checkCrntPredOvlvl(predstgValues, obsInfo) {
  if (Object.keys(predstgValues).length > 0) {
    for (var predstgValue of predstgValues) {
      if (
        (obsInfo.warnStg != null && predstgValue.stg >= obsInfo.warnStg) ||
        (obsInfo.spclWarnStg != null &&
          predstgValue.stg >= obsInfo.spclWarnStg) ||
        (obsInfo.dngStg != null && predstgValue.stg >= obsInfo.dngStg) ||
        (obsInfo.fldStg != null && predstgValue.stg >= obsInfo.fldStg)
      ) {
        return true;
      }
    }
  }
  return false;
}

/**
 * 予測水位の最大観測日時を取得する
 * @param {*} predstgValues 予測水位リスト
 */
function getLaterPredTime(predstgValues) {
  let obsTime = null;
  if (Object.keys(predstgValues).length > 0) {
    for (var predstgValue of predstgValues) {
      if (obsTime === null) {
        obsTime = predstgValue.obsTime;
      } else {
        if (Util.formatDate(predstgValue.obsTime) > Util.formatDate(obsTime)) {
          obsTime = predstgValue.obsTime;
        }
      }
    }
  }
  return obsTime;
}

/**
 * [雨量観測所情報]雨量観測所情報(時間・10分単位)を生成
 * @param {*} tmDataList 雨量観測値情報のリスト
 */
function getMin10HrDataRain(tmDataList) {
  let rnList = [];
  let rnIncList = [];

  // 時刻補完はバッチ側で実施
  if (tmDataList != null) {
    for (var rnValue of tmDataList) {
      var rn = {
        obsTime: rnValue.obsTime,
        rn10m: "rn10m" in rnValue ? rnValue.rn10m : null,
        rn10mCcd: "rn10mCcd" in rnValue ? rnValue.rn10mCcd : null,
        rnHr: "rnHr" in rnValue ? rnValue.rnHr : null,
        rnHrCcd: "rnHrCcd" in rnValue ? rnValue.rnHrCcd : null,
      };
      rnList.push(rn);

      var rnInc = {
        obsTime: rnValue.obsTime,
        rnInc: rnValue.rnInc,
        rnIncCcd: rnValue.rnIncCcd,
      };
      rnIncList.push(rnInc);
    }
  }

  return {
    rnList: rnList,
    rnIncList: rnIncList,
  };
}

/**
 * [流域平均観測所情報]流域平均観測所情報(時間・10分単位)を生成
 * @param {*} tmDataList 流域平均観測値情報のリスト
 */
function getMin10HrDataBsn(tmDataList) {
  let bsnList = [];
  let bsnIncList = [];

  // 時刻補完はバッチ側で実施
  if (tmDataList != null) {
    for (var bsnValue of tmDataList) {
      var bsn = {
        obsTime: bsnValue.obsTime,
        bsnrn10m: "bsnrn10m" in bsnValue ? bsnValue.bsnrn10m : null,
        bsnrn10mCcd: "bsnrn10mCcd" in bsnValue ? bsnValue.bsnrn10mCcd : null,
        bsnrnHr: "bsnrnHr" in bsnValue ? bsnValue.bsnrnHr : null,
        bsnrnHrCcd: "bsnrnHrCcd" in bsnValue ? bsnValue.bsnrnHrCcd : null,
      };
      bsnList.push(bsn);

      var bsnInc = {
        obsTime: bsnValue.obsTime,
        bsnrnInc: bsnValue.bsnrnInc,
        bsnrnIncCcd: bsnValue.bsnrnIncCcd,
      };
      bsnIncList.push(bsnInc);
    }
  }
  return {
    bsnList: bsnList,
    bsnIncList: bsnIncList,
  };
}

/**
 * [水位観測所情報]水位観測所情報(時間・10分単位)を生成
 * @param {*} tmDataList 水位観測値情報のリスト
 * @param {*} reprnTmDataList 関連雨量観測値情報のリスト
 */
function getMin10HrDataStg(tmDataList, reprnTmDataList) {
  let result = [];

  // 通常水位と関連雨量観測値リストを統合する(時刻補完はバッチ側で実施)
  for (var cnt in tmDataList) {
    var stg = {
      obsTime: tmDataList[cnt].obsTime,
      stg: tmDataList[cnt].stg,
      stgHght: tmDataList[cnt].stgHght,
      stgCcd: tmDataList[cnt].stgCcd,
      stgOvlvl: tmDataList[cnt].stgOvlvl,
      stg10mChg:
        "stg10mChg" in tmDataList[cnt] ? tmDataList[cnt].stg10mChg : null,
      stg10mChgCcd:
        "stg10mChgCcd" in tmDataList[cnt] ? tmDataList[cnt].stg10mChgCcd : null,
      stgHrChg: "stgHrChg" in tmDataList[cnt] ? tmDataList[cnt].stgHrChg : null,
      stgHrChgCcd:
        "stgHrChgCcd" in tmDataList[cnt] ? tmDataList[cnt].stgHrChgCcd : null,
      // 堤防天端からの高さ
      diffTopendHght: tmDataList[cnt].stgHght,
      stgQmflg: tmDataList[cnt].stgQmflg,
      // 関連雨量観測所が存在する場合値を入れる
      rn10m:
        reprnTmDataList != null && "rn10m" in reprnTmDataList[cnt]
          ? reprnTmDataList[cnt].rn10m
          : null,
      rn10mCcd:
        reprnTmDataList != null && "rn10mCcd" in reprnTmDataList[cnt]
          ? reprnTmDataList[cnt].rn10mCcd
          : null,
      rnHr:
        reprnTmDataList != null && "rnHr" in reprnTmDataList[cnt]
          ? reprnTmDataList[cnt].rnHr
          : null,
      rnHrCcd:
        reprnTmDataList != null && "rnHrCcd" in reprnTmDataList[cnt]
          ? reprnTmDataList[cnt].rnHrCcd
          : null,
      // 累加雨量は10分・時間両方に含まれているため、プロパティ有無判定はしない
      rnInc: reprnTmDataList != null ? reprnTmDataList[cnt].rnInc : null,
      rnIncCcd: reprnTmDataList != null ? reprnTmDataList[cnt].rnIncCcd : null,
    };
    result.push(stg);
  }

  return result;
}

/**
 * [水位観測所情報]河川横断図情報(時間・10分単位)を生成
 * @param {*} tmDataList 水位観測値情報のリスト
 * @param {string} argObsTime 観測日時
 * @param {string} subMinutes リスト化する時間単位
 */
function getMin10HrDataCross(tmDataList, argObsTime, subMinutes) {
  let nextObsTime = Util.toDate(argObsTime);
  let stgList = [];

  // 1レコード目, obsValueより未来が存在するが値が設定されていない場合はそのレコードを削除して処理を続行
  if (
    tmDataList &&
    Object.keys(tmDataList).length > 0 &&
    Util.formatDate(tmDataList[0].obsTime) > Util.formatDate(argObsTime) &&
    tmDataList[0].stg === null
  ) {
    tmDataList.shift();
  }

  // 水位観測所
  if (tmDataList && Object.keys(tmDataList).length > 0) {
    let stgChg = null;
    let stgChgCcd = null;
    for (var stgValue of tmDataList) {
      // 該当時刻範囲でデータが抜けていた場合は補完する
      if (Util.formatDate(stgValue.obsTime) <= Util.formatDate(argObsTime)) {
        // 水位観測値情報のリストの時刻が横断図の最新観測日時よりも過去の場合補完する
        while (
          Util.formatDate(stgValue.obsTime) != Util.formatDate(nextObsTime)
        ) {
          if (stgList.length < 50) {
            stgList.push(getMissingCrossValue(nextObsTime));
          }
          nextObsTime = Util.subMinutes(nextObsTime, subMinutes).toDate();
        }
      } else {
        // 水位観測値情報のリストの時刻が横断図の最新観測日時よりも未来の場合
        // 水位観測値情報リストをスキップする
        continue;
      }

      // 50時刻に満たない場合は追加する
      if (stgList.length < 50) {
        stgChg = null;
        stgChgCcd = null;
        if (subMinutes === 10) {
          // 10分単位
          stgChg = stgValue.stg10mChg;
          stgChgCcd = stgValue.stg10mChgCcd;
        } else {
          // 時間単位
          stgChg = stgValue.stgHrChg;
          stgChgCcd = stgValue.stgHrChgCcd;
        }

        var elevation = null;
        if (
          stgValue.stgCcd != null &&
          stgValue.stgCcd != 140 &&
          stgValue.stgCcd != 160 &&
          stgValue.stgCcd != 190
        ) {
          // 小数点第2位で切り上げ
          elevation = roundUpValue(stgValue.stgCrsHght, 100);
        }
        var stg = {
          date: stgValue.obsTime,
          elevation: elevation,
          stg: stgValue.stg,
          stg_ccd: stgValue.stgCcd,
          stg_qmflg: stgValue.stgQmflg,
          stg_ovlvl: stgValue.stgOvlvl,
          stg_chg: stgChg,
          stg_chg_ccd: stgChgCcd,
        };
        stgList.push(stg);
      }
      // 指定時間ずつ前の時刻に戻る
      nextObsTime = Util.subMinutes(nextObsTime, subMinutes).toDate();
    }
  }
  // 観測値リストが50件に満たない場合に補完する。
  while (stgList.length < 50) {
    stgList.push(getMissingCrossValue(nextObsTime));
    nextObsTime = Util.subMinutes(nextObsTime, subMinutes).toDate();
  }

  return stgList;
}

/**
 * [ダム観測所情報]水位観測所情報(時間・10分単位)を生成
 * @param {*} tmDataList 水位観測値情報のリスト
 * @param {*} reprnTmDataList 関連雨量観測値情報のリスト
 */
function getMin10HrDataDam(tmDataList, reprnTmDataList) {
  let result = [];

  // ダム観測所と関連雨量観測値リストを統合する(時刻補完はバッチ側で実施)
  if (tmDataList != null) {
    for (var cnt in tmDataList) {
      var damReprn = {
        obsTime: tmDataList[cnt].obsTime,
        storLvl: tmDataList[cnt].storLvl,
        storLvlCcd: tmDataList[cnt].storLvlCcd,
        storCap: tmDataList[cnt].storCap,
        storCapCcd: tmDataList[cnt].storCapCcd,
        storPcntIrr: tmDataList[cnt].storPcntIrr,
        storPcntIrrCcd: tmDataList[cnt].storPcntIrrCcd,
        storPcntEff: tmDataList[cnt].storPcntEff,
        storPcntEffCcd: tmDataList[cnt].storPcntEffCcd,
        flood: tmDataList[cnt].storFcntIrr,
        floodCcd: tmDataList[cnt].storFcntIrrCcd,
        allSink: tmDataList[cnt].allSink,
        allSinkCcd: tmDataList[cnt].allSinkCcd,
        allDisch: tmDataList[cnt].allDisch,
        allDischCcd: tmDataList[cnt].allDischCcd,
        rdbsnrn10m:
          reprnTmDataList != null && "rdbsnrn10m" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrn10m
            : null,
        rdbsnrn10mCcd:
          reprnTmDataList != null && "rdbsnrn10mCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrn10mCcd
            : null,
        rdbsnrnHr:
          reprnTmDataList != null && "rdbsnrnHr" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrnHr
            : null,
        rdbsnrnHrCcd:
          reprnTmDataList != null && "rdbsnrnHrCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrnHrCcd
            : null,
        rdbsnrnInc:
          reprnTmDataList != null && "rdbsnrnInc" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrnInc
            : null,
        rdbsnrnIncCcd:
          reprnTmDataList != null && "rdbsnrnIncCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].rdbsnrnIncCcd
            : null,
        bsnrn10m:
          reprnTmDataList != null && "bsnrn10m" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrn10m
            : null,
        bsnrn10mCcd:
          reprnTmDataList != null && "bsnrn10mCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrn10mCcd
            : null,
        bsnrnHr:
          reprnTmDataList != null && "bsnrnHr" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrnHr
            : null,
        bsnrnHrCcd:
          reprnTmDataList != null && "bsnrnHrCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrnHrCcd
            : null,
        bsnrnInc:
          reprnTmDataList != null && "bsnrnInc" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrnInc
            : null,
        bsnrnIncCcd:
          reprnTmDataList != null && "bsnrnIncCcd" in reprnTmDataList[cnt]
            ? reprnTmDataList[cnt].bsnrnIncCcd
            : null,
      };
      result.push(damReprn);
    }
  }

  return result;
}

/**
 * [レーダ流域平均観測所情報]レーダ流域平均観測所情報(時間・10分単位)を生成
 * @param {*} tmDataList レーダ流域平均観測値情報のリスト
 */
function getMin10HrDataRdBsn(tmDataList) {
  let rdbsnList = [];
  let rdbsnIncList = [];

  // 時刻補完はバッチ側で実施
  if (tmDataList != null) {
    for (var rdbsnValue of tmDataList) {
      var rdbsn = {
        obsTime: rdbsnValue.obsTime,
        rdbsnrn10m: "rdbsnrn10m" in rdbsnValue ? rdbsnValue.rdbsnrn10m : null,
        rdbsnrn10mCcd:
          "rdbsnrn10mCcd" in rdbsnValue ? rdbsnValue.rdbsnrn10mCcd : null,
        rdbsnrnHr: "rdbsnrnHr" in rdbsnValue ? rdbsnValue.rdbsnrnHr : null,
        rdbsnrnHrCcd:
          "rdbsnrnHrCcd" in rdbsnValue ? rdbsnValue.rdbsnrnHrCcd : null,
      };
      rdbsnList.push(rdbsn);

      var rdbsnInc = {
        obsTime: rdbsnValue.obsTime,
        rdbsnrnInc: rdbsnValue.rdbsnrnInc,
        rdbsnrnIncCcd: rdbsnValue.rdbsnrnIncCcd,
      };
      rdbsnIncList.push(rdbsnInc);
    }
  }
  return {
    rdbsnList: rdbsnList,
    rdbsnIncList: rdbsnIncList,
  };
}

/**
 * [ダム観測所情報]制限水位・放流水位情報の取得
 *
 * 観測日時が水位期間に含まれているとき、その水位と期間を返す。
 * 期間の判断は 月日 (年は判断基準に使用しない)
 *
 * @param appTime 観測日時 "YYYY/MM/dd HH:mm"
 * @param returnDateFormat 戻り値の期間の日付の形式
 * @param stage1 水位1
 * @param stage2 水位2
 * @param stage3 水位3
 * @param stage4 水位4
 * @param start1 水位期間開始1
 * @param start2 水位期間開始2
 * @param start3 水位期間開始3
 * @param start4 水位期間開始4
 * @param end1 水位期間終了1
 * @param end2 水位期間終了2
 * @param end3 水位期間終了3
 * @param end4 水位期間終了4
 */
function getStageInfo(
  appTime,
  returnDateFormat,
  stage1,
  stage2,
  stage3,
  stage4,
  start1,
  start2,
  start3,
  start4,
  end1,
  end2,
  end3,
  end4
) {
  const returnDateTimeFormatter = returnDateFormat;
  const checkDateTimeFormatter = "MM/DD";
  const checkAppTime = appTime.substring("YYYY/".length, "YYYY/MM/dd".length); //"MM/DD"

  // 水位期間1
  if (start1 != null && end1 != null) {
    var startStr = Util.formatDate(start1, checkDateTimeFormatter);
    var endStr = Util.formatDate(end1, checkDateTimeFormatter);
    if (
      (startStr < endStr &&
        startStr <= checkAppTime &&
        checkAppTime <= endStr) ||
      (startStr > endStr &&
        (startStr <= checkAppTime || checkAppTime <= endStr))
    ) {
      var stg = stage1;
      var stgStrt = Util.formatDate(start1, returnDateTimeFormatter);
      var stgEnd = Util.formatDate(end1, returnDateTimeFormatter);
      return { stg: stg, stgStrt: stgStrt, stgEnd: stgEnd };
    }
  }

  // 水位期間2
  if (start2 != null && end2 != null) {
    var star2tStr = Util.formatDate(start2, checkDateTimeFormatter);
    var end2Str = Util.formatDate(end2, checkDateTimeFormatter);
    if (
      (star2tStr < end2Str &&
        star2tStr <= checkAppTime &&
        checkAppTime <= end2Str) ||
      (star2tStr > end2Str &&
        (star2tStr <= checkAppTime || checkAppTime <= end2Str))
    ) {
      var stg2 = stage2;
      var stg2Strt = Util.formatDate(start2, returnDateTimeFormatter);
      var stg2End = Util.formatDate(end2, returnDateTimeFormatter);
      return {
        stg: stg2,
        stgStrt: stg2Strt,
        stgEnd: stg2End,
      };
    }
  }

  // 水位期間3
  if (start3 != null && end3 != null) {
    var star3tStr = Util.formatDate(start3, checkDateTimeFormatter);
    var end3Str = Util.formatDate(end3, checkDateTimeFormatter);
    if (
      (star3tStr < end3Str &&
        star3tStr <= checkAppTime &&
        checkAppTime <= end3Str) ||
      (star3tStr > end3Str &&
        (star3tStr <= checkAppTime || checkAppTime <= end3Str))
    ) {
      var stg3 = stage3;
      var stg3Strt = Util.formatDate(start3, returnDateTimeFormatter);
      var stg3End = Util.formatDate(end3, returnDateTimeFormatter);
      return {
        stg: stg3,
        stgStrt: stg3Strt,
        stgEnd: stg3End,
      };
    }
  }

  // 水位期間4
  if (start4 != null && end4 != null) {
    var star4tStr = Util.formatDate(start4, checkDateTimeFormatter);
    var end4Str = Util.formatDate(end4, checkDateTimeFormatter);
    if (
      (star4tStr < end4Str &&
        star4tStr <= checkAppTime &&
        checkAppTime <= end4Str) ||
      (star4tStr > end4Str &&
        (star4tStr <= checkAppTime || checkAppTime <= end4Str))
    ) {
      var stg4 = stage4;
      var stg4Strt = Util.formatDate(start4, returnDateTimeFormatter);
      var stg4End = Util.formatDate(end4, returnDateTimeFormatter);
      return {
        stg: stg4,
        stgStrt: stg4Strt,
        stgEnd: stg4End,
      };
    }
  }

  return { stg: null, stgStrt: null, stgEnd: null };
}

/**
 * [ダム観測所情報]ダム模式図関連情報を生成する
 *
 * @param {*} obsInfo ダム観測所情報
 * @param {*} tmData 最新ダム観測値情報
 * @param {*} dwStgObsInfo 下流水位観測所情報
 * @param {*} dwStgTmData 最新下流水位観測値情報
 * @param {*} relatTmObsInfo 流域平均雨量観測所情報
 * @param {*} relatTmTmData 最新流域平均雨量観測値情報
 * @param {*} relatRdObsInfo レーダ流域平均雨量観測所情報
 * @param {*} relatRdTmData レーダ流域平均雨量観測値情報
 * @param {*} damMin10DataList 10分単位のダム観測値情報
 * @param {*} damHrDataList 時間単位のダム観測値情報
 * @param {*} relatDwStgHrDataList [模式図用]時間単位の下流水位観測値情報
 * @param {*} limitStageInfo [模式図用]制限水位情報
 * @param {*} spareStageInfo [模式図用]予備放流水位情報
 * @param {string} argObsTime 観測日時(YYYY/MM/DD HH:mm)
 */
function setDiagData(
  obsInfo,
  tmData,
  dwStgObsInfo,
  dwStgTmData,
  relatTmObsInfo,
  relatTmTmData,
  relatRdObsInfo,
  relatRdTmData,
  damMin10DataList,
  damHrDataList,
  relatDwStgHrDataList,
  limitStageInfo,
  spareStageInfo,
  argObsTime
) {
  let diagRainData = null;
  let diagRainSpec = null;
  let diagDwStgSpec = null;
  let storLvlChange = null;
  let HrTmData = null;
  let HrDwStgTmData = null;
  let HrStorLvlChange = null;
  const storLvlUp = "up";
  const storLvlDown = "down";
  const storLvlNone = "none";
  const bsnText = "(流域平均)";
  const rdbsnText = "(レーダ流域平均)";

  // 雨量観測値の編集
  // 流域平均雨量を優先する
  if (
    relatTmTmData &&
    obsInfo.relatTmObsFcd !== null &&
    obsInfo.relatTmObsFcd !== "0000000000000"
  ) {
    diagRainData = {
      rainM: relatTmTmData.bsnrn10m,
      rainMCcd: relatTmTmData.bsnrn10mCcd,
      rainMCautOvflg: relatTmTmData.bsnrn10mCautOvflg,
      rainMWarnOvflg: relatTmTmData.bsnrn10mWarnOvflg,
      rainH: relatTmTmData.bsnrnHr10m,
      rainHCcd: relatTmTmData.bsnrnHr10mCcd,
      rainHCautOvflg: relatTmTmData.bsnrnHr10mCautOvflg,
      rainHWarnOvflg: relatTmTmData.bsnrnHr10mWarnOvflg,
      total: relatTmTmData.bsnrnInc,
      totalCcd: relatTmTmData.bsnrnIncCcd,
      totalCautOvflg: relatTmTmData.bsnrnIncCautOvflg,
      totalWarnOvflg: relatTmTmData.bsnrnIncWarnOvflg,
    };
  } else if (
    relatRdTmData &&
    obsInfo.relatRdObsFcd !== null &&
    obsInfo.relatRdObsFcd !== "0000000000000"
  ) {
    diagRainData = {
      rainM: relatRdTmData.rdbsnrn10m,
      rainMCcd: relatRdTmData.rdbsnrn10mCcd,
      rainMCautOvflg: relatRdTmData.rdbsnrn10mCautOvflg,
      rainMWarnOvflg: relatRdTmData.rdbsnrn10mWarnOvflg,
      rainH: relatRdTmData.rdbsnrnHr10m,
      rainHCcd: relatRdTmData.rdbsnrnHr10mCcd,
      rainHCautOvflg: relatRdTmData.rdbsnrnHr10mCautOvflg,
      rainHWarnOvflg: relatRdTmData.rdbsnrnHr10mWarnOvflg,
      total: relatRdTmData.rdbsnrnInc,
      totalCcd: relatRdTmData.rdbsnrnIncCcd,
      totalCautOvflg: relatRdTmData.rdbsnrnIncCautOvflg,
      totalWarnOvflg: relatRdTmData.rdbsnrnIncWarnOvflg,
    };
  } else {
    // データが無い場合はプロパティを生成する
    diagRainData = {
      rainM: null,
      rainMCcd: null,
      rainH: null,
      rainHCcd: null,
      total: null,
      totalCcd: null,
    };
  }

  // 雨量観測所の編集
  // 流域平均雨量を優先する
  if (
    relatTmObsInfo &&
    obsInfo.relatTmObsFcd !== null &&
    obsInfo.relatTmObsFcd !== "0000000000000"
  ) {
    diagRainSpec = {
      name:
        obsInfo.relatTmItmKndCd != 1
          ? relatTmObsInfo.obsNm + bsnText
          : relatTmObsInfo.obsNm,
    };
  } else if (
    relatRdObsInfo &&
    obsInfo.relatRdObsFcd !== null &&
    obsInfo.relatRdObsFcd !== "0000000000000"
  ) {
    diagRainSpec = {
      name:
        obsInfo.relatRdItmKndCd != 1
          ? relatRdObsInfo.obsNm + rdbsnText
          : relatRdObsInfo.obsNm,
    };
  } else {
    // データが無い場合はnull
    diagRainSpec = null;
  }

  // 検索時刻より10分前の時刻を取得
  let oldObsTime = Util.formatDate(Util.subMinutes(argObsTime, 10).toDate());
  // 貯水位変化量の取得
  if (
    damMin10DataList &&
    Object.keys(damMin10DataList).length > 0 &&
    argObsTime === Util.formatDate(damMin10DataList[0].obsTime) &&
    oldObsTime === Util.formatDate(damMin10DataList[1].obsTime)
  ) {
    // 1レコード目が検索時刻、2レコード目が検索時刻より10分前の時
    if (damMin10DataList[0].storLvlCcd != 0) {
      // 検索時刻の貯水位の内容コードが0以外の場合
      storLvlChange = storLvlNone;
    } else if (damMin10DataList[0].storLvl < damMin10DataList[1].storLvl) {
      storLvlChange = storLvlDown;
    } else if (damMin10DataList[0].storLvl > damMin10DataList[1].storLvl) {
      storLvlChange = storLvlUp;
    } else {
      storLvlChange = storLvlNone;
    }
  } else {
    storLvlChange = storLvlNone;
  }

  // 正時の時刻取得
  let argObsTimeHr = argObsTime.substring(0, argObsTime.length - 2) + "00";
  // 正時の検索時刻より1時間前の時刻取得
  let oldArgObsTimeHr = Util.formatDate(
    Util.subMinutes(argObsTimeHr, 60).toDate()
  );

  // ダムの正時のデータと貯水位変化量の取得
  if (
    damHrDataList &&
    Object.keys(damHrDataList).length > 0 &&
    argObsTimeHr === Util.formatDate(damHrDataList[0].obsTime)
  ) {
    // 時間リストの1レコード目が検索時刻の正時と一致した場合
    HrTmData = damHrDataList[0];

    if (oldArgObsTimeHr === Util.formatDate(damHrDataList[1].obsTime)) {
      // 2レコード目が検索時刻の1時間前と一致した場合
      if (HrTmData.storLvlCcd != 0) {
        // 検索時刻の貯水位の内容コードが0以外の場合
        HrStorLvlChange = storLvlNone;
      } else if (HrTmData.storLvl < damHrDataList[1].storLvl) {
        HrStorLvlChange = storLvlDown;
      } else if (HrTmData.storLvl > damHrDataList[1].storLvl) {
        HrStorLvlChange = storLvlUp;
      } else {
        HrStorLvlChange = storLvlNone;
      }
    }
  }

  // 下流観測所の正時のデータと貯水位変化量の取得
  if (
    relatDwStgHrDataList &&
    Object.keys(relatDwStgHrDataList).length > 0 &&
    argObsTimeHr === Util.formatDate(relatDwStgHrDataList[0].obsTime)
  ) {
    // 時間リストの1レコード目が検索時刻の正時と一致した場合
    HrDwStgTmData = relatDwStgHrDataList[0];
  }

  // 下流観測所の編集
  if (dwStgObsInfo) {
    diagDwStgSpec = {
      name: dwStgObsInfo.obsNm,
      damLat: obsInfo.lat,
      damLon: obsInfo.lon,
      stgLat: dwStgObsInfo.lat,
      stgLon: dwStgObsInfo.lon,
    };
  }

  // 模式図情報の生成
  let diagData = {
    value: {
      date:
        tmData != null && tmData.obsTime
          ? Util.formatDate(tmData.obsTime, "YYYY/MM/DD")
          : Util.formatDate(argObsTime, "YYYY/MM/DD"),
      time:
        tmData != null && tmData.obsTime
          ? Util.formatDate(tmData.obsTime, "HH:mm:ss")
          : Util.formatDate(argObsTime, "YYYY/MM/DD"),
      dam: {
        lvl: tmData != null ? tmData.storLvl : null,
        lvlCcd: tmData != null ? tmData.storLvlCcd : null,
        // 10分前のデータとの貯水位変化量
        chg: tmData != null ? storLvlChange : null,
        irr: tmData != null ? tmData.storPcntIrr : null,
        irrCcd: tmData != null ? tmData.storPcntIrrCcd : null,
        flood: tmData != null ? tmData.storFcntIrr : null,
        floodCcd: tmData != null ? tmData.storFcntIrrCcd : null,
        sink: tmData != null ? tmData.allSink : null,
        sinkCcd: tmData != null ? tmData.allSinkCcd : null,
        disch: tmData != null ? tmData.allDisch : null,
        dischCcd: tmData != null ? tmData.allDischCcd : null,
      },
      damH: {
        lvl: HrTmData != null ? HrTmData.storLvl : null,
        lvlCcd: HrTmData != null ? HrTmData.storLvlCcd : null,
        // 1時間前のデータとの貯水位変化量
        chg: HrTmData != null ? HrStorLvlChange : null,
        irr: HrTmData != null ? HrTmData.storPcntIrr : null,
        irrCcd: HrTmData != null ? HrTmData.storPcntIrrCcd : null,
        flood: HrTmData != null ? HrTmData.storFcntIrr : null,
        floodCcd: HrTmData != null ? HrTmData.storFcntIrrCcd : null,
        sink: HrTmData != null ? HrTmData.allSink : null,
        sinkCcd: HrTmData != null ? HrTmData.allSinkCcd : null,
        disch: HrTmData != null ? HrTmData.allDisch : null,
        dischCcd: HrTmData != null ? HrTmData.allDischCcd : null,
      },
      rain: diagRainData,
      stage: {
        // 零点高からの高さ
        lvl: dwStgTmData != null ? dwStgTmData.stg : null,
        // 堤防天端からの高さ
        lvlHght: dwStgTmData != null ? dwStgTmData.stgHght : null,
        lvlCcd: dwStgTmData != null ? dwStgTmData.stgCcd : null,
        stgOvlvl: dwStgTmData != null ? dwStgTmData.stgOvlvl : null,
      },
      stageH: {
        // 零点高からの高さ
        lvl: HrDwStgTmData != null ? HrDwStgTmData.stg : null,
        // 堤防天端からの高さ
        lvlHght: HrDwStgTmData != null ? HrDwStgTmData.stgHght : null,
        lvlCcd: HrDwStgTmData != null ? HrDwStgTmData.stgCcd : null,
        stgOvlvl: HrDwStgTmData != null ? HrDwStgTmData.stgOvlvl : null,
      },
    },
    dsch: {
      lvl: tmData != null ? tmData.damdschLvl : null,
      name: tmData != null ? tmData.damdschFgrNm : null,
    },
    spec: {
      dam: {
        name: obsInfo.obsNm,
        proviso: setPrvsStg(limitStageInfo, obsInfo.prvsStg),
        srchgStage: obsInfo.srchgStg,
        normalStage: obsInfo.nrmlHighStg,
        minStage: obsInfo.minStg,
        floodctl: obsInfo.fldctlStrtFlw,
        dsgnFldLv: obsInfo.dsgnFldLv,
        limitStage: {
          value: limitStageInfo.stg,
          start: limitStageInfo.stgStrt,
          end: limitStageInfo.stgEnd,
        },
        spareStage: {
          value: spareStageInfo.stg,
          start: spareStageInfo.stgStrt,
          end: spareStageInfo.stgEnd,
        },
      },
      rain: diagRainSpec,
      stage: diagDwStgSpec,
    },
  };
  return diagData;
}

/**
 * 未取集横断データ(横断図)
 *
 * @param obsTime 観測日時
 */
function getMissingCrossValue(obsTime) {
  return {
    date: Util.formatDate(obsTime, "YYYY/MM/DD HH:mm"),
    elevation: null,
    stg_ccd: NOT_COLLECTED,
    stg_qmflg: null,
    stg_chg_ccd: NOT_COLLECTED,
    stg_ovlvl: null,
    stg_chg: null,
  };
}

/**
 * 数値フォーマット（切り上げする）
 * @param {number} value 切り上げする数値
 * @param {number} base 切り上げ対象桁（100→少数点第2位）
 */
function roundUpValue(val1, base) {
  if (val1 === null) {
    return null;
  }
  return Math.ceil(val1 * base) / base;
}

// 異常洪水時防災操作開始水位計算
function setPrvsStg(info, prvsStg) {
  // 観測所情報か、ダム模式図からの呼び出しか判定する
  const obsInfoFlg = info.lmtStg !== undefined ? true : false;

  if (prvsStg !== null) {
    // 異常洪水時防災操作開始水位(ただし書き水位)がある場合はゲート操作方式と判定し出力する
    if (obsInfoFlg) {
      return {
        value: formatFloat(prvsStg),
        valid: true,
      };
    } else {
      return formatFloat(prvsStg);
    }
  } else {
    // 異常洪水時防災操作開始水位(ただし書き水位)が無い場合(自然調節方式)は表示しない
    if (obsInfoFlg) {
      return {
        value: null,
        valid: false,
      };
    } else {
      return null;
    }
  }
}

/**
 * 水位観測値リストの最小値を取得する(10分/時間)
 * @param stg10mList 水位観測値リスト(10分)
 * @param stgHrList  水位観測値リスト(時間)
 * @param predStgList 予測水位観測値リスト
 */
function getStgListMinValue(stg10mList, stgHrList, predStgList) {
  let min10MinStg = null;
  let min10MinStgHght = null;
  let hrMinStg = null;
  let hrMinStgHght = null;

  for (var mCnt = 0; mCnt < stg10mList.length; mCnt++) {
    if (stg10mList[mCnt].stg !== null && stg10mList[mCnt].stgCcd < 130) {
      if (min10MinStg === null) {
        min10MinStg = stg10mList[mCnt].stg;
      } else {
        min10MinStg =
          stg10mList[mCnt].stg < min10MinStg
            ? stg10mList[mCnt].stg
            : min10MinStg;
      }
    }
    if (stg10mList[mCnt].stgHght !== null && stg10mList[mCnt].stgCcd < 130) {
      if (min10MinStgHght === null) {
        min10MinStgHght = stg10mList[mCnt].stgHght;
      } else {
        min10MinStgHght =
          stg10mList[mCnt].stgHght < min10MinStgHght
            ? stg10mList[mCnt].stgHght
            : min10MinStgHght;
      }
    }
  }

  for (var hCnt = 0; hCnt < stgHrList.length; hCnt++) {
    if (stgHrList[hCnt].stg !== null && stgHrList[hCnt].stgCcd < 130) {
      if (hrMinStg === null) {
        hrMinStg = stgHrList[hCnt].stg;
      } else {
        hrMinStg =
          stgHrList[hCnt].stg < hrMinStg ? stgHrList[hCnt].stg : hrMinStg;
      }
    }
    if (stgHrList[hCnt].stgHght !== null && stgHrList[hCnt].stgCcd < 130) {
      if (hrMinStgHght === null) {
        hrMinStgHght = stgHrList[hCnt].stgHght;
      } else {
        hrMinStgHght =
          stgHrList[hCnt].stgHght < hrMinStgHght
            ? stgHrList[hCnt].stgHght
            : hrMinStgHght;
      }
    }
  }

  // 予測水位データ
  if (predStgList) {
    for (let pCnt = 0; pCnt < predStgList.length; pCnt++) {
      if (min10MinStg > predStgList[pCnt].stg) {
        min10MinStg = predStgList[pCnt].stg;
      }
      if (min10MinStgHght > predStgList[pCnt].stgHght) {
        min10MinStgHght = predStgList[pCnt].stgHght;
      }

      if (hrMinStg > predStgList[pCnt].stg) {
        hrMinStg = predStgList[pCnt].stg;
      }
      if (hrMinStgHght > predStgList[pCnt].stgHght) {
        hrMinStgHght = predStgList[pCnt].stgHght;
      }
    }
  }

  return {
    min10Stg: min10MinStg,
    min10StgHght: min10MinStgHght,
    hrStg: hrMinStg,
    hrStgHght: hrMinStgHght,
  };
}

/**
 * 水位観測値リストの最大値を取得する(10分/時間)
 * @param stg10mList 水位観測値リスト(10分)
 * @param stgHrList  水位観測値リスト(時間)
 * @param predStgList 予測水位観測値リスト
 */
function getStgListMaxValue(stg10mList, stgHrList, predStgList) {
  let min10MaxStg = null;
  let min10MaxStgHght = null;
  let hrMaxStg = null;
  let hrMaxStgHght = null;

  for (var mCnt = 0; mCnt < stg10mList.length; mCnt++) {
    if (min10MaxStg === null && stg10mList[mCnt].stgCcd < 130) {
      min10MaxStg = stg10mList[mCnt].stg;
    } else {
      if (min10MaxStg < stg10mList[mCnt].stg && stg10mList[mCnt].stgCcd < 130) {
        min10MaxStg = stg10mList[mCnt].stg;
      }
    }
    if (min10MaxStgHght === null && stg10mList[mCnt].stgCcd < 130) {
      min10MaxStgHght = stg10mList[mCnt].stgHght;
    } else {
      if (
        min10MaxStgHght < stg10mList[mCnt].stgHght &&
        stg10mList[mCnt].stgCcd < 130
      ) {
        min10MaxStgHght = stg10mList[mCnt].stgHght;
      }
    }
  }

  for (var hCnt = 0; hCnt < stgHrList.length; hCnt++) {
    if (hrMaxStg === null && stgHrList[hCnt].stgCcd < 130) {
      hrMaxStg = stgHrList[hCnt].stg;
    } else {
      if (hrMaxStg < stgHrList[hCnt].stg && stgHrList[hCnt].stgCcd < 130) {
        hrMaxStg = stgHrList[hCnt].stg;
      }
    }
    if (hrMaxStgHght === null && stgHrList[hCnt].stgCcd < 130) {
      hrMaxStgHght = stgHrList[hCnt].stgHght;
    } else {
      if (
        hrMaxStgHght < stgHrList[hCnt].stgHght &&
        stgHrList[hCnt].stgCcd < 130
      ) {
        hrMaxStgHght = stgHrList[hCnt].stgHght;
      }
    }
  }

  // 予測水位データ
  if (predStgList) {
    for (let pCnt = 0; pCnt < predStgList.length; pCnt++) {
      if (min10MaxStg < predStgList[pCnt].stg) {
        min10MaxStg = predStgList[pCnt].stg;
      }
      if (min10MaxStgHght < predStgList[pCnt].stgHght) {
        min10MaxStgHght = predStgList[pCnt].stgHght;
      }
      if (hrMaxStg < predStgList[pCnt].stg) {
        hrMaxStg = predStgList[pCnt].stg;
      }
      if (hrMaxStgHght < predStgList[pCnt].stgHght) {
        hrMaxStgHght = predStgList[pCnt].stgHght;
      }
    }
  }
  return {
    min10Stg: min10MaxStg,
    min10StgHght: min10MaxStgHght,
    hrStg: hrMaxStg,
    hrStgHght: hrMaxStgHght,
  };
}

/**
 * 最小の基準水位を取得する
 *
 * @param rsrvStg 水防団待機水位
 * @param warnStg 避難注意水位
 * @param spclWarnStg 避難判断水位
 * @param dngStg 氾濫危険水位
 * @param fldStg 氾濫開始水位
 */
function getMinStandardVlue(rsrvStg, warnStg, spclWarnStg, dngStg, fldStg) {
  if (rsrvStg != null) {
    // 水防団待機
    return rsrvStg;
  } else if (warnStg != null) {
    // 避難注意水位
    return warnStg;
  } else if (spclWarnStg != null) {
    // 避難判断水位
    return spclWarnStg;
  } else if (dngStg != null) {
    // 氾濫危険水位
    return dngStg;
  } else if (fldStg != null) {
    // 氾濫開始水位
    return fldStg;
  }

  return null;
}

/**
 * 最大の基準水位を取得する
 *
 * @param fldStg 氾濫開始水位
 * @param dngStg 氾濫危険水位
 * @param spclWarnStg 避難判断水位
 * @param warnStg 避難注意水位
 * @param rsrvStg 水防団待機水位
 */
function getMaxStandardVlue(fldStg, dngStg, spclWarnStg, warnStg, rsrvStg) {
  if (fldStg != null) {
    // 氾濫開始水位
    return fldStg;
  } else if (dngStg != null) {
    // 氾濫危険水位
    return dngStg;
  } else if (spclWarnStg != null) {
    // 避難判断水位
    return spclWarnStg;
  } else if (warnStg != null) {
    // 避難注意水位
    return warnStg;
  } else if (rsrvStg != null) {
    // 水防団待機水位
    return rsrvStg;
  }
  return null;
}

/**
 * 水位グラフの下限値を算出する
 * @param {number} minStg 最小の観測値
 * @param {number} minStandard 最小の基準値
 */
// function getGraphMinValue(minStg, minStandard) {
//   // nullケース
//   if (minStg != null && minStandard == null) {
//     // 整数値の場合は切り捨て後の値と同値なので、1引く
//     if (Number.isInteger(minStg)) {
//       minStg = minStg - 1.0;
//     }
//     // 小数点切り下げ
//     return Math.floor(minStg);
//   } else if (minStg == null && minStandard != null) {
//     if (Number.isInteger(minStandard)) {
//       minStandard = minStandard - 1.0;
//     }
//     return Math.floor(minStandard);
//   } else if (minStg == null && minStandard == null) {
//     return 0;
//   }

//   if (minStg <= minStandard) {
//     // 最小の基準値よりも水位が小さい場合
//     if (Number.isInteger(minStg)) {
//       minStg = minStg - 1.0;
//     }
//     // 小数点切り下げ
//     return Math.floor(minStg);
//   } else {
//     if (Number.isInteger(minStandard)) {
//       minStandard = minStandard - 1.0;
//     }
//     return Math.floor(minStandard);
//   }
// }

/**
 * 水位グラフの上限値を算出する
 * @param {number} maxStg 最小の観測値
 * @param {number} maxStandard 最小の基準値
 */
// function getGraphMaxValue(maxStg, maxStandard) {
//   // nullケース
//   if (maxStg != null && maxStandard == null) {
//     // 小数点切り上げ
//     return roundUpValue(maxStg, 1);
//   } else if (maxStg == null && maxStandard != null) {
//     return roundUpValue(maxStandard, 1);
//   } else if (maxStg == null && maxStandard == null) {
//     return 0;
//   }

//   if (maxStg <= maxStandard) {
//     return roundUpValue(maxStandard, 1);
//   } else {
//     return roundUpValue(maxStg, 1);
//   }
// }

function getLatestScamTime(obsData) {
  var dateType = obsData.scamDetailInfo.dateTypeNow;
  var getTime = obsData.scamDetailInfo.getTime;
  var createTime = obsData.scamDetailInfo.createTime;

  if (dateType === 2 && createTime != null) {
    return createTime;
  } else if (
    (dateType === 2 && getTime != null) ||
    (dateType === 0 && getTime != null)
  ) {
    return getTime;
  } else {
    return null;
  }
}

/**
 * 未収集判定
 * @param itmkndCd 観測所種別コード
 * @param {*} tmData 最新水位観測値情報
 */
function checkNotCollected(itmkndCd, tmData) {
  if (tmData === null) {
    return true;
  }
  if (itmkndCd === 4) {
    if (
      typeof tmData.stgCcd !== "undefined" &&
      tmData.stgCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 7) {
    if (
      typeof tmData.storLvlCcd !== "undefined" &&
      tmData.storLvlCcd === NOT_COLLECTED &&
      typeof tmData.storCapCcd !== "undefined" &&
      tmData.storCapCcd === NOT_COLLECTED &&
      typeof tmData.storPcntIrrCcd !== "undefined" &&
      tmData.storPcntIrrCcd === NOT_COLLECTED &&
      typeof tmData.allSinkCcd !== "undefined" &&
      tmData.allSinkCcd === NOT_COLLECTED &&
      typeof tmData.allDischCcd !== "undefined" &&
      tmData.allDischCcd === NOT_COLLECTED &&
      typeof tmData.storPcntEffCcd !== "undefined" &&
      tmData.storPcntEffCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 1) {
    if (
      typeof tmData.rn10mCcd !== "undefined" &&
      tmData.rn10mCcd === NOT_COLLECTED &&
      typeof tmData.rnHr10mCcd !== "undefined" &&
      tmData.rnHr10mCcd === NOT_COLLECTED &&
      typeof tmData.rnIncCcd !== "undefined" &&
      tmData.rnIncCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd == 2) {
    if (
      typeof tmData.bsnrn10mCcd !== "undefined" &&
      tmData.bsnrn10mCcd === NOT_COLLECTED &&
      typeof tmData.bsnrnHr10mCcd !== "undefined" &&
      tmData.bsnrnHr10mCcd === NOT_COLLECTED &&
      typeof tmData.bsnrnIncCcd !== "undefined" &&
      tmData.bsnrnIncCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 6) {
    if (
      typeof tmData.wtrtmpCcd !== "undefined" &&
      tmData.wtrtmpCcd === NOT_COLLECTED &&
      typeof tmData.conductCcd !== "undefined" &&
      tmData.conductCcd === NOT_COLLECTED &&
      typeof tmData.doxCcd !== "undefined" &&
      tmData.doxCcd === NOT_COLLECTED &&
      typeof tmData.phCcd !== "undefined" &&
      tmData.phCcd === NOT_COLLECTED &&
      typeof tmData.turbdtyCcd !== "undefined" &&
      tmData.turbdtyCcd === NOT_COLLECTED &&
      typeof tmData.codCcd !== "undefined" &&
      tmData.codCcd === NOT_COLLECTED &&
      typeof tmData.amnCcd !== "undefined" &&
      tmData.amnCcd === NOT_COLLECTED &&
      typeof tmData.sltCcd !== "undefined" &&
      tmData.sltCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 12) {
    if (
      typeof tmData.onthwvHghtCcd !== "undefined" &&
      tmData.onthwvHghtCcd === NOT_COLLECTED &&
      typeof tmData.tidlvlCcd !== "undefined" &&
      tmData.tidlvlCcd === NOT_COLLECTED &&
      typeof tmData.avewndSpdCcd !== "undefined" &&
      tmData.avewndSpdCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd === 3) {
    if (
      typeof tmData.snwdpCcd !== "undefined" &&
      tmData.snwdpCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  } else if (itmkndCd == 20 || itmkndCd == 21) {
    if (
      typeof tmData.rdbsnrn10mCcd !== "undefined" &&
      tmData.rdbsnrn10mCcd === NOT_COLLECTED &&
      typeof tmData.rdbsnrnHr10mCcd !== "undefined" &&
      tmData.rdbsnrnHr10mCcd === NOT_COLLECTED &&
      typeof tmData.rdbsnrnIncCcd !== "undefined" &&
      tmData.rdbsnrnIncCcd === NOT_COLLECTED
    ) {
      return true;
    }
    return false;
  }
  return false;
}

/**
 * クリップボードコピー用のヘッダー生成
 * @param headers 観測値リストのヘッダー
 * @param rowNm1 1列の中で区切る要素数(3要素ごとに区切る場合は3を指定,
 *                                    1-2-1毎に区切る場合は1を指定)
 * @param rowNm2 1列の中で区切る要素数(1-2-1毎に区切る場合は2を指定)
 * @param rowNm3 1列の中で区切る要素数(1-2-1毎に区切る場合は1を指定)
 */
function getCopyHeader(headers, rowNm1, rowNm2, rowNm3) {
  let header = "";
  let tab = "";
  let cnt = rowNm1 != undefined ? 1 : 0;

  for (var headIndex = 0; headIndex < headers.length; headIndex++) {
    // 改行コードがある場合は除外する
    headers[headIndex].text = headers[headIndex].text.replace(/\r?\n/g, "");

    if (cnt == 1 && headIndex != 0) {
      // rowNm1が設定されている場合
      tab = "";
      for (var i = 1; i < rowNm1; i++) {
        // 要素数分ヘッダーを追加
        tab += "\t" + headers[headIndex].text;
      }
      if (rowNm2 != undefined) {
        cnt++;
      }
    } else if (cnt == 2 && headIndex != 0) {
      // rowNm2が設定されている場合
      tab = "";
      for (var j = 1; j < rowNm2; j++) {
        tab += "\t" + headers[headIndex].text;
      }
      if (rowNm3 != undefined) {
        cnt++;
      } else {
        cnt--;
      }
    } else if (cnt == 3 && headIndex != 0) {
      // rowNm3が設定されている場合
      tab = "";
      for (var k = 1; k < rowNm3; k++) {
        tab += "\t" + headers[headIndex].text;
      }
      // rowNm1に戻る
      cnt -= 2;
    }

    header +=
      headers[headIndex].text +
      tab +
      (headers.length - 1 != headIndex ? "\t" : "");
  }
  return header;
}

/**
 * ダム関連雨量観測所の最新観測値プロパティ名を変換
 * @param obsValue 関連雨量観測所観測値
 * @param itmKndCdBfr 変換前の観測所種別
 * @param itmKndCdConv 変換後の観測所種別
 */
function convertRelatObsValue(obsValue, itmKndCdBfr, itmKndCdConv) {
  if (itmKndCdBfr === 1) {
    // データが雨量観測所だった場合
    if (itmKndCdConv == 2) {
      // 観測所種別コード = 2(流域平均雨量)
      // 変更するプロパティ名のオブジェクトを作成
      const newKeys = {
        rn10m: "bsnrn10m",
        rn10mCcd: "bsnrn10mCcd",
        rn10mCautOvflg: "bsnrn10mCautOvflg",
        rn10mWarnOvflg: "bsnrn10mWarnOvflg",
        rnHr: "bsnrnHr",
        rnHrCcd: "bsnrnHrCcd",
        rnHrCautOvflg: "bsnrnHrCautOvflg",
        rnHrWarnOvflg: "bsnrnHrWarnOvflg",
        rnInc: "bsnrnInc",
        rnIncCcd: "bsnrnIncCcd",
        rnIncCautOvflg: "bsnrnIncCautOvflg",
        rnIncWarnOvflg: "bsnrnIncWarnOvflg",
        rnHr10m: "bsnrnHr10m",
        rnHr10mCcd: "bsnrnHr10mCcd",
        rnHr10mCautOvflg: "bsnrnHr10mCautOvflg",
        rnHr10mWarnOvflg: "bsnrnHr10mWarnOvflg",
      };
      return renameKeys(obsValue, newKeys);
    } else if ((itmKndCdConv === 20) | (itmKndCdConv === 21)) {
      // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
      const newKeys = {
        rn10m: "rdbsnrn10m",
        rn10mCcd: "rdbsnrn10mCcd",
        rn10mCautOvflg: "rdbsnrn10mCautOvflg",
        rn10mWarnOvflg: "rdbsnrn10mWarnOvflg",
        rnHr: "rdbsnrnHr",
        rnHrCcd: "rdbsnrnHrCcd",
        rnHrCautOvflg: "rdbsnrnHrCautOvflg",
        rnHrWarnOvflg: "rdbsnrnHrWarnOvflg",
        rnInc: "rdbsnrnInc",
        rnIncCcd: "rdbsnrnIncCcd",
        rnIncCautOvflg: "rdbsnrnIncCautOvflg",
        rnIncWarnOvflg: "rdbsnrnIncWarnOvflg",
        rnHr10m: "rdbsnrnHr10m",
        rnHr10mCcd: "rdbsnrnHr10mCcd",
        rnHr10mCautOvflg: "rdbsnrnHr10mCautOvflg",
        rnHr10mWarnOvflg: "rdbsnrnHr10mWarnOvflg",
      };
      return renameKeys(obsValue, newKeys);
    }
  }
  return obsValue;
}

/**
 * ダム関連雨量観測所の10分/時間リストのプロパティ名を変換
 * @param dataList 10分/時間リスト
 * @param itmKndCdBfr 変換前の観測所種別
 * @param itmKndCdConv 変換後の観測所種別
 */
function convertRelatDataList(dataList, itmKndCdBfr, itmKndCdConv) {
  if (itmKndCdBfr === 1) {
    // データが雨量観測所だった場合
    if (itmKndCdConv == 2) {
      // 観測所種別コード = 2(流域平均雨量)
      let resultList = [];
      const newKeys = {
        rn10m: "bsnrn10m",
        rn10mCcd: "bsnrn10mCcd",
        rnHr: "bsnrnHr",
        rnHrCcd: "bsnrnHrCcd",
        rnInc: "bsnrnInc",
        rnIncCcd: "bsnrnIncCcd",
      };
      for (const data of dataList) {
        resultList.push(renameKeys(data, newKeys));
      }
      return resultList;
    } else if ((itmKndCdConv === 20) | (itmKndCdConv === 21)) {
      // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
      let resultList = [];
      const newKeys = {
        rn10m: "rdbsnrn10m",
        rn10mCcd: "rdbsnrn10mCcd",
        rnHr: "rdbsnrnHr",
        rnHrCcd: "rdbsnrnHrCcd",
        rnInc: "rdbsnrnInc",
        rnIncCcd: "rdbsnrnIncCcd",
      };
      for (const data of dataList) {
        resultList.push(renameKeys(data, newKeys));
      }
      return resultList;
    }
  }
  return dataList;
}

/**
 * JSONプロパティ名を変換
 * @param obj 変換対象のjson
 * @param newKeys 変更するプロパティ名のオブジェクト
 */
function renameKeys(obj, newKeys) {
  const keyValues = Object.keys(obj).map((key) => {
    const newKey = newKeys[key] || key;
    return { [newKey]: obj[key] };
  });
  return Object.assign({}, ...keyValues);
}
/**
 * 関連雨量観測所の観測所種別を判別
 * @param tm 関連雨量観測所の観測値
 * @param kndCd 関連雨量観測所の観測所種別
 * @param nm データ項目名
 */
function checkReprnObs(tm, kndCd, nm) {
  let data = null;
  if (kndCd === 2) {
    data = "bsn" + nm;
  } else if (kndCd === 20 || kndCd === 21) {
    data = "rdbsn" + nm;
  } else {
    data = nm;
  }
  if (nm.includes("Ccd")) {
    return tm != null ? tm[data] : NOT_COLLECTED;
  } else {
    return tm != null ? tm[data] : null;
  }
}

/**
 * 観測位置情報の現在の画像URLから画像名（カメラID）のみ切り取り
 * @param currProvUrl 現在の画像URL
 */
function extractImageName(currProvUrl) {
  const lastSegment = currProvUrl.split('/').pop();
  const imageName = lastSegment.split('.')[0];
  return imageName;
}

async function getUrl(path, itmkndCd, originProduction, historyCamUrl, testEnvironmentsIp) {
  const response = await TelemeterRepository.getHistoryImagePaths(path, itmkndCd, originProduction, historyCamUrl, testEnvironmentsIp);
  return {
    status: response.status,
  };
}

async function getJsonUrl(path) {
  const response = await TelemeterJsonRepository.getHistoryScamDetailJson(path);
  return {
    status: response.status,
    data: response.data
  };
}

/**
 * 過去画像URLの作成と取得
 * @param appTime 観測日時
 * @param cameraId 画像名取得
 * @param itmkndCd 観測所種別コード
 * @param sysId カメラ種別
 */
async function obsAppTimeArray({appTime, cameraId, itmkndCd, sysId}, originProduction, historyCamUrl, testEnvironmentsIp) {
  const noImageUrl = originProduction + "/kawabou/img/no-image.png";
  if (!appTime || !cameraId || !itmkndCd) {
    return noImageUrl;
  }

  const minutesStep = sysId === 1 ? 5 : 10;
  let startTime = roundTimeToInterval(appTime, sysId);
  /**
   * 過去ファイル取得時間の範囲を70分にしている理由
   * テーブル編集系共通定義マスタの最新値ファイル用欠測判定時間が定義されているため今回は定義にあわせて70分に指定
  */
  const endTime = new Date(startTime.getTime() - 70 * 60000);
  
  while (startTime >= endTime) {
    let afterformatAppTime = Util.getDateConnectPath(startTime);
    let path = `${afterformatAppTime}/${cameraId}.jpg`
    const result = await getUrl(path, itmkndCd, originProduction, historyCamUrl, testEnvironmentsIp);
    
    if (result.status === 200) {
      if (location.origin === originProduction) {
        return historyCamUrl + path;
      } else if(location.origin.includes('localhost')) {
        return location.origin + `/kawabou/file/files/master/obs/cam/history/` + path;
      } else {
        // 試験環境
        return `http://` + testEnvironmentsIp + `/cam/history/` + path;
      }
    }
    startTime = new Date(startTime.getTime() - minutesStep * 60000);
  }

  return noImageUrl;
}

function roundTimeToInterval(appTime, sysId) {
  let newDate = appTime;
  const minutes = appTime.getMinutes();
  let roundedMinutes;

  if (sysId === 1) {
    roundedMinutes = Math.floor(minutes / 5) * 5;
  } else {
    roundedMinutes = Math.floor(minutes / 10) * 10;
  }
  newDate.setMinutes(roundedMinutes);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
}

function convertTimestampToDateString(dateTimeStr) {
  const year = dateTimeStr.substring(0, 4);
  const month = dateTimeStr.substring(4, 6);
  const day = dateTimeStr.substring(6, 8);
  const hours = dateTimeStr.substring(8, 10);
  const minutes = dateTimeStr.substring(10, 12);
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

  return formattedDateTime;
}
 
function replaceJpgWithJson(imageHistoryUrl) {
  if (imageHistoryUrl && Array.isArray(imageHistoryUrl)) {
    const jsonHistoryUrlArray = imageHistoryUrl.map(url => url.replace('.jpg', '.json'));
    return jsonHistoryUrlArray;
  } else if(imageHistoryUrl) {
    const jsonHistoryUrl = imageHistoryUrl.replace('.jpg','.json');
    return jsonHistoryUrl;
  }
}

async function getDetailJson(arrayHistoryJsons) {
  let getArrayHistoryJson = [];
  for (let index = 0; index < arrayHistoryJsons.length; index++) {
    let path = arrayHistoryJsons[index];
    const result = await getJsonUrl(path);
    if (result.status === 200) {
      const detailTimeData = updateLatestScamTime(result);
      if (detailTimeData === null) {
        getArrayHistoryJson.push("");
      } else {
        getArrayHistoryJson.push(detailTimeData);
      }
    } else {
      getArrayHistoryJson.push("");
    }

    // 1つ目の値がなければ以降の処理不要
    if (getArrayHistoryJson[0] === "") {
      return getArrayHistoryJson;
    }
  }

  return getArrayHistoryJson;
}

async function setArrayTimeData(arrayTime, type) {
  if (type === "detailTime") {
    // 個別詳細画面日時
    let detailTIme = [];
    detailTIme = await getDetailJson(arrayTime);
    return detailTIme;
  } else {
    // 観測日時
    let dateTime = [];
    // スライダーバー時間表示用
    let sliderLabelTime = [];
    for (let index = 0; index < arrayTime.length; index++) {
      const time = arrayTime[index];
      dateTime.push(Util.toDate(time));
      if (time === arrayTime[0] || time == arrayTime[arrayTime.length - 1]) {
        let result = time.split(' ');
        sliderLabelTime.push(result[1]);
      } else {
        sliderLabelTime.push("");
      }
    }

    return sliderLabelTime;
  }
}

/**
 * 個別観測所日時（任意のタイミングで時間取得）
 * @param appTime 観測日時
 * @param isCurrent 観測日時（現在/過去）
 * @param radarType レーダータイプ
 * @param radarXrainDate XRain
 * @param radarCbandDate Cバンド
 */
function getBaseTime(appTime, isCurrent, radarType, radarXrainDate, radarCbandDate) {
  let returnTime = appTime;
  if (isCurrent) {
    if (radarType == "xrain") {
      returnTime = radarXrainDate;
    } else {
      returnTime = radarCbandDate;
    }
  }
  return returnTime;
}